msgid ""
msgstr ""
"POT-Creation-Date: 2022-09-21 18:47+0530\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
msgid "Unrealized Base PnL"
msgstr "Unrealized Base PnL"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Wallet not connected"
msgstr "Wallet not connected"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Pear Protocol"
msgstr "Pear Protocol"

#: src/components/RatingToast/RatingToast.tsx
msgid "Not likely"
msgstr "Not likely"

#: src/pages/Home/Home.tsx
msgid "Available on your preferred network"
msgstr "Available on your preferred network"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Trading Protocol"
msgstr "Decentralized Trading Protocol"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/ClaimModal.tsx
msgid "Claim submitted!"
msgstr "Claim submitted!"

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "Claims are disabled"
msgstr "Claims are disabled"

#: src/components/AddressDropdown/AddressDropdown.tsx
msgid "Disconnect"
msgstr "Disconnect"

#: src/components/Glp/GlpSwap.jsx
msgid "Buy GM tokens before the epoch resets in {0} to be eligible for the Bonus Rebate. Alternatively, wait for the epoch to reset to redeem GLP and buy GM within the same epoch."
msgstr "Buy GM tokens before the epoch resets in {0} to be eligible for the Bonus Rebate. Alternatively, wait for the epoch to reset to redeem GLP and buy GM within the same epoch."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
#: src/components/Synthetics/MarketsList/MarketsList.tsx
#: src/components/Synthetics/TVChart/Chart.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "PRICE"
msgstr "PRICE"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "receive"
msgstr "receive"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Referrals Dashboard"
msgstr "GMX Referrals Dashboard"

#: src/pages/Stake/ClaimModal.tsx
msgid "Stake GMX Rewards"
msgstr "Stake GMX Rewards"

#: src/components/Glp/SwapErrorModal.tsx
msgid "There is not enough liquidity in a single token for your size. Please check the Save on Fees section and consider splitting your order into several different ones"
msgstr "There is not enough liquidity in a single token for your size. Please check the Save on Fees section and consider splitting your order into several different ones"

#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
msgid "Decrease the withdraw size to match the max. <0>Read more</0>.<1/><2/><3>Set max withdrawal</3>"
msgstr "Decrease the withdraw size to match the max. <0>Read more</0>.<1/><2/><3>Set max withdrawal</3>"

#: src/domain/synthetics/userFeedback/utils.ts
msgid "What would have made your rating a 9 or 10?"
msgstr "What would have made your rating a 9 or 10?"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "{existingTriggerOrderLength, plural, one {You have an active trigger order that might execute immediately after you open this position. Please cancel the order or accept the confirmation to continue.} other {You have # active trigger orders that might execute immediately after you open this position. Please cancel the orders or accept the confirmation to continue.}}"
msgstr "{existingTriggerOrderLength, plural, one {You have an active trigger order that might execute immediately after you open this position. Please cancel the order or accept the confirmation to continue.} other {You have # active trigger orders that might execute immediately after you open this position. Please cancel the orders or accept the confirmation to continue.}}"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Show debug values"
msgstr "Show debug values"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Stop Loss"
msgstr "Execute Stop Loss"

#: src/pages/Exchange/Exchange.tsx
msgid "Could not decrease {tokenSymbol} {longOrShortText} within the allowed slippage, you can adjust the allowed slippage in the settings on the top right of the page."
msgstr "Could not decrease {tokenSymbol} {longOrShortText} within the allowed slippage, you can adjust the allowed slippage in the settings on the top right of the page."

#: src/components/ModalViews/RedirectModal.tsx
msgid "Agree"
msgstr "Agree"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "BonsaiDAO"
msgstr "BonsaiDAO"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Approval signed"
msgstr "Approval signed"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "Daily Loss"
msgstr "Daily Loss"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "earns fees from providing liquidity to multiple GMX V2 markets"
msgstr "earns fees from providing liquidity to multiple GMX V2 markets"

#: src/pages/Home/Home.tsx
msgid "GMX is currently live on Arbitrum and Avalanche."
msgstr "GMX is currently live on Arbitrum and Avalanche."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create TWAP Swap"
msgstr "Create TWAP Swap"

#: src/components/Glp/GlpSwap.jsx
msgid "Max Pool Capacity"
msgstr "Max Pool Capacity"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Optimizer on Avalanche"
msgstr "Yield Optimizer on Avalanche"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Arbitrum"
msgstr "Arbitrum"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/pages/Exchange/Exchange.tsx
msgid "Orders ({0})"
msgstr "Orders ({0})"

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "You have not deposited any tokens for vesting."
msgstr "You have not deposited any tokens for vesting."

#: src/domain/synthetics/positions/utils.ts
msgid "stop loss"
msgstr "stop loss"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Type"
msgstr "Type"

#: src/components/Exchange/PositionSeller.jsx
msgid "Order submitted!"
msgstr "Order submitted!"

#: src/domain/synthetics/orders/setAutoCancelOrdersTxn.ts
msgid "Updating {updateOrdersCount} TP/SL order(s)"
msgstr "Updating {updateOrdersCount} TP/SL order(s)"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "RabbitHole"
msgstr "RabbitHole"

#: src/pages/Dashboard/WeightText.tsx
msgid "{0} is above its target weight.<0/><1/>Get lower fees to <2>swap</2> tokens for {1}."
msgstr "{0} is above its target weight.<0/><1/>Get lower fees to <2>swap</2> tokens for {1}."

#: src/domain/synthetics/markets/createGlvWithdrawalTxn.ts
#: src/domain/synthetics/markets/createWithdrawalTxn.ts
msgid "Withdrawal error."
msgstr "Withdrawal error."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Limit"
msgstr "Failed Limit"

#: src/components/Synthetics/MarketStats/MarketGraphs.tsx
msgid "Performance"
msgstr "Performance"

#: src/components/Synthetics/GmList/PerformanceLabel.tsx
msgid "Annualized return of the pool or vault over the selected period, compared to a benchmark that follows Uniswap V2–style rebalancing of the backing tokens in the same GM pool or GLV vault.<0/><1/>Annualized figures based on short periods may be distorted by short-term volatility.<2/><3/>For detailed stats and comparisons, see the <4>GMX V2 LP Dashboard</4>."
msgstr "Annualized return of the pool or vault over the selected period, compared to a benchmark that follows Uniswap V2–style rebalancing of the backing tokens in the same GM pool or GLV vault.<0/><1/>Annualized figures based on short periods may be distorted by short-term volatility.<2/><3/>For detailed stats and comparisons, see the <4>GMX V2 LP Dashboard</4>."

#: src/pages/Home/Home.tsx
msgid "Decentralized<0/>Perpetual Exchange"
msgstr "Decentralized<0/>Perpetual Exchange"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Current Reserved"
msgstr "Current Reserved"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V2 Arbitrum"
msgstr "V2 Arbitrum"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "EIP-4844, 13-20 Mar"
msgstr "EIP-4844, 13-20 Mar"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "Total size"
msgstr "Total size"

#: src/components/OneClickPromoBanner/OneClickPromoBanner.tsx
msgid "Try Express Trading"
msgstr "Try Express Trading"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "Note that there may be rare cases where the order cannot be executed, for example, if the chain is down and no oracle reports are produced or if there is not enough available liquidity."
msgstr "Note that there may be rare cases where the order cannot be executed, for example, if the chain is down and no oracle reports are produced or if there is not enough available liquidity."

#: src/components/ExpressTradingOutOfGasBanner.ts/ExpressTradingOutOfGasBanner.tsx
#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Buy {gasPaymentTokensText}"
msgstr "Buy {gasPaymentTokensText}"

#: src/components/ToastifyDebug/ToastifyDebug.tsx
msgid "Show error"
msgstr "Show error"

#: src/components/Exchange/SwapBox.jsx
msgid "Trigger orders, increasing positions (market or limit), adding collateral, and swapping on GMX V1 are now disabled. You can still close existing positions using market orders."
msgstr "Trigger orders, increasing positions (market or limit), adding collateral, and swapping on GMX V1 are now disabled. You can still close existing positions using market orders."

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "{0} can be used to buy GM for this market up to the specified buying caps."
msgstr "{0} can be used to buy GM for this market up to the specified buying caps."

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High TWAP Network Fee"
msgstr "High TWAP Network Fee"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Market Swap"
msgstr "Execute Market Swap"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
#~ msgid "Can I claim more than once?"
#~ msgstr "Can I claim more than once?"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Deposit submitted!"
msgstr "Deposit submitted!"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/Dashboard/StatsCard.tsx
msgid "Volume"
msgstr "Volume"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel Limit Swap"
msgstr "Cancel Limit Swap"

#: src/pages/LeaderboardPage/components/CompetitionCountdown.tsx
msgid "{seconds}s"
msgstr "{seconds}s"

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "{0} Required"
msgstr "{0} Required"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
#~ msgid "GLV is similar in composition to GLP. Users can sell it, but holding it will earn them incentives"
#~ msgstr "GLV is similar in composition to GLP. Users can sell it, but holding it will earn them incentives"

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "No incentives distribution history yet."
msgstr "No incentives distribution history yet."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
#: src/pages/Dashboard/StatsCard.tsx
msgid "Fees"
msgstr "Fees"

#: src/lib/contracts/callContract.tsx
msgid "View status."
msgstr "View status."

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "Buyable"
msgstr "Buyable"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "TWAP Number of Parts"
msgstr "TWAP Number of Parts"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Net Value: Initial Collateral + PnL - Borrow Fee - Negative Funding Fee - Close Fee - UI Fee"
msgstr "Net Value: Initial Collateral + PnL - Borrow Fee - Negative Funding Fee - Close Fee - UI Fee"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "The spread is > 1%, please ensure the trade details are acceptable before confirming"
msgstr "The spread is > 1%, please ensure the trade details are acceptable before confirming"

#: src/components/Glp/GlpSwap.jsx
msgid "Max pool capacity reached for {0}<0/><1/>Please mint GLP using another token"
msgstr "Max pool capacity reached for {0}<0/><1/>Please mint GLP using another token"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Enter a value"
msgstr "Enter a value"

#: src/pages/NftWallet/NftWallet.jsx
msgid "Enter NFT Address"
msgstr "Enter NFT Address"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "AVAILABLE"
msgstr "AVAILABLE"

#: src/components/NpsModal/NpsModal.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "@username"
msgstr "@username"

#: src/components/TVChartContainer/constants.ts
msgid "Stop Market - Short Inc."
msgstr "Stop Market - Short Inc."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Take Profit"
msgstr "Failed Take Profit"

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Confirm Settle"
msgstr "Confirm Settle"

#: src/domain/synthetics/markets/createDepositTxn.ts
#: src/domain/synthetics/markets/createGlvDepositTxn.ts
msgid "Deposit error."
msgstr "Deposit error."

#: src/pages/Exchange/Exchange.tsx
msgid "Increased {tokenSymbol} {longOrShortText}, +{0} USD."
msgstr "Increased {tokenSymbol} {longOrShortText}, +{0} USD."

#: src/domain/synthetics/orders/setAutoCancelOrdersTxn.ts
msgid "{updateOrdersCount} TP/SL order(s) updated"
msgstr "{updateOrdersCount} TP/SL order(s) updated"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Stop market price above mark price"
msgstr "Stop market price above mark price"

#: src/components/Errors/errorToasts.tsx
msgid "Transaction failed due to execution fee validation. <0>View</0>.<1/><2/>{suggestText}"
msgstr "Transaction failed due to execution fee validation. <0>View</0>.<1/><2/>{suggestText}"

#: src/pages/Stake/StakeModal.tsx
msgid "Pending {stakingTokenSymbol} approval"
msgstr "Pending {stakingTokenSymbol} approval"

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Open Positions"
msgstr "Open Positions"

#: src/pages/Stake/UnstakeModal.tsx
msgid "Unstaking..."
msgstr "Unstaking..."

#: src/components/Exchange/SwapBox.jsx
msgid "You can change the \"Collateral In\" token above to find lower fees"
msgstr "You can change the \"Collateral In\" token above to find lower fees"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "The sellable cap for the pool GM: {0} [{1}]  has been reached, as the tokens are reserved by traders. Please choose a different pool, reduce the sell size, or split your withdrawal from multiple pools."
msgstr "The sellable cap for the pool GM: {0} [{1}]  has been reached, as the tokens are reserved by traders. Please choose a different pool, reduce the sell size, or split your withdrawal from multiple pools."

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "Swap TWAP: Swap tokens in evenly distributed parts over a specified time."
msgstr "Swap TWAP: Swap tokens in evenly distributed parts over a specified time."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max {0} short exceeded"
msgstr "Max {0} short exceeded"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient GM balance"
msgstr "Insufficient GM balance"

#: src/components/Synthetics/MarketStats/components/MarketDescription.tsx
#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "This token is a vault of automatically rebalanced GM tokens that accrue fees from leverage trading and swaps from the included markets. Backed by {0} and {1}."
msgstr "This token is a vault of automatically rebalanced GM tokens that accrue fees from leverage trading and swaps from the included markets. Backed by {0} and {1}."

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max pool USD exceeded"
msgstr "Max pool USD exceeded"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Limit price below mark price"
msgstr "Limit price below mark price"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "sell"
msgstr "sell"

#: src/components/Exchange/SwapBox.jsx
#: src/config/events.tsx
msgid "Please migrate your positions to GMX V2."
msgstr "Please migrate your positions to GMX V2."

#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/Exchange/Exchange.tsx
msgid "Positions"
msgstr "Positions"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "{0} can not be sent to smart contract addresses. Select another token."
msgstr "{0} can not be sent to smart contract addresses. Select another token."

#: src/domain/synthetics/markets/claimFundingFeesTxn.ts
msgid "Funding Claimed"
msgstr "Funding Claimed"

#: src/components/Errors/errorToasts.tsx
msgid "Transaction failed due to RPC error.<0/><1/>Please enable <2>Express trading</2> under settings, which should offer a better experience."
msgstr "Transaction failed due to RPC error.<0/><1/>Please enable <2>Express trading</2> under settings, which should offer a better experience."

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Referral code added!"
msgstr "Referral code added!"

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "SELLABLE"
msgstr "SELLABLE"

#: src/pages/Dashboard/StatsCard.tsx
msgid "Treasury"
msgstr "Treasury"

#: src/components/Glp/SwapErrorModal.tsx
msgid "Swap {0} to {1} on 1inch"
msgstr "Swap {0} to {1} on 1inch"

#: src/components/MarketSelector/GmPoolsSelectorForGlvMarket.tsx
#: src/components/MarketSelector/PoolSelector.tsx
#: src/components/Synthetics/GmList/GmList.tsx
#: src/components/Synthetics/GmList/GmList.tsx
#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "No pools matched."
msgstr "No pools matched."

#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Orders"
msgstr "Orders"

#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "Increased {positionText}, +{0}"
msgstr "Increased {positionText}, +{0}"

#: src/pages/Stake/Stake.tsx
msgid "Claim and view your incentives, airdrops, and prizes"
msgstr "Claim and view your incentives, airdrops, and prizes"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Funding Fee"
msgstr "Funding Fee"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "Insufficient liquidity in the {0} market pool. Select a different pool for this market. Choosing a different pool would open a new position different from the existing one.<0><1>Switch to {1} market pool</1>.</0>"
msgstr "Insufficient liquidity in the {0} market pool. Select a different pool for this market. Choosing a different pool would open a new position different from the existing one.<0><1>Switch to {1} market pool</1>.</0>"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Confirm Limit Order"
msgstr "Confirm Limit Order"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
msgid "Confirm Withdraw"
msgstr "Confirm Withdraw"

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Realized PnL"
msgstr "Realized PnL"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX V2 Data Analytics within Telegram"
msgstr "GMX V2 Data Analytics within Telegram"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "You can transfer ETH from other networks to Arbitrum using any of the below options:"
msgstr "You can transfer ETH from other networks to Arbitrum using any of the below options:"

#: src/components/Exchange/SwapBox.jsx
msgid "Created limit order for {0} {1}: {2} USD!"
msgstr "Created limit order for {0} {1}: {2} USD!"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Invalid token fromToken: \"{0}\" toToken: \"{toTokenAddress}\""
msgstr "Invalid token fromToken: \"{0}\" toToken: \"{toTokenAddress}\""

#: src/components/Header/AppHeaderLinks.tsx
#: src/pages/Dashboard/DashboardV2.tsx
#: src/pages/Dashboard/StatsCard.tsx
msgid "Stats"
msgstr "Stats"

#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimCollateralHistoryRow.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Claim Price Impact Rebates"
msgstr "Claim Price Impact Rebates"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Max Capacity"
msgstr "Max Capacity"

#: src/domain/synthetics/orders/utils.tsx
msgid "Market Swap"
msgstr "Market Swap"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "A $500,000 GLV pool (funded by DAO funds) rewards long-term holders: If you keep your distributed GLV for at least 3 months (without selling or transferring), you'll receive a pro rata share."
msgstr "A $500,000 GLV pool (funded by DAO funds) rewards long-term holders: If you keep your distributed GLV for at least 3 months (without selling or transferring), you'll receive a pro rata share."

#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "Trade History"
msgstr "Trade History"

#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Tabs/NestedTab.tsx
msgid "More"
msgstr "More"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Since your position's collateral is in {symbol}, with an initial value higher than the {indexName} short position size, the collateral value will increase to cover any negative PnL, so there is no liquidation price."
msgstr "Since your position's collateral is in {symbol}, with an initial value higher than the {indexName} short position size, the collateral value will increase to cover any negative PnL, so there is no liquidation price."

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "{actionsCount, plural, one {Order} other {# Orders}}"
msgstr "{actionsCount, plural, one {Order} other {# Orders}}"

#: src/config/bridging.tsx
msgid "Buy APE on Arbitrum with <0>Camelot</0>."
msgstr "Buy APE on Arbitrum with <0>Camelot</0>."

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "You will need to be on this page to accept the transfer, <0>click here</0> to copy the link to this page if needed."
msgstr "You will need to be on this page to accept the transfer, <0>click here</0> to copy the link to this page if needed."

#: src/components/ModalViews/RedirectModal.tsx
msgid "Don't show this message again for 30 days."
msgstr "Don't show this message again for 30 days."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "hide"
msgstr "hide"

#: src/pages/Dashboard/GmxCard.tsx
msgid "in liquidity"
msgstr "in liquidity"

#: src/components/Exchange/SwapBox.jsx
msgid "Exit Price"
msgstr "Exit Price"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Enter Price"
msgstr "Enter Price"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Rebates on V2"
msgstr "Rebates on V2"

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Incentives are airdropped weekly."
msgstr "Incentives are airdropped weekly."

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
msgid "Acceptable Price Impact"
msgstr "Acceptable Price Impact"

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Add to Metamask"
msgstr "Add to Metamask"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Insufficient staked tokens"
msgstr "Insufficient staked tokens"

#: src/components/NpsModal/NpsModal.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Telegram contact (optional)"
msgstr "Telegram contact (optional)"

#: src/domain/synthetics/orders/useDisabledCancelMarketOrderMessage.ts
msgid "Market order will be cancellable in {minutesText}{seconds}s."
msgstr "Market order will be cancellable in {minutesText}{seconds}s."

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "About GLP Incident"
msgstr "About GLP Incident"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "providing liquidity"
msgstr "providing liquidity"

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "Tap [Create Wallet] to start using your Web3 Wallet."
msgstr "Tap [Create Wallet] to start using your Web3 Wallet."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Plutus"
msgstr "Plutus"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Pairs Trading"
msgstr "Pairs Trading"

#: src/pages/Actions/ActionsV1/ActionsV1.tsx
msgid "GMX {versionName} {networkName} actions for all accounts."
msgstr "GMX {versionName} {networkName} actions for all accounts."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Cancel submitted"
msgstr "Cancel submitted"

#: src/components/Exchange/PositionSeller.jsx
msgid "Please uncheck \"Keep Leverage\", or close a larger position amount."
msgstr "Please uncheck \"Keep Leverage\", or close a larger position amount."

#: src/components/Exchange/PositionDropdown.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Edit Collateral"
msgstr "Edit Collateral"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Long Stop Market: {0} a short position when the price is below the trigger price."
msgstr "{typeString} Long Stop Market: {0} a short position when the price is below the trigger price."

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Limit price above mark price"
msgstr "Limit price above mark price"

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "Create or Import a Wallet"
msgstr "Create or Import a Wallet"

#: src/pages/Stake/ClaimModal.tsx
msgid "Stake esGMX Rewards"
msgstr "Stake esGMX Rewards"

#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "Networks and Settings"
msgstr "Networks and Settings"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Max network fee buffer precision is 0.01%"
msgstr "Max network fee buffer precision is 0.01%"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Max. Leverage Exceeded"
msgstr "Max. Leverage Exceeded"

#: src/components/SearchInput/SearchInput.tsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "Search Token"
msgstr "Search Token"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DeltaPrime"
msgstr "DeltaPrime"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX using Decentralized Exchange Aggregators:"
msgstr "Buy GMX using Decentralized Exchange Aggregators:"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Min. Required Collateral"
msgstr "Min. Required Collateral"

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "{0} tokens have been converted to GMX from the {1} esGMX deposited for vesting."
msgstr "{0} tokens have been converted to GMX from the {1} esGMX deposited for vesting."

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Rank"
msgstr "Rank"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Average position size."
msgstr "Average position size."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/TradeHistoryRow.tsx
msgid "{0} <0/><1> to </1>{1} <2/>"
msgstr "{0} <0/><1> to </1>{1} <2/>"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Short Market: {0} a short position at the current price."
msgstr "{typeString} Short Market: {0} a short position at the current price."

#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
msgid "Claim {totalUsd}"
msgstr "Claim {totalUsd}"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Yak Swap"
msgstr "Yield Yak Swap"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Vaultka"
msgstr "Vaultka"

#: src/components/Synthetics/AccruedPositionPriceImpactRebateModal/AccruedPositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "MARKET"
msgstr "MARKET"

#: src/domain/synthetics/userFeedback/utils.ts
msgid "What did you like the most about our service?"
msgstr "What did you like the most about our service?"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Paraswap"
msgstr "Paraswap"

#: src/components/TVChartContainer/constants.ts
msgid "TP - Long Dec."
msgstr "TP - Long Dec."

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Claimable Rebates"
msgstr "Claimable Rebates"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max pool amount reached"
msgstr "Max pool amount reached"

#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
msgid "Market Orders"
msgstr "Market Orders"

#: src/domain/synthetics/userFeedback/utils.ts
msgid "How can we address your concerns and improve your experience?"
msgstr "How can we address your concerns and improve your experience?"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Total value locked takes into account:"
msgstr "Total value locked takes into account:"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sending buy request"
msgstr "Sending buy request"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "You can check your claim history <0>here</0>."
msgstr "You can check your claim history <0>here</0>."

#: src/components/Synthetics/Claims/ClaimableCard.tsx
msgid "Claimable positive funding fees.<0/><1/>They become available after modifying the position by increasing or decreasing it, depositing or withdrawing collateral, or settling the fees using the \"Settle\" button."
msgstr "Claimable positive funding fees.<0/><1/>They become available after modifying the position by increasing or decreasing it, depositing or withdrawing collateral, or settling the fees using the \"Settle\" button."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "Acceptable price for the order."
msgstr "Acceptable price for the order."

#: src/components/TVChartContainer/DynamicLine.tsx
msgid "The order could not be updated"
msgstr "The order could not be updated"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Cross-chain one-click deposits into GM"
msgstr "Cross-chain one-click deposits into GM"

#: src/pages/Home/Home.tsx
msgid "Open positions through a simple swap interface. Conveniently swap from any supported asset into the position of your choice."
msgstr "Open positions through a simple swap interface. Conveniently swap from any supported asset into the position of your choice."

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
#~ msgid "Incentives Distribution History"
#~ msgstr "Incentives Distribution History"

#: src/components/BuyInputSection/BuyInputSection.tsx
#: src/components/BuyInputSection/BuyInputSection.tsx
#: src/components/InputSection/InputSection.jsx
#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "MAX"
msgstr "MAX"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Invalid slippage value"
msgstr "Invalid slippage value"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
msgid "{0} price"
msgstr "{0} price"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max {0} buyable amount exceeded"
msgstr "Max {0} buyable amount exceeded"

#: src/components/Glp/GlpSwap.jsx
msgid "Sell submitted!"
msgstr "Sell submitted!"

#: src/components/Exchange/PositionSeller.jsx
msgid "Closing..."
msgstr "Closing..."

#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Code already taken"
msgstr "Code already taken"

#: src/components/TVChartContainer/constants.ts
msgid "SL - Short Dec."
msgstr "SL - Short Dec."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Slippage should be less than -5%"
msgstr "Slippage should be less than -5%"

#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
msgid "Acceptable Swap Impact"
msgstr "Acceptable Swap Impact"

#: src/components/NpsModal/NpsModal.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Leave your Telegram if you’re okay with being contacted for a quick follow-up"
msgstr "Leave your Telegram if you’re okay with being contacted for a quick follow-up"

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Unrealized PnL"
msgstr "Unrealized PnL"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "This value may be higher on other websites due to the collateral of positions being included in the calculation."
msgstr "This value may be higher on other websites due to the collateral of positions being included in the calculation."

#: src/components/Referrals/ClaimAffiliatesModal/ClaimAffiliatesModal.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Rewards"
msgstr "Rewards"

#: src/components/Exchange/ExchangeTVChart.jsx
msgid "Liq. {0} {longOrShortText}"
msgstr "Liq. {0} {longOrShortText}"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/GmShiftBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Pay"
msgstr "Pay"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Governance Page"
msgstr "GMX Governance Page"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Money Market"
msgstr "Decentralized Money Market"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Stop Price"
msgstr "Stop Price"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "using GLV and GM tokens. Buying or staking GMX, or using referrals, is not supported at this time."
msgstr "using GLV and GM tokens. Buying or staking GMX, or using referrals, is not supported at this time."

#: src/pages/AccountDashboard/HistoricalLists.tsx
msgid "Positions ({positionsCount})"
msgstr "Positions ({positionsCount})"

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "<0>Trade GMX</0>"
msgstr "<0>Trade GMX</0>"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "As network fees have increased, an additional network fee is needed."
msgstr "As network fees have increased, an additional network fee is needed."

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Deposited"
msgstr "Deposited"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "Swap Limit: Swap tokens when the trigger price is reached."
msgstr "Swap Limit: Swap tokens when the trigger price is reached."

#: src/components/Glp/GlpSwap.jsx
msgid "{0} GLP have been reserved for vesting."
msgstr "{0} GLP have been reserved for vesting."

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
msgid "Selling {symbol}..."
msgstr "Selling {symbol}..."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Buy with {0}"
msgstr "Buy with {0}"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Asset Management"
msgstr "Asset Management"

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Adding..."
msgstr "Adding..."

#: src/pages/Actions/SyntheticsActions.tsx
msgid "GMX {VERSION_NAME} {networkName} actions for all accounts."
msgstr "GMX {VERSION_NAME} {networkName} actions for all accounts."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "There may not be sufficient liquidity to execute your order when the price conditions are met"
msgstr "There may not be sufficient liquidity to execute your order when the price conditions are met"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "GMX uses TradingView to provide real-time cryptocurrency charts, so you can easily follow <0>BTCUSD</0> price in real-time, along with other currency pair rates. The interactive charts offer advanced tools and a user-friendly interface for easier market analysis and decision-making."
msgstr "GMX uses TradingView to provide real-time cryptocurrency charts, so you can easily follow <0>BTCUSD</0> price in real-time, along with other currency pair rates. The interactive charts offer advanced tools and a user-friendly interface for easier market analysis and decision-making."

#: src/components/Glp/SwapErrorModal.tsx
msgid "Swap on 1inch"
msgstr "Swap on 1inch"

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Open {0} in Coingecko"
msgstr "Open {0} in Coingecko"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
msgid "Buy {operationTokenSymbol}"
msgstr "Buy {operationTokenSymbol}"

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Buy GM: {0}"
msgstr "Buy GM: {0}"

#: src/pages/Dashboard/GlpCard.tsx
#: src/pages/Dashboard/GmCard.tsx
#: src/pages/Dashboard/GmxCard.tsx
msgid "Market Cap"
msgstr "Market Cap"

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "{positionName} Fees settled"
msgstr "{positionName} Fees settled"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Average leverage used."
msgstr "Average leverage used."

#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/TotalRewardsCard.tsx
msgid "Escrowed GMX"
msgstr "Escrowed GMX"

#: src/components/InterviewModal/InterviewModal.tsx
msgid "We want your insights to help improve GMX for Liquidity Providers. For security reasons, we won't contact you first. Please send the message \"I’m a Liquidity Provider\" to our official telegram account:"
msgstr "We want your insights to help improve GMX for Liquidity Providers. For security reasons, we won't contact you first. Please send the message \"I’m a Liquidity Provider\" to our official telegram account:"

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
msgid "Insufficient Liquidity"
msgstr "Insufficient Liquidity"

#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
msgid "The max network fee is overestimated, including by the buffer set under settings. Upon execution, any excess network fee is sent back to your account."
msgstr "The max network fee is overestimated, including by the buffer set under settings. Upon execution, any excess network fee is sent back to your account."

#: src/components/Synthetics/GmList/GmListItem.tsx
#: src/pages/PoolsDetails/PoolsDetailsHeader.tsx
msgid "TVL (Supply)"
msgstr "TVL (Supply)"

#: src/components/ModalViews/RedirectModal.tsx
msgid "Alternative links can be found in the <0>docs</0>.<1/><2/>By clicking Agree you accept the <3>T&Cs</3> and <4>Referral T&Cs</4>.<5/><6/>"
msgstr "Alternative links can be found in the <0>docs</0>.<1/><2/>By clicking Agree you accept the <3>T&Cs</3> and <4>Referral T&Cs</4>.<5/><6/>"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "All Time"
msgstr "All Time"

#: src/components/Referrals/referralsHelper.js
msgid "The referral code can't be more than {MAX_REFERRAL_CODE_LENGTH} characters."
msgstr "The referral code can't be more than {MAX_REFERRAL_CODE_LENGTH} characters."

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
msgid "Trigger Orders"
msgstr "Trigger Orders"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX fundamentals"
msgstr "GMX fundamentals"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Referral Code"
msgstr "Referral Code"

#: src/components/Footer/constants.ts
msgid "Charts by TradingView"
msgstr "Charts by TradingView"

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "GMX Staked Rewards"
msgstr "GMX Staked Rewards"

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Staked Tokens"
msgstr "Staked Tokens"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Beefy"
msgstr "Beefy"

#: src/pages/Stake/UnstakeModal.tsx
msgid "Unstake completed!"
msgstr "Unstake completed!"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/MinReceiveRow.tsx
msgid "Min. Receive"
msgstr "Min. Receive"

#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
msgid "Estimated Fee Refund"
msgstr "Estimated Fee Refund"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Swaps"
msgstr "GMX Swaps"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Deactivating..."
msgstr "Deactivating..."

#: src/components/Header/HomeHeaderLinks.tsx
msgid "Protocol"
msgstr "Protocol"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Overview"
msgstr "Overview"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Allow all my tokens to be transferred to a new account"
msgstr "Allow all my tokens to be transferred to a new account"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Avalanche Max. APY: {0}"
msgstr "Avalanche Max. APY: {0}"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Collateral"
msgstr "Collateral"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel Stop Market"
msgstr "Cancel Stop Market"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Limit"
msgstr "Execute Limit"

#: src/components/AprInfo/AprInfo.tsx
msgid "Base APY"
msgstr "Base APY"

#: src/components/TokenCard/TokenCard.tsx
msgid "GMX V1 markets are disabled. GLP is being phased out and no longer supports GMX V1 markets."
msgstr "GMX V1 markets are disabled. GLP is being phased out and no longer supports GMX V1 markets."

#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
msgid "WARNING: This position has a low amount of collateral after deducting borrowing fees, deposit more collateral to reduce the position's liquidation risk."
msgstr "WARNING: This position has a low amount of collateral after deducting borrowing fees, deposit more collateral to reduce the position's liquidation risk."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/pages/BuyGlp/BuyGlp.jsx
#: src/pages/Stake/GlpCard.tsx
msgid "Sell GLP"
msgstr "Sell GLP"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Since your position's collateral is in {symbol}, with an initial value higher than the {indexName} long position size, the collateral value will cover any negative PnL, so there is no liquidation price."
msgstr "Since your position's collateral is in {symbol}, with an initial value higher than the {indexName} long position size, the collateral value will cover any negative PnL, so there is no liquidation price."

#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "Short Liq."
msgstr "Short Liq."

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "One-Click Trading is disabled. Time limit expired."
msgstr "One-Click Trading is disabled. Time limit expired."

#: src/components/Synthetics/MarketStats/components/MarketDescription.tsx
msgid "This token automatically accrues fees from leverage trading and swaps for the {0} market. It is also exposed to {composition} as per the composition displayed."
msgstr "This token automatically accrues fees from leverage trading and swaps for the {0} market. It is also exposed to {composition} as per the composition displayed."

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "Buy Fee"
msgstr "Buy Fee"

#: src/pages/Dashboard/DashboardPageTitle.tsx
msgid "Tokens"
msgstr "Tokens"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Request Withdraw"
msgstr "Request Withdraw"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "1inch"
msgstr "1inch"

#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "Composition"
msgstr "Composition"

#: src/components/ToastifyDebug/ToastifyDebug.tsx
msgid "Copied"
msgstr "Copied"

#: src/components/Exchange/PositionEditor.jsx
msgid "Requested deposit of {0} {1} into {2} {longOrShortText}."
msgstr "Requested deposit of {0} {1} into {2} {longOrShortText}."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Invalid TWAP number of parts value"
msgstr "Invalid TWAP number of parts value"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Invalid network fee buffer value"
msgstr "Invalid network fee buffer value"

#: src/components/Exchange/TradeHistory.jsx
msgid "Request deposit into {0} {longOrShortText}"
msgstr "Request deposit into {0} {longOrShortText}"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "0x"
msgstr "0x"

#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "FUNDING FEE"
msgstr "FUNDING FEE"

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Markets"
msgstr "Markets"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Real-time rants about GMX Trades"
msgstr "Real-time rants about GMX Trades"

#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "The total realized and unrealized profit and loss for the period, considering price impact and fees but excluding swap fees."
msgstr "The total realized and unrealized profit and loss for the period, considering price impact and fees but excluding swap fees."

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Volume on V2"
msgstr "Volume on V2"

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "Show less"
msgstr "Show less"

#: src/pages/Stake/Vesting.tsx
msgid "Vest"
msgstr "Vest"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Total value of tokens in the GLP pools."
msgstr "Total value of tokens in the GLP pools."

#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "Select pool"
msgstr "Select pool"

#: src/pages/Dashboard/MarketsListV1.tsx
msgid "WEIGHT"
msgstr "WEIGHT"

#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "APR"
msgstr "APR"

#: src/pages/NftWallet/NftWallet.jsx
msgid "Tranferring..."
msgstr "Tranferring..."

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Synthetics/MarketStats/MarketGraphs.tsx
#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
#: src/pages/Pools/PoolsTimeRangeFilter.tsx
#: src/pages/Stake/TotalRewardsCard.tsx
msgid "Total"
msgstr "Total"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Swap active: {0}, executed: {1}, cancelled: {2}"
msgstr "Swap active: {0}, executed: {1}, cancelled: {2}"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Buy token on:"
msgstr "Buy token on:"

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Realized Price Impact"
msgstr "Realized Price Impact"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Limit Swap"
msgstr "Failed Limit Swap"

#: src/context/SyntheticsStateContext/selectors/chartSelectors/selectChartLines.tsx
msgid "Liq. {longOrShortText} - {marketIndexName}"
msgstr "Liq. {longOrShortText} - {marketIndexName}"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Longing..."
msgstr "Longing..."

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Total Rebates"
msgstr "Total Rebates"

#: src/components/Synthetics/MarketStats/components/MarketDescription.tsx
msgid "This token automatically accrues fees from leverage trading and swaps for the {0} market. It is also exposed to {1} and {2} as per the composition displayed."
msgstr "This token automatically accrues fees from leverage trading and swaps for the {0} market. It is also exposed to {1} and {2} as per the composition displayed."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Min order: {0}"
msgstr "Min order: {0}"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Wallet is not connected"
msgstr "Wallet is not connected"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "TWAP Swap"
msgstr "TWAP Swap"

#: src/components/TokenCard/TokenCard.tsx
#: src/pages/Dashboard/DashboardPageTitle.tsx
msgid "GM is the liquidity provider token for GMX V2 markets. Accrues 63% of the V2 markets generated fees."
msgstr "GM is the liquidity provider token for GMX V2 markets. Accrues 63% of the V2 markets generated fees."

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
msgid "The current price impact is {0}. Consider adding a buffer of 0.30% to it so the order is more likely to be processed."
msgstr "The current price impact is {0}. Consider adding a buffer of 0.30% to it so the order is more likely to be processed."

#: src/components/ToastifyDebug/ToastifyDebug.tsx
msgid "Hide error"
msgstr "Hide error"

#: src/components/Referrals/TradersStats.tsx
msgid "The owner of this Referral Code has set a custom discount of {currentTierDiscount}% instead of the standard {0}% for Tier {1}."
msgstr "The owner of this Referral Code has set a custom discount of {currentTierDiscount}% instead of the standard {0}% for Tier {1}."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Your wallet, your keys. You sign each transaction on-chain using your own RPC, typically provided by your wallet. Gas payments in ETH."
msgstr "Your wallet, your keys. You sign each transaction on-chain using your own RPC, typically provided by your wallet. Gas payments in ETH."

#: src/components/Exchange/PositionSeller.jsx
msgid "Leftover position below 10 USD"
msgstr "Leftover position below 10 USD"

#: src/pages/Stake/Stake.tsx
msgid "Distributions"
msgstr "Distributions"

#: src/config/bridging.tsx
msgid "Mint tBTC using BTC with <0>Threshold</0>."
msgstr "Mint tBTC using BTC with <0>Threshold</0>."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Swap Price Impact"
msgstr "Swap Price Impact"

#: src/domain/synthetics/userFeedback/utils.ts
msgid "What issues did you encounter that led to your rating?"
msgstr "What issues did you encounter that led to your rating?"

#: src/pages/NftWallet/NftWallet.jsx
msgid "NFT Address"
msgstr "NFT Address"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "{orderText} cancelled."
msgstr "{orderText} cancelled."

#: src/components/TokenCard/TokenCard.tsx
msgid "{avalancheLink} GLV Pools are <0>incentivized{sparkle}.</0>"
msgstr "{avalancheLink} GLV Pools are <0>incentivized{sparkle}.</0>"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Set Max Leverage"
msgstr "Set Max Leverage"

#: src/components/Exchange/PositionSeller.jsx
msgid "Insufficient Available Liquidity to swap to {0}:"
msgstr "Insufficient Available Liquidity to swap to {0}:"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Created At"
msgstr "Created At"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Symbiosis"
msgstr "Symbiosis"

#: src/components/TokenSelector/TokenSelector.tsx
msgid "No tokens matched."
msgstr "No tokens matched."

#: src/components/Exchange/TradeHistory.jsx
msgid "Withdraw {0} USD from {1}{longOrShortText}"
msgstr "Withdraw {0} USD from {1}{longOrShortText}"

#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "{orderTypeLabel} {positionText}, -{0}"
msgstr "{orderTypeLabel} {positionText}, -{0}"

#: src/pages/PageNotFound/PageNotFound.jsx
#: src/pages/PageNotFound/PageNotFound.jsx
msgid "Page not found"
msgstr "Page not found"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram bot for GMX position updates"
msgstr "Telegram bot for GMX position updates"

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "account"
msgstr "account"

#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Keep leverage at {0}"
msgstr "Keep leverage at {0}"

#: src/components/Exchange/SwapBox.jsx
msgid "If you have an existing position, the position will be closed at {0} USD.<0/><1/>This exit price will change with the price of the asset.<2/><3/><4>Read more</4>."
msgstr "If you have an existing position, the position will be closed at {0} USD.<0/><1/>This exit price will change with the price of the asset.<2/><3/><4>Read more</4>."

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "AVAIL. LIQ."
msgstr "AVAIL. LIQ."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Transfer Submitted"
msgstr "Transfer Submitted"

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "One-Click Trading is disabled. Action limit exceeded."
msgstr "One-Click Trading is disabled. Action limit exceeded."

#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
msgid "Shift GM"
msgstr "Shift GM"

#: src/components/Exchange/PositionEditor.jsx
msgid "Requested withdrawal of {0} USD from {1} {longOrShortText}."
msgstr "Requested withdrawal of {0} USD from {1} {longOrShortText}."

#: src/pages/Exchange/Exchange.tsx
msgid "Could not increase {tokenSymbol} {longOrShortText} within the allowed slippage, you can adjust the allowed slippage in the settings on the top right of the page."
msgstr "Could not increase {tokenSymbol} {longOrShortText} within the allowed slippage, you can adjust the allowed slippage in the settings on the top right of the page."

#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
msgid "Swapped {0} for {1}"
msgstr "Swapped {0} for {1}"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Tier {0} ({currentRebatePercentage}% rebate)"
msgstr "Tier {0} ({currentRebatePercentage}% rebate)"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Discover GMX Alerts"
msgstr "Discover GMX Alerts"

#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Price on Avalanche"
msgstr "Price on Avalanche"

#: src/components/Exchange/SwapBox.jsx
msgid "Swap Order creation failed."
msgstr "Swap Order creation failed."

#: src/pages/Exchange/Exchange.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Chart positions"
msgstr "Chart positions"

#: src/components/TVChartContainer/DynamicLine.tsx
msgid "Unknown Order"
msgstr "Unknown Order"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "The order will only execute if the price conditions are met and there is sufficient liquidity"
msgstr "The order will only execute if the price conditions are met and there is sufficient liquidity"

#: src/components/Exchange/FeesTooltip.tsx
msgid "Swap Fee"
msgstr "Swap Fee"

#: src/components/Glp/GlpSwap.jsx
msgid "GLP sell disabled, pending {0} upgrade"
msgstr "GLP sell disabled, pending {0} upgrade"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient receive token liquidity"
msgstr "Insufficient receive token liquidity"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Announcements and Updates"
msgstr "GMX Announcements and Updates"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update Limit Swap"
msgstr "Update Limit Swap"

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "fee"
msgstr "fee"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V2 Avalanche Fuji"
msgstr "V2 Avalanche Fuji"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Shift order cancelled"
msgstr "Shift order cancelled"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Order executed"
msgstr "Order executed"

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Select Positions"
msgstr "Select Positions"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be long {indexSymbol} from your long position, while being long {collateralSymbol} from your {collateralSymbol} collateral. The liquidation price will vary based on the price of {collateralSymbol}."
msgstr "You will be long {indexSymbol} from your long position, while being long {collateralSymbol} from your {collateralSymbol} collateral. The liquidation price will vary based on the price of {collateralSymbol}."

#: src/domain/synthetics/orders/setAutoCancelOrdersTxn.ts
msgid "Failed to update order(s)"
msgstr "Failed to update order(s)"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V2 Avalanche"
msgstr "V2 Avalanche"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Market Decrease"
msgstr "Failed Market Decrease"

#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Full market"
msgstr "Full market"

#: src/pages/NftWallet/NftWallet.jsx
msgid "NFT Wallet"
msgstr "NFT Wallet"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Proposals Voting page"
msgstr "GMX Proposals Voting page"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "You can buy ETH directly on <0>Arbitrum</0> using these options:"
msgstr "You can buy ETH directly on <0>Arbitrum</0> using these options:"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DEX Aggregator"
msgstr "DEX Aggregator"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Mark price for the order."
msgstr "Mark price for the order."

#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
msgid "Net Value"
msgstr "Net Value"

#: src/components/MarketSelector/MarketSelector.tsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterBase.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Search Market"
msgstr "Search Market"

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "The order's acceptable price includes the current price impact and set allowed slippage. The execution price must meet this condition for the order to be executed."
msgstr "The order's acceptable price includes the current price impact and set allowed slippage. The execution price must meet this condition for the order to be executed."

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Once the mark price hits the limit price, the order will attempt to execute, guaranteeing the acceptable price, which includes the set acceptable price impact. Note that if there is a negative price impact, the mark price may need to be higher than the limit price."
msgstr "Once the mark price hits the limit price, the order will attempt to execute, guaranteeing the acceptable price, which includes the set acceptable price impact. Note that if there is a negative price impact, the mark price may need to be higher than the limit price."

#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Transaction ID"
msgstr "Transaction ID"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
msgid "Borrow Fee / Day"
msgstr "Borrow Fee / Day"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Number of parts must be between {MIN_TWAP_NUMBER_OF_PARTS} and {MAX_TWAP_NUMBER_OF_PARTS}"
msgstr "Number of parts must be between {MIN_TWAP_NUMBER_OF_PARTS} and {MAX_TWAP_NUMBER_OF_PARTS}"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX (Chinese)"
msgstr "GMX (Chinese)"

#: src/components/Exchange/OrderEditor.jsx
msgid "Price is below Mark Price"
msgstr "Price is below Mark Price"

#: src/pages/Stake/Vesting.tsx
msgid "Withdraw from GMX Vault"
msgstr "Withdraw from GMX Vault"

#: src/components/Exchange/PositionEditor.jsx
msgid "Withdrawal submitted."
msgstr "Withdrawal submitted."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Referral Discount"
msgstr "Referral Discount"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "{longOrShort} positions do not pay a funding fee or a borrow fee."
msgstr "{longOrShort} positions do not pay a funding fee or a borrow fee."

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Fees for the past"
msgstr "Fees for the past"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Optimizations"
msgstr "Yield Optimizations"

#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Receive (Approximate)"
msgstr "Receive (Approximate)"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "No swap path found"
msgstr "No swap path found"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Combined stop losses are at maximum (100%). Decrease existing values to add more orders."
msgstr "Combined stop losses are at maximum (100%). Decrease existing values to add more orders."

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "4-18 Places"
msgstr "4-18 Places"

#: src/components/Synthetics/MarketsList/MarketsList.tsx
msgid "MARKETS"
msgstr "MARKETS"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "Max {0}"
msgstr "Max {0}"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "This token automatically accrues fees from leverage trading and swaps for the {marketName} market. It is also exposed to {exposedToLabel} as per the composition displayed."
msgstr "This token automatically accrues fees from leverage trading and swaps for the {marketName} market. It is also exposed to {exposedToLabel} as per the composition displayed."

#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "Withdrew {0} from {positionText}"
msgstr "Withdrew {0} from {positionText}"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Create Order"
msgstr "Create Order"

#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Utilization"
msgstr "Utilization"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "{orderTypeText} {0} for {1}"
msgstr "{orderTypeText} {0} for {1}"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Sender has withdrawn all tokens from GLP Vesting Vault"
msgstr "Sender has withdrawn all tokens from GLP Vesting Vault"

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High Swap Profit Fee"
msgstr "High Swap Profit Fee"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "WARNING: This position has a low amount of collateral after deducting fees, deposit more collateral to reduce the position's liquidation risk."
msgstr "WARNING: This position has a low amount of collateral after deducting fees, deposit more collateral to reduce the position's liquidation risk."

#: src/components/Exchange/SwapBox.jsx
msgid "Max {0} long capacity"
msgstr "Max {0} long capacity"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Enter a  price"
msgstr "Enter a  price"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Account"
msgstr "Account"

#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Using high leverage increases the risk of liquidation."
msgstr "Using high leverage increases the risk of liquidation."

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Express Trading is not available for wrapping or unwrapping native token {0}."
msgstr "Express Trading is not available for wrapping or unwrapping native token {0}."

#: src/components/Exchange/FeesTooltip.tsx
#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Close Fee"
msgstr "Close Fee"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "V1 Airdrop"
msgstr "V1 Airdrop"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "GMX"
msgstr "GMX"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX from Uniswap or directly on GMX (make sure to select Arbitrum):"
msgstr "Buy GMX from Uniswap or directly on GMX (make sure to select Arbitrum):"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Close to execution price"
msgstr "Close to execution price"

#: src/components/ExpressTradingOutOfGasBanner.ts/ExpressTradingOutOfGasBanner.tsx
#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Express and One-Click Trading are unavailable due to insufficient gas balance."
msgstr "Express and One-Click Trading are unavailable due to insufficient gas balance."

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "No funds to claim"
msgstr "No funds to claim"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "Global Leaderboard"
msgstr "Global Leaderboard"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Min size per part: {0}"
msgstr "Min size per part: {0}"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Trigger price above liq. price"
msgstr "Trigger price above liq. price"

#: src/pages/Home/Home.tsx
msgid "Simple Swaps"
msgstr "Simple Swaps"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "No results found"
msgstr "No results found"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBox.tsx
msgid "Pair"
msgstr "Pair"

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
msgid "Max {0} out"
msgstr "Max {0} out"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "There is no price impact. There is a single<0/>execution price for increasing shorts or<1/>decreasing longs for this size."
msgstr "There is no price impact. There is a single<0/>execution price for increasing shorts or<1/>decreasing longs for this size."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Option-based Vaults"
msgstr "Option-based Vaults"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Mark"
msgstr "Mark"

#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
msgid "Keep leverage at {keepLeverageAtValue}"
msgstr "Keep leverage at {keepLeverageAtValue}"

#: src/pages/Dashboard/GmxCard.tsx
msgid "not staked"
msgstr "not staked"

#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "Layer 2"
msgstr "Layer 2"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "Rebates Distribution History"
msgstr "Rebates Distribution History"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Accrued Negative Funding Fee"
msgstr "Accrued Negative Funding Fee"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Forfeit profit not checked"
msgstr "Forfeit profit not checked"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
msgid "Buy GM"
msgstr "Buy GM"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "of close fee"
msgstr "of close fee"

#: src/components/Exchange/TradeHistory.jsx
msgid "Increase {0} {longOrShortText}, +{1} USD, {2} Price: {3} USD"
msgstr "Increase {0} {longOrShortText}, +{1} USD, {2} Price: {3} USD"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "The address of the esGMX (IOU) token is {esGmxIouAddress}."
msgstr "The address of the esGMX (IOU) token is {esGmxIouAddress}."

#: src/components/NotifyModal/NotifyModal.tsx
msgid "GMX Alerts"
msgstr "GMX Alerts"

#: src/components/Synthetics/Claims/SettleAccruedCard.tsx
msgid "Show details"
msgstr "Show details"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "To reduce fees, select a different asset to pay with."
msgstr "To reduce fees, select a different asset to pay with."

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Once the mark price hits the limit price, the order will attempt to execute, guaranteeing the acceptable price, which includes the set acceptable price impact. Note that if there is a negative price impact, the mark price may need to be lower than the limit price."
msgstr "Once the mark price hits the limit price, the order will attempt to execute, guaranteeing the acceptable price, which includes the set acceptable price impact. Note that if there is a negative price impact, the mark price may need to be lower than the limit price."

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Buy {0}"
msgstr "Buy {0}"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "USD Value may not be accurate since the data does not contain prices for {0}"
msgstr "USD Value may not be accurate since the data does not contain prices for {0}"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Blueberry Club"
msgstr "GMX Blueberry Club"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "Cumulative PnL"
msgstr "Cumulative PnL"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Arbitrum Max. APY:"
msgstr "Arbitrum Max. APY:"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Vault Capacity for your Account:"
msgstr "Vault Capacity for your Account:"

#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "{0, plural, one {Cancel order} other {Cancel # orders}}"
msgstr "{0, plural, one {Cancel order} other {Cancel # orders}}"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Display PnL After Fees"
msgstr "Display PnL After Fees"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Protocol risk explorer and stats"
msgstr "Protocol risk explorer and stats"

#: src/components/Exchange/PositionShareCard.tsx
msgid "Generating shareable image..."
msgstr "Generating shareable image..."

#: src/components/Exchange/FeesTooltip.tsx
#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Borrow Fee"
msgstr "Borrow Fee"

#: src/components/Glp/GlpSwap.jsx
msgid "Buy submitted."
msgstr "Buy submitted."

#: src/pages/Stake/Stake.tsx
#~ msgid "Incentives & Prizes"
#~ msgstr "Incentives & Prizes"

#: src/components/Glp/GlpSwap.jsx
msgid "Fees may vary depending on which asset you sell GLP for. <0/>Enter the amount of GLP you want to redeem in the order form, then check here to compare fees."
msgstr "Fees may vary depending on which asset you sell GLP for. <0/>Enter the amount of GLP you want to redeem in the order form, then check here to compare fees."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "{txnTypeText} {0} order for"
msgstr "{txnTypeText} {0} order for"

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
msgid "The fees' USD value is calculated at the time they are earned and does not include incentives."
msgstr "The fees' USD value is calculated at the time they are earned and does not include incentives."

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/pages/Stake/StakeModal.tsx
#: src/pages/Stake/UnstakeModal.tsx
#: src/pages/Stake/VesterDepositModal.tsx
msgid "Max"
msgstr "Max"

#: src/components/Referrals/AddAffiliateCode.jsx
#: src/components/Referrals/JoinReferralCode.tsx
msgid "Checking code..."
msgstr "Checking code..."

#: src/components/Synthetics/GmList/GmList.tsx
#: src/components/Synthetics/MarketsList/MarketsList.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "GM Pools"
msgstr "GM Pools"

#: src/components/Exchange/SwapBox.jsx
msgid "There is a \"Close\" button on each position row, clicking it will display the option to close positions via market orders."
msgstr "There is a \"Close\" button on each position row, clicking it will display the option to close positions via market orders."

#: src/components/Synthetics/TradeBox/TradeBoxRows/AvailableLiquidityRow.tsx
msgid "The order will only execute if the price conditions are met and there is sufficient liquidity."
msgstr "The order will only execute if the price conditions are met and there is sufficient liquidity."

#: src/pages/Referrals/Referrals.tsx
msgid "Affiliates"
msgstr "Affiliates"

#: src/pages/Stake/Vesting.tsx
msgid "Convert esGMX tokens to GMX tokens.<0/>Please read the <1>vesting details</1> before using the vaults."
msgstr "Convert esGMX tokens to GMX tokens.<0/>Please read the <1>vesting details</1> before using the vaults."

#: src/components/OneClickPromoBanner/OneClickPromoBanner.tsx
msgid "Try Express"
msgstr "Try Express"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Failed to deactivate"
msgstr "Failed to deactivate"

#: src/lib/legacy.ts
msgid "No open position, order cannot be executed unless a position is opened"
msgstr "No open position, order cannot be executed unless a position is opened"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "Short Positions"
msgstr "Short Positions"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
msgid "Buying {symbol}..."
msgstr "Buying {symbol}..."

#: src/components/Exchange/TradeHistory.jsx
msgid "Could not increase {0} {longOrShortText}, +{1} USD, Acceptable Price: {2}  USD"
msgstr "Could not increase {0} {longOrShortText}, +{1} USD, Acceptable Price: {2}  USD"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX on {chainName}"
msgstr "Buy GMX on {chainName}"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/PositionEditor/PositionEditorAdvancedRows.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Size"
msgstr "Size"

#: src/components/InterviewToast/InterviewToast.tsx
msgid "We value your experience and insights and invite you to participate in an anonymous one-on-one chat."
msgstr "We value your experience and insights and invite you to participate in an anonymous one-on-one chat."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Header/AppHeaderUser.tsx
#: src/components/Referrals/AddAffiliateCode.jsx
#: src/components/Referrals/JoinReferralCode.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/TotalRewardsCard.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Connect Wallet"
msgstr "Connect Wallet"

#: src/components/Exchange/OrdersToa.jsx
msgid "Enabling Orders..."
msgstr "Enabling Orders..."

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Vest with GLP on Avalanche"
msgstr "Vest with GLP on Avalanche"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "No esGMX to claim"
msgstr "No esGMX to claim"

#: src/components/Exchange/SwapBox.jsx
msgid "Requested increase of {tokenSymbol} {longOrShortText} by {0} USD."
msgstr "Requested increase of {tokenSymbol} {longOrShortText} by {0} USD."

#: src/pages/Home/Home.tsx
msgid "Enter and exit positions with minimal spread and low price impact. Get the optimal price without incurring additional costs."
msgstr "Enter and exit positions with minimal spread and low price impact. Get the optimal price without incurring additional costs."

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "STIP.b trading incentives"
msgstr "STIP.b trading incentives"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "You can edit the default Allowed Slippage in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than {0}, may result in failed orders if prices are volatile."
msgstr "You can edit the default Allowed Slippage in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than {0}, may result in failed orders if prices are volatile."

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
msgid "Last 365d"
msgstr "Last 365d"

#: src/components/Exchange/FeesTooltip.tsx
msgid "<0>Read more</0> about fees."
msgstr "<0>Read more</0> about fees."

#: src/components/Exchange/OrdersList.jsx
msgid "You will receive at least {0} {1} if this order is executed. The execution price may vary depending on swap fees at the time the order is executed."
msgstr "You will receive at least {0} {1} if this order is executed. The execution price may vary depending on swap fees at the time the order is executed."

#: src/components/Exchange/SwapBox.jsx
msgid "Limit order creation failed."
msgstr "Limit order creation failed."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Dune Analytics"
msgstr "Dune Analytics"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "There isn't enough GM: {0} [{1}] liquidity in GLV to fulfill your sell request. Please choose a different pool, reduce the sell size, or split your withdrawal from multiple pools."
msgstr "There isn't enough GM: {0} [{1}] liquidity in GLV to fulfill your sell request. Please choose a different pool, reduce the sell size, or split your withdrawal from multiple pools."

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Approving {0}..."
msgstr "Approving {0}..."

#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "Deposited {0} into {positionText}"
msgstr "Deposited {0} into {positionText}"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Your wallet, your keys. GMX executes transactions for you without individual signing, providing a seamless, CEX-like experience. Trades use GMX-sponsored premium RPCs for reliability, even during network congestion. Gas payments in USDC or WETH."
msgstr "Your wallet, your keys. GMX executes transactions for you without individual signing, providing a seamless, CEX-like experience. Trades use GMX-sponsored premium RPCs for reliability, even during network congestion. Gas payments in USDC or WETH."

#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimCollateralHistoryRow.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Claim Funding Fees"
msgstr "Claim Funding Fees"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Rebates are airdropped weekly."
msgstr "Rebates are airdropped weekly."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Display Settings"
msgstr "Display Settings"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "Hold the GLV tokens for three months to be eligible for the $500,000 incentive program."
msgstr "Hold the GLV tokens for three months to be eligible for the $500,000 incentive program."

#: src/components/StatsTooltip/ChainsStatsTooltipRow.tsx
msgid "Total:"
msgstr "Total:"

#: src/domain/tokens/approveTokens.tsx
msgid "{0} Approved!"
msgstr "{0} Approved!"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "No swap path available. <0>Swap {0} to STBTC</0> to use {1} as collateral."
msgstr "No swap path available. <0>Swap {0} to STBTC</0> to use {1} as collateral."

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "<0>Provide liquidity</0> and earn {gmxMarketApyDataText} APY"
msgstr "<0>Provide liquidity</0> and earn {gmxMarketApyDataText} APY"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Address"
msgstr "Address"

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "Winner:"
msgstr "Winner:"

#: src/pages/Home/Home.tsx
msgid "Total Trading Volume"
msgstr "Total Trading Volume"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/CollateralSpreadRow.tsx
msgid "Collateral Spread"
msgstr "Collateral Spread"

#: src/components/Synthetics/TradeBox/TradeBoxRows/CollateralSelectorRow.tsx
msgid "You have an existing limit order with {symbol} as collateral. <0>Switch to {symbol} collateral</0>."
msgstr "You have an existing limit order with {symbol} as collateral. <0>Switch to {symbol} collateral</0>."

#: src/components/Header/Header.tsx
msgid "Trade on GMX V2 in Arbitrum and win 280,000 ARB (> $500k) in prizes in <0>two weekly</0> competitions. Live from March 13th to 27th."
msgstr "Trade on GMX V2 in Arbitrum and win 280,000 ARB (> $500k) in prizes in <0>two weekly</0> competitions. Live from March 13th to 27th."

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Index"
msgstr "Index"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Finance Dashboard"
msgstr "Decentralized Finance Dashboard"

#: src/components/Glp/GlpSwap.jsx
msgid "GLP buy disabled, pending {0} upgrade"
msgstr "GLP buy disabled, pending {0} upgrade"

#: src/components/Errors/errorToasts.tsx
#: src/components/Errors/errorToasts.tsx
msgid "<0>Error submitting order.</0><1/><2>Signer address does not match receiver address.</2><3/><4>Please reload the page and try again.</4>"
msgstr "<0>Error submitting order.</0><1/><2>Signer address does not match receiver address.</2><3/><4>Please reload the page and try again.</4>"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Trading Mode"
msgstr "Trading Mode"

#: src/components/Errors/errorToasts.tsx
msgid "Transaction failed due to RPC error.<0/><1/>Please try changing the RPC url in your wallet settings with the help of <2>chainlist.org</2>.<3/><4/><5>Read more</5>."
msgstr "Transaction failed due to RPC error.<0/><1/>Please try changing the RPC url in your wallet settings with the help of <2>chainlist.org</2>.<3/><4/><5>Read more</5>."

#: src/components/Exchange/PositionSeller.jsx
msgid "You have an active order to decrease {longOrShortText} {sizeInToken} {0} (${1}) at {prefix} {2}"
msgstr "You have an active order to decrease {longOrShortText} {sizeInToken} {0} (${1}) at {prefix} {2}"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max {0} sellable amount exceeded"
msgstr "Max {0} sellable amount exceeded"

#: src/components/Glp/GlpSwap.jsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "TOKEN"
msgstr "TOKEN"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "What is the bonus incentive for holding your GLV?"
msgstr "What is the bonus incentive for holding your GLV?"

#: src/pages/NftWallet/NftWallet.jsx
msgid "Transfer NFT"
msgstr "Transfer NFT"

#: src/components/Exchange/PositionEditor.jsx
msgid "Enable deposit failed."
msgstr "Enable deposit failed."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Receiver has not staked GMX tokens before"
msgstr "Receiver has not staked GMX tokens before"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram bot for GMX Swaps monitoring"
msgstr "Telegram bot for GMX Swaps monitoring"

#: src/components/Synthetics/MarketsList/MarketsList.tsx
msgid "LIQUIDITY"
msgstr "LIQUIDITY"

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
msgid "Swaps"
msgstr "Swaps"

#: src/components/ApproveTokenButton/ApproveTokenButton.tsx
#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Allow {0} to be spent"
msgstr "Allow {0} to be spent"

#: src/components/Exchange/SwapBox.jsx
msgid "Swap Order created!"
msgstr "Swap Order created!"

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "POSITION"
msgstr "POSITION"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "Trading Volume"
msgstr "Trading Volume"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "You have an existing limit order in the {0} market pool but it lacks liquidity for this order."
msgstr "You have an existing limit order in the {0} market pool but it lacks liquidity for this order."

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Reserved for Vesting"
msgstr "Reserved for Vesting"

#: src/components/Exchange/TradeHistory.jsx
#: src/components/Referrals/JoinReferralCode.tsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Update"
msgstr "Update"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DODO"
msgstr "DODO"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Your transfer has been initiated."
msgstr "Your transfer has been initiated."

#: src/components/Synthetics/GmList/FeeApyLabel.tsx
msgid "Estimated annualized fees generated by trading activity (open, close, borrow, liquidations, swaps) over the selected period. Does not include backing token price changes, trading PnL, or funding fees.<0/><1/>For detailed stats and comparisons, see the <2>GMX V2 LP Dashboard</2>."
msgstr "Estimated annualized fees generated by trading activity (open, close, borrow, liquidations, swaps) over the selected period. Does not include backing token price changes, trading PnL, or funding fees.<0/><1/>For detailed stats and comparisons, see the <2>GMX V2 LP Dashboard</2>."

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Liquidation Risk Alerts"
msgstr "Liquidation Risk Alerts"

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "{positionName} Fees settling"
msgstr "{positionName} Fees settling"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "{existingTriggerOrderLength, plural, one {You have an active trigger order that could impact this position.} other {You have # active trigger orders that could impact this position.}}"
msgstr "{existingTriggerOrderLength, plural, one {You have an active trigger order that could impact this position.} other {You have # active trigger orders that could impact this position.}}"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Shift order executed"
msgstr "Shift order executed"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "You need a total of at least {0} {stakeTokenLabel} to vest {1} esGMX."
msgstr "You need a total of at least {0} {stakeTokenLabel} to vest {1} esGMX."

#: src/components/Exchange/TradeHistory.jsx
msgid "Swap {0} USDG for{1} {2}"
msgstr "Swap {0} USDG for{1} {2}"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "{0} will be swapped to {1} on order execution."
msgstr "{0} will be swapped to {1} on order execution."

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "Claiming with a smart account requires specific instructions. Contributors will post these in the coming days."
msgstr "Claiming with a smart account requires specific instructions. Contributors will post these in the coming days."

#. Button to clear the filter selection
#: src/components/Synthetics/TableOptionsFilter/TableOptionsFilter.tsx
msgid "Clear selection"
msgstr "Clear selection"

#: src/domain/synthetics/orders/utils.tsx
msgid "The order will not be executed as its trigger price is beyond the position's liquidation price."
msgstr "The order will not be executed as its trigger price is beyond the position's liquidation price."

#: src/domain/synthetics/orders/cancelOrdersTxn.ts
msgid "Failed to cancel {ordersText}"
msgstr "Failed to cancel {ordersText}"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Short Stop Market: {0} a short position when the price is below the trigger price."
msgstr "{typeString} Short Stop Market: {0} a short position when the price is below the trigger price."

#: src/components/Errors/errorToasts.tsx
#: src/components/Errors/errorToasts.tsx
msgid "The mark price has changed, consider increasing your Allowed Slippage by clicking on the \"...\" icon next to your address."
msgstr "The mark price has changed, consider increasing your Allowed Slippage by clicking on the \"...\" icon next to your address."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Default Allowed Slippage"
msgstr "Default Allowed Slippage"

#. Total Value Locked
#: src/components/Synthetics/MarketsList/MarketsList.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "TVL"
msgstr "TVL"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "Shift Fee"
msgstr "Shift Fee"

#: src/pages/Dashboard/GlpCard.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "GLP Pool"
msgstr "GLP Pool"

#: src/domain/legacy.ts
#: src/pages/Exchange/Exchange.tsx
msgid "Cancel submitted."
msgstr "Cancel submitted."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX from Traderjoe:"
msgstr "Buy GMX from Traderjoe:"

#: src/pages/Actions/ActionsRouter.tsx
msgid "V1 is not supported on {chainName}. Please switch to Arbitrum to use V1."
msgstr "V1 is not supported on {chainName}. Please switch to Arbitrum to use V1."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Saulius GMX Analytics"
msgstr "Saulius GMX Analytics"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
msgid "{0} Price"
msgstr "{0} Price"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX from centralized services"
msgstr "Buy GMX from centralized services"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Bridge and swap"
msgstr "Bridge and swap"

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price above lowest limit price"
msgstr "Trigger price above lowest limit price"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Borrow Fee Rate"
msgstr "Borrow Fee Rate"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max number of parts: {MAX_TWAP_NUMBER_OF_PARTS}"
msgstr "Max number of parts: {MAX_TWAP_NUMBER_OF_PARTS}"

#: src/components/Header/AppHeaderUser.tsx
#: src/components/Header/AppHeaderUser.tsx
#: src/components/ModalViews/RedirectModal.tsx
#: src/pages/Home/Home.tsx
msgid "Launch App"
msgstr "Launch App"

#: src/pages/Exchange/Exchange.tsx
msgid "Deposited {0} USD into {tokenSymbol} {longOrShortText}"
msgstr "Deposited {0} USD into {tokenSymbol} {longOrShortText}"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Receiver has staked GMX/GLP before"
msgstr "Receiver has staked GMX/GLP before"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Fulfilling sell request"
msgstr "Fulfilling sell request"

#: src/components/Exchange/TradeHistory.jsx
msgid "{actionDisplay} Order"
msgstr "{actionDisplay} Order"

#: src/components/Exchange/SwapBox.jsx
msgid "There are more longs than shorts, borrow fees for shorting is currently zero"
msgstr "There are more longs than shorts, borrow fees for shorting is currently zero"

#: src/components/TokenCard/TokenCard.tsx
msgid "Avalanche APR:"
msgstr "Avalanche APR:"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Dune Analytics for GMX"
msgstr "Dune Analytics for GMX"

#: src/components/Exchange/TradeHistory.jsx
msgid "Could not decrease {0} {longOrShortText}, +{1} USD, Acceptable Price: {2}"
msgstr "Could not decrease {0} {longOrShortText}, +{1} USD, Acceptable Price: {2}"

#: src/components/Synthetics/MarketsList/MarketsList.tsx
msgid "NET RATE / 1 H"
msgstr "NET RATE / 1 H"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Vest with GMX on Avalanche"
msgstr "Vest with GMX on Avalanche"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Click on the Position to select its market, then use the trade box to increase your Position Size, or to set Take Profit / Stop Loss Orders."
msgstr "Click on the Position to select its market, then use the trade box to increase your Position Size, or to set Take Profit / Stop Loss Orders."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Relayer request failed"
msgstr "Relayer request failed"

#: src/components/Exchange/TradeHistory.jsx
msgid "Request decrease {0} {longOrShortText}, -{1} USD, Acceptable Price: {2} {3} USD"
msgstr "Request decrease {0} {longOrShortText}, -{1} USD, Acceptable Price: {2} {3} USD"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "settings updated"
msgstr "settings updated"

#: src/components/Exchange/SwapBox.jsx
msgid "You have an existing position with {0} as collateral."
msgstr "You have an existing position with {0} as collateral."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Transfer Account"
msgstr "Transfer Account"

#: src/pages/Actions/ActionsRouter.tsx
#: src/pages/Actions/ActionsV1/ActionsV1.tsx
msgid "GMX V1 Actions"
msgstr "GMX V1 Actions"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute TWAP Part"
msgstr "Execute TWAP Part"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Swap Profit Fee"
msgstr "Swap Profit Fee"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Amount to claim"
msgstr "Amount to claim"

#: src/pages/Jobs/Jobs.jsx
msgid "Job openings at GMX."
msgstr "Job openings at GMX."

#: src/components/Exchange/OrderEditor.jsx
msgid "Price below Mark Price"
msgstr "Price below Mark Price"

#: src/components/Stake/GMXAprTooltip.tsx
msgid "APRs are updated weekly on Wednesday and will depend on the fees collected for the week."
msgstr "APRs are updated weekly on Wednesday and will depend on the fees collected for the week."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Fees (Incl. Swap)"
msgstr "Fees (Incl. Swap)"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "{fromText} to {toMinText}"
msgstr "{fromText} to {toMinText}"

#: src/components/Errors/errorToasts.tsx
msgid "Otherwise, try changing the RPC url in your wallet settings with the help of <0>chainlist.org</0>."
msgstr "Otherwise, try changing the RPC url in your wallet settings with the help of <0>chainlist.org</0>."

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Price above Liq. Price"
msgstr "Price above Liq. Price"

#: src/domain/synthetics/orders/utils.tsx
msgid "There may not be sufficient liquidity to execute the pay token to collateral token swap when the price conditions are met."
msgstr "There may not be sufficient liquidity to execute the pay token to collateral token swap when the price conditions are met."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "User Quests"
msgstr "User Quests"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "Funds claimed"
msgstr "Funds claimed"

#: src/components/Glp/GlpSwap.jsx
msgid "{0} pool exceeded, try different token"
msgstr "{0} pool exceeded, try different token"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/domain/synthetics/positions/utils.ts
msgid "Trigger"
msgstr "Trigger"

#: src/pages/Exchange/Exchange.tsx
msgid "Positions ({0})"
msgstr "Positions ({0})"

#: src/pages/Stake/UnstakeModal.tsx
msgid "Unstake failed."
msgstr "Unstake failed."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Order cancelled"
msgstr "Order cancelled"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Not enough Available Swap Liquidity to fill the Order."
msgstr "Not enough Available Swap Liquidity to fill the Order."

#: src/pages/Stake/Stake.tsx
#~ msgid "Earn prizes by participating in GMX Trading Competitions."
#~ msgstr "Earn prizes by participating in GMX Trading Competitions."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Confirm Long"
msgstr "Confirm Long"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Traders Referred on Arbitrum"
msgstr "Traders Referred on Arbitrum"

#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "PnL After Fees"
msgstr "PnL After Fees"

#: src/lib/contracts/callContract.tsx
#: src/lib/contracts/callContract.tsx
#: src/lib/contracts/callContract.tsx
msgid "Transaction sent."
msgstr "Transaction sent."

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Enter up to 10 coins"
msgstr "Enter up to 10 coins"

#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "Exposure to Backing Tokens"
msgstr "Exposure to Backing Tokens"

#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Creating..."
msgstr "Creating..."

#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "Withdrawing from Subaccount"
msgstr "Withdrawing from Subaccount"

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "Settling Position Fees"
msgstr "Settling Position Fees"

#: src/components/Exchange/OrderEditor.jsx
msgid "Minimum received"
msgstr "Minimum received"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Available amount to withdraw from GLP. Funds not utilized by current open positions."
msgstr "Available amount to withdraw from GLP. Funds not utilized by current open positions."

#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Enter your feedback here"
msgstr "Enter your feedback here"

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High Impact on Collateral"
msgstr "High Impact on Collateral"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "and"
msgstr "and"

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Distribution History"
msgstr "Distribution History"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient GLV liquidity"
msgstr "Insufficient GLV liquidity"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Invalid price, see warning"
msgstr "Invalid price, see warning"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be short {indexSymbol} only from your short position."
msgstr "You will be short {indexSymbol} only from your short position."

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Signing approval..."
msgstr "Signing approval..."

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
msgid "The current price impact is {0}. Consider using -0.30% acceptable price impact so the order is more likely to be processed."
msgstr "The current price impact is {0}. Consider using -0.30% acceptable price impact so the order is more likely to be processed."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Auto-Cancel TP/SL"
msgstr "Auto-Cancel TP/SL"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Funding Fee Rate"
msgstr "Funding Fee Rate"

#: src/components/Exchange/PositionSeller.jsx
msgid "Requested decrease of {0} {longOrShortText} by {sizeDeltaUsd} USD."
msgstr "Requested decrease of {0} {longOrShortText} by {sizeDeltaUsd} USD."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Returned Collateral"
msgstr "Returned Collateral"

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "You need to select {swapTokenSymbol} as the \"Pay\" token to use it for collateral to initiate this trade."
msgstr "You need to select {swapTokenSymbol} as the \"Pay\" token to use it for collateral to initiate this trade."

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "There are issues in the TP/SL orders."
msgstr "There are issues in the TP/SL orders."

#: src/components/Glp/GlpSwap.jsx
msgid "The Bonus Rebate is an estimate and will be airdropped as ARB tokens when migrating this liquidity to GM pools within the same epoch. <0>Read more</0>."
msgstr "The Bonus Rebate is an estimate and will be airdropped as ARB tokens when migrating this liquidity to GM pools within the same epoch. <0>Read more</0>."

#: src/components/Glp/GlpSwap.jsx
msgid "{0} GLP sold for {1} {2}!"
msgstr "{0} GLP sold for {1} {2}!"

#: src/components/TVChartContainer/constants.ts
msgid "Stop Market - Long Inc."
msgstr "Stop Market - Long Inc."

#: src/domain/synthetics/claimHistory/claimPriceImpactRebate.ts
msgid "Failed to Claim Price Impact Rebate"
msgstr "Failed to Claim Price Impact Rebate"

#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Only positions with over {0} in \"Capital Used\" are ranked."
msgstr "Only positions with over {0} in \"Capital Used\" are ranked."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Accept minimum and {action}"
msgstr "Accept minimum and {action}"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
msgid "Withdraw from Affiliate Vault"
msgstr "Withdraw from Affiliate Vault"

#: src/components/Glp/GlpSwap.jsx
msgid "Current Pool Amount"
msgstr "Current Pool Amount"

#: src/domain/legacy.ts
#: src/pages/Exchange/Exchange.tsx
msgid "Cancel failed."
msgstr "Cancel failed."

#: src/components/Synthetics/TradeBox/TradeBoxRows/AvailableLiquidityRow.tsx
msgid "The order will be executed if there is sufficient liquidity and the execution price guarantees that you will receive the minimum receive amount."
msgstr "The order will be executed if there is sufficient liquidity and the execution price guarantees that you will receive the minimum receive amount."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Transacting with a depegged stable coin is subject to spreads reflecting the worse of current market price or $1.00, with transactions involving multiple stablecoins may have multiple spreads."
msgstr "Transacting with a depegged stable coin is subject to spreads reflecting the worse of current market price or $1.00, with transactions involving multiple stablecoins may have multiple spreads."

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Use the \"Close\" button to reduce your Position Size."
msgstr "Use the \"Close\" button to reduce your Position Size."

#: src/components/Exchange/PositionDropdown.tsx
msgid "Increase Size (Limit)"
msgstr "Increase Size (Limit)"

#: src/domain/synthetics/orders/utils.tsx
msgid "The order may not execute at the desired {priceText} as its acceptable price impact is set to {formattedOrderAcceptablePriceImpact}, which is lower than the current market price impact of {formattedCurrentAcceptablePriceImpact}. It can be edited using the \"Edit\" button."
msgstr "The order may not execute at the desired {priceText} as its acceptable price impact is set to {formattedOrderAcceptablePriceImpact}, which is lower than the current market price impact of {formattedCurrentAcceptablePriceImpact}. It can be edited using the \"Edit\" button."

#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Liquidation Fee"
msgstr "Liquidation Fee"

#: src/components/Synthetics/Claims/SettleAccruedCard.tsx
#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Settle"
msgstr "Settle"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Short TWAP: {0} a short position in evenly distributed parts over a specified time."
msgstr "{typeString} Short TWAP: {0} a short position in evenly distributed parts over a specified time."

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "Insufficient gas for network fees"
msgstr "Insufficient gas for network fees"

#: src/domain/synthetics/orders/utils.tsx
msgid "There may not be sufficient liquidity to execute the swap when the min. receive conditions are met."
msgstr "There may not be sufficient liquidity to execute the swap when the min. receive conditions are met."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "{fromText} to"
msgstr "{fromText} to"

#: src/components/Exchange/PositionDropdown.tsx
msgid "Select Market"
msgstr "Select Market"

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "Open positions: {0}<0/>Under risk: {1}"
msgstr "Open positions: {0}<0/>Under risk: {1}"

#: src/components/Exchange/UsefulLinks.tsx
msgid "Speed up page loading"
msgstr "Speed up page loading"

#: src/components/Exchange/TradeHistory.jsx
msgid "{0}: Swap {amountInDisplay}{1} for{minOutDisplay} {2}, Price:{3} USD"
msgstr "{0}: Swap {amountInDisplay}{1} for{minOutDisplay} {2}, Price:{3} USD"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "(Rebated)"
msgstr "(Rebated)"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX from centralized exchanges:"
msgstr "Buy GMX from centralized exchanges:"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "GMX bonds can be bought on Bond Protocol with a discount and a small vesting period:"
msgstr "GMX bonds can be bought on Bond Protocol with a discount and a small vesting period:"

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price above highest limit price"
msgstr "Trigger price above highest limit price"

#: src/components/Exchange/OrdersToa.jsx
msgid "Note that orders are not guaranteed to be executed.<0/><1/>This can occur in a few situations including but not exclusive to:"
msgstr "Note that orders are not guaranteed to be executed.<0/><1/>This can occur in a few situations including but not exclusive to:"

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Open Positions with Orders"
msgstr "Open Positions with Orders"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Copin"
msgstr "Copin"

#: src/components/Exchange/PositionSeller.jsx
msgid "{nativeTokenSymbol} can not be sent to smart contract addresses. Select another token."
msgstr "{nativeTokenSymbol} can not be sent to smart contract addresses. Select another token."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "This swap is routed through several GM pools for the lowest possible fees and price impact."
msgstr "This swap is routed through several GM pools for the lowest possible fees and price impact."

#: src/components/Synthetics/OrderItem/TwapOrdersList/TwapOrdersList.tsx
#: src/components/Synthetics/OrderItem/TwapOrdersList/TwapOrdersList.tsx
msgid "{0}"
msgstr "{0}"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Not enough Available Liquidity to fill the Order. The Order will get filled when the condition is met and there is enough Available Liquidity."
msgstr "Not enough Available Liquidity to fill the Order. The Order will get filled when the condition is met and there is enough Available Liquidity."

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Annualized data based on the past 7 days."
msgstr "Annualized data based on the past 7 days."

#: src/components/Exchange/OrdersToa.jsx
#: src/components/Exchange/OrdersToa.jsx
msgid "Enable Orders"
msgstr "Enable Orders"

#: src/components/Glp/GlpSwap.jsx
msgid "Max pool capacity reached for {0}. Please mint GLP using another token"
msgstr "Max pool capacity reached for {0}. Please mint GLP using another token"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "No liquidity is available for increasing shorts for<0/>this size. Max short size: {0}<1/><2/>Execution prices for decreasing longs."
msgstr "No liquidity is available for increasing shorts for<0/>this size. Max short size: {0}<1/><2/>Execution prices for decreasing longs."

#: src/components/Header/AppHeaderLinks.tsx
msgid "Trade"
msgstr "Trade"

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Adding referral code failed."
msgstr "Adding referral code failed."

#: src/components/Exchange/PositionEditor.jsx
msgid "Max leverage without PnL: {0}x"
msgstr "Max leverage without PnL: {0}x"

#: src/pages/SyntheticsFallbackPage/SyntheticsFallbackPage.tsx
msgid "V2 doesn't currently support this network"
msgstr "V2 doesn't currently support this network"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V1 Arbitrum"
msgstr "V1 Arbitrum"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Avalanche"
msgstr "Avalanche"

#: src/components/Synthetics/MarketStats/MarketGraphs.tsx
msgid "Fee APR"
msgstr "Fee APR"

#: src/domain/synthetics/positions/utils.ts
msgid "SL"
msgstr "SL"

#: src/components/Header/AppHeaderLinks.tsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
#: src/pages/Stake/Stake.tsx
#: src/pages/Stake/Stake.tsx
#: src/pages/Stake/Stake.tsx
#: src/pages/Stake/Stake.tsx
#: src/pages/Stake/StakeModal.tsx
#: src/pages/Stake/StakeModal.tsx
msgid "Stake"
msgstr "Stake"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
msgid "Allow {tokenSymbol} to be spent"
msgstr "Allow {tokenSymbol} to be spent"

#: src/components/NpsModal/NpsModal.tsx
msgid "Help us improve"
msgstr "Help us improve"

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Invalid Liquidation Price"
msgstr "Invalid Liquidation Price"

#: src/pages/Home/Home.tsx
msgid "An aggregate of high-quality price feeds determine when liquidations occur. This keeps positions safe from temporary wicks."
msgstr "An aggregate of high-quality price feeds determine when liquidations occur. This keeps positions safe from temporary wicks."

#: src/components/Exchange/PositionSeller.jsx
msgid "Swap amount from {0} to {1} exceeds {2} available liquidity. Choose a different \"Receive\" token."
msgstr "Swap amount from {0} to {1} exceeds {2} available liquidity. Choose a different \"Receive\" token."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create Take Profit"
msgstr "Create Take Profit"

#: src/components/Exchange/OrderEditor.jsx
msgid "Update Order"
msgstr "Update Order"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "Can I sell my GLV if I want, and where?"
msgstr "Can I sell my GLV if I want, and where?"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel TWAP"
msgstr "Cancel TWAP"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Mark price for the liquidation."
msgstr "Mark price for the liquidation."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "<0>Selling {0}{1}<1>{poolName}</1></0>"
msgstr "<0>Selling {0}{1}<1>{poolName}</1></0>"

#: src/components/Exchange/PositionSeller.jsx
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max close amount exceeded"
msgstr "Max close amount exceeded"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max leverage: {0}x"
msgstr "Max leverage: {0}x"

#: src/domain/synthetics/positions/utils.ts
msgid "T"
msgstr "T"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Please enter the names of the coins you'd like to see added:"
msgstr "Please enter the names of the coins you'd like to see added:"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Forfeit profit and Short"
msgstr "Forfeit profit and Short"

#: src/pages/Dashboard/GmxCard.tsx
msgid "Staked on Arbitrum"
msgstr "Staked on Arbitrum"

#: src/components/Exchange/PositionSeller.jsx
msgid "Order creation failed."
msgstr "Order creation failed."

#: src/components/TokenCard/TokenCard.tsx
msgid "Sell token on:"
msgstr "Sell token on:"

#: src/components/Synthetics/MissedCoinsHint/MissedCoinsHint.tsx
msgid "Can’t find the coin you need? Let us know"
msgstr "Can’t find the coin you need? Let us know"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Delegated to"
msgstr "Delegated to"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "{orderText} update failed."
msgstr "{orderText} update failed."

#: src/components/Exchange/TradeHistory.jsx
msgid "Execute Order: Swap {fromAmountDisplay} {0} for {toAmountDisplay} {1}"
msgstr "Execute Order: Swap {fromAmountDisplay} {0} for {toAmountDisplay} {1}"

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "Buy {swapTokenSymbol} on 1inch"
msgstr "Buy {swapTokenSymbol} on 1inch"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "PnL (%)"
msgstr "PnL (%)"

#: src/domain/synthetics/userFeedback/utils.ts
msgid "How can we continue to meet your expectations?"
msgstr "How can we continue to meet your expectations?"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "The esGMX (IOU) token is transferrable. You can add the token to your wallet and send it to another address to claim if you'd like."
msgstr "The esGMX (IOU) token is transferrable. You can add the token to your wallet and send it to another address to claim if you'd like."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Self-transfer not supported"
msgstr "Self-transfer not supported"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Generating session..."
msgstr "Generating session..."

#: src/pages/Exchange/Exchange.tsx
msgid "Decreased {tokenSymbol} {longOrShortText}, -{0} USD."
msgstr "Decreased {tokenSymbol} {longOrShortText}, -{0} USD."

#: src/components/Exchange/PositionEditor.jsx
msgid "Leave at least {0} ETH for gas"
msgstr "Leave at least {0} ETH for gas"

#: src/pages/Exchange/Exchange.tsx
msgid "Enable orders failed."
msgstr "Enable orders failed."

#: src/pages/Dashboard/GlpCard.tsx
#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Total Staked"
msgstr "Total Staked"

#: src/components/Exchange/FeesTooltip.tsx
#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Network Fee"
msgstr "Network Fee"

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Expected execution price for the order, including the current price impact."
msgstr "Expected execution price for the order, including the current price impact."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/PositionEditor/PositionEditorAdvancedRows.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
msgid "Leverage"
msgstr "Leverage"

#: src/pages/Exchange/Exchange.tsx
msgid "Enable orders sent."
msgstr "Enable orders sent."

#: src/components/Exchange/PositionEditor.jsx
#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "Withdrawing..."
msgstr "Withdrawing..."

#: src/components/Synthetics/Claims/ClaimsHistory.tsx
msgid "No claims match the selected filters"
msgstr "No claims match the selected filters"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Referrals/ClaimAffiliatesModal/ClaimAffiliatesModal.tsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterBase.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/TradeHistoryRow.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
#: src/domain/synthetics/positions/utils.ts
msgid "Market"
msgstr "Market"

#: src/components/Exchange/PositionSeller.jsx
msgid "Swap amount from {0} to {1} exceeds {2} acceptable amount. Can only receive {3}."
msgstr "Swap amount from {0} to {1} exceeds {2} acceptable amount. Can only receive {3}."

#: src/pages/Stake/Stake.tsx
#~ msgid "Earn {incentivesToken} token incentives by purchasing GM tokens or trading in GMX V2."
#~ msgstr "Earn {incentivesToken} token incentives by purchasing GM tokens or trading in GMX V2."

#: src/components/Exchange/PositionEditor.jsx
msgid "Withdraw disabled, pending {0} upgrade"
msgstr "Withdraw disabled, pending {0} upgrade"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Read the rules"
msgstr "Read the rules"

#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Lev."
msgstr "Lev."

#: src/pages/Stake/StakeModal.tsx
msgid "Stake failed."
msgstr "Stake failed."

#: src/components/NpsModal/NpsModal.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Submitting..."
msgstr "Submitting..."

#: src/components/Header/HomeHeaderLinks.tsx
msgid "App"
msgstr "App"

#: src/components/Synthetics/GmList/GlvList.tsx
msgid "Yield-optimized vaults supplying liquidity across multiple GMX markets."
msgstr "Yield-optimized vaults supplying liquidity across multiple GMX markets."

#: src/components/Synthetics/GmAssetDropdown/GmAssetDropdown.tsx
msgid "Add {marketName} to Wallet"
msgstr "Add {marketName} to Wallet"

#: src/components/Synthetics/GmList/PerformanceLabel.tsx
msgid "Annualized Performance"
msgstr "Annualized Performance"

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "<0>{0}</0> <1><2>{indexName}</2><3>[{poolName}]</3></1>"
msgstr "<0>{0}</0> <1><2>{indexName}</2><3>[{poolName}]</3></1>"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Swap {0} to {1}"
msgstr "Swap {0} to {1}"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Fees are high to swap from {0} to {1}."
msgstr "Fees are high to swap from {0} to {1}."

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
msgid "Debug values are not available"
msgstr "Debug values are not available"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Trigger price below liq. price"
msgstr "Trigger price below liq. price"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/AffiliateClaimModal.tsx
#: src/pages/Stake/ClaimModal.tsx
msgid "Claim failed."
msgstr "Claim failed."

#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Positions{0}"
msgstr "Positions{0}"

#: src/domain/synthetics/orders/simulateExecuteTxn.tsx
msgid "Unknown Error"
msgstr "Unknown Error"

#: src/components/Glp/GlpSwap.jsx
msgid "Buying..."
msgstr "Buying..."

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Enter a new ratio or allowed slippage"
msgstr "Enter a new ratio or allowed slippage"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Swap UI Fee"
msgstr "Swap UI Fee"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Decrease the size to match the max. allowed leverage:"
msgstr "Decrease the size to match the max. allowed leverage:"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Accrued Positive Funding Fee"
msgstr "Accrued Positive Funding Fee"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Sender has withdrawn all tokens from Affiliate Vesting Vault"
msgstr "Sender has withdrawn all tokens from Affiliate Vesting Vault"

#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeHistory/keys.ts
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "Liquidated"
msgstr "Liquidated"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Blueberry Pulse"
msgstr "Blueberry Pulse"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "Please switch to the <0><1/><2>Arbitrum</2></0> or <3><4/><5>Avalanche</5></3> deployment for those features."
msgstr "Please switch to the <0><1/><2>Arbitrum</2></0> or <3><4/><5>Avalanche</5></3> deployment for those features."

#: src/components/NetworkDropdown/LanguagePopupHome.tsx
#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "Select Language"
msgstr "Select Language"

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Direction"
msgstr "Direction"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "GM can be sold for {0} and {1} for this market up to the specified selling caps. The remaining tokens in the pool are reserved for currently open positions."
msgstr "GM can be sold for {0} and {1} for this market up to the specified selling caps. The remaining tokens in the pool are reserved for currently open positions."

#: src/components/Glp/GlpSwap.jsx
#~ msgid "Due to the recent incident on GMX V1 Arbitrum, GLP on Arbitrum is not sellable."
#~ msgstr "Due to the recent incident on GMX V1 Arbitrum, GLP on Arbitrum is not sellable."

#: src/components/Synthetics/GmList/GlvList.tsx
#: src/components/Synthetics/GmList/GmList.tsx
msgid "Graph showing performance vs benchmark over the selected period."
msgstr "Graph showing performance vs benchmark over the selected period."

#: src/components/Synthetics/ExecutionPriceRow.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "Order Acceptable Price"
msgstr "Order Acceptable Price"

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "VOL."
msgstr "VOL."

#: src/components/Glp/GlpSwap.jsx
msgid "Max Capacity for {0} Reached"
msgstr "Max Capacity for {0} Reached"

#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price below limit price"
msgstr "Trigger price below limit price"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "<0>Buying {0}{1}<1>{poolName}</1></0> <2>with {tokensText}</2>"
msgstr "<0>Buying {0}{1}<1>{poolName}</1></0> <2>with {tokensText}</2>"

#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Initial Collateral"
msgstr "Initial Collateral"

#: src/pages/Stake/StakeModal.tsx
msgid "<0>Delegate your undelegated {0} GMX DAO</0> voting power before staking."
msgstr "<0>Delegate your undelegated {0} GMX DAO</0> voting power before staking."

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Avg. Size"
msgstr "Avg. Size"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "V1 esGMX"
msgstr "V1 esGMX"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Take Profit PnL"
msgstr "Take Profit PnL"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Let us know which coins you're missing"
msgstr "Let us know which coins you're missing"

#: src/components/Exchange/PositionEditor.jsx
msgid "Enable withdraw sent."
msgstr "Enable withdraw sent."

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Your esGMX (IOU) balance will decrease by your claim amount after claiming, this is expected behaviour."
msgstr "Your esGMX (IOU) balance will decrease by your claim amount after claiming, this is expected behaviour."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "The Max Network Fee is set to a higher value to handle potential increases in gas price during order execution. Any excess network fee will be refunded to your account when the order is executed. Only applicable to GMX V2."
msgstr "The Max Network Fee is set to a higher value to handle potential increases in gas price during order execution. Any excess network fee will be refunded to your account when the order is executed. Only applicable to GMX V2."

#: src/domain/synthetics/positions/utils.ts
msgid "stop market"
msgstr "stop market"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Start Unrealized PnL"
msgstr "Start Unrealized PnL"

#: src/components/TVChartContainer/constants.ts
msgid "Limit - Short Inc."
msgstr "Limit - Short Inc."

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "Sending settle request"
msgstr "Sending settle request"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
#~ msgid "Some funds are still held in GLP. Users should expect future claims and check back periodically. most funds have already been distributed."
#~ msgstr "Some funds are still held in GLP. Users should expect future claims and check back periodically. most funds have already been distributed."

#: src/lib/legacy.ts
msgid "Order cannot be executed as the remaining position would be smaller than $5.00"
msgstr "Order cannot be executed as the remaining position would be smaller than $5.00"

#: src/components/Referrals/ClaimAffiliatesModal/ClaimAffiliatesModal.tsx
#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/AffiliateClaimModal.tsx
#: src/pages/Stake/ClaimModal.tsx
msgid "Claiming..."
msgstr "Claiming..."

#. Filter option for tokens favorites
#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "All"
msgstr "All"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Request Market Increase"
msgstr "Request Market Increase"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Edit {0}"
msgstr "Edit {0}"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Vest with GMX on Arbitrum"
msgstr "Vest with GMX on Arbitrum"

#: src/components/Synthetics/Claims/ClaimableCard.tsx
msgid "Claimable price impact rebates.<0/><1/><2>Read more</2>."
msgstr "Claimable price impact rebates.<0/><1/><2>Read more</2>."

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "{longOrShort} positions {fundingAction} a funding fee of {fundingRate} per hour and {borrowAction} a borrow fee of {borrowRate} per hour."
msgstr "{longOrShort} positions {fundingAction} a funding fee of {fundingRate} per hour and {borrowAction} a borrow fee of {borrowRate} per hour."

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/domain/synthetics/positions/utils.ts
msgid "TWAP"
msgstr "TWAP"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Updating Order..."
msgstr "Updating Order..."

#: src/components/Exchange/PositionSeller.jsx
msgid "Close failed."
msgstr "Close failed."

#: src/pages/Stake/Stake.tsx
msgid "You are earning rewards with {0} tokens.<0/>Tokens: {amountStr}."
msgstr "You are earning rewards with {0} tokens.<0/>Tokens: {amountStr}."

#: src/components/ModalViews/RedirectModal.tsx
msgid "The website is a community deployed and maintained instance of the open source <0>GMX front end</0>, hosted and served on the distributed, peer-to-peer <1>IPFS network</1>."
msgstr "The website is a community deployed and maintained instance of the open source <0>GMX front end</0>, hosted and served on the distributed, peer-to-peer <1>IPFS network</1>."

#: src/components/Exchange/PositionEditor.jsx
msgid "Deposit failed."
msgstr "Deposit failed."

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
msgid "<0>Set Recommended Impact: {0}</0>."
msgstr "<0>Set Recommended Impact: {0}</0>."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Defi Llama"
msgstr "Defi Llama"

#: src/pages/Exchange/Exchange.tsx
msgid "Orders cancelled."
msgstr "Orders cancelled."

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "Last Rebalance"
msgstr "Last Rebalance"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel Limit"
msgstr "Cancel Limit"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "V2 Claim"
msgstr "V2 Claim"

#: src/components/Exchange/OrdersToa.jsx
msgid "Accept that orders are not guaranteed to execute and trigger orders may not settle at the trigger price"
msgstr "Accept that orders are not guaranteed to execute and trigger orders may not settle at the trigger price"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Select a market"
msgstr "Select a market"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "The buyable cap for the pool GM: {0} in {1} [{2}] has been reached. Please choose a different pool or reduce the buy size."
msgstr "The buyable cap for the pool GM: {0} in {1} [{2}] has been reached. Please choose a different pool or reduce the buy size."

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High External Swap Impact"
msgstr "High External Swap Impact"

#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "No trades yet"
msgstr "No trades yet"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
#: src/components/Synthetics/PositionSeller/rows/AllowedSlippageRow.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AllowedSlippageRow.tsx
msgid "Allowed Slippage"
msgstr "Allowed Slippage"

#: src/components/Exchange/OrderEditor.jsx
msgid "Order update failed."
msgstr "Order update failed."

#: src/components/Glp/GlpSwap.jsx
msgid "Waiting for Approval"
msgstr "Waiting for Approval"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "{longOrShort} positions {fundingAction} a funding fee of {fundingRate} per hour and do not pay a borrow fee."
msgstr "{longOrShort} positions {fundingAction} a funding fee of {fundingRate} per hour and do not pay a borrow fee."

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Short TP/SL: {0} a short position when the trigger price is reached."
msgstr "{typeString} Short TP/SL: {0} a short position when the trigger price is reached."

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Community-led Telegram groups."
msgstr "Community-led Telegram groups."

#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
msgid "{longShortText} {0} Open Interest"
msgstr "{longShortText} {0} Open Interest"

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "COMP."
msgstr "COMP."

#: src/pages/Stake/Vesting.tsx
msgid "You have no GMX tokens to claim."
msgstr "You have no GMX tokens to claim."

#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Settled Funding Fees"
msgstr "Settled Funding Fees"

#: src/pages/LeaderboardPage/components/CompetitionCountdown.tsx
msgid "Ends in"
msgstr "Ends in"

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Please input a referral code to benefit from fee discounts."
msgstr "Please input a referral code to benefit from fee discounts."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Deposit"
msgstr "Failed Deposit"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "Distribution happens in two GLV variants to mirror GLP's multi-asset exposure: one variant is optimized for ETH-based markets (50% ETH / 50% USDC) and the other for BTC-based markets (50% BTC / 50% USDC). This allocation reflects the composition of recovered funds and allows for dynamic shifting of GLV liquidity to all top GMX markets to enhance your yield."
msgstr "Distribution happens in two GLV variants to mirror GLP's multi-asset exposure: one variant is optimized for ETH-based markets (50% ETH / 50% USDC) and the other for BTC-based markets (50% BTC / 50% USDC). This allocation reflects the composition of recovered funds and allows for dynamic shifting of GLV liquidity to all top GMX markets to enhance your yield."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Request Market Swap"
msgstr "Request Market Swap"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "Insufficient liquidity in the {0} market pool. Select a different pool for this market.{1}"
msgstr "Insufficient liquidity in the {0} market pool. Select a different pool for this market.{1}"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "App disabled, pending {0} upgrade"
msgstr "App disabled, pending {0} upgrade"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Rebates earned by this account as an affiliate."
msgstr "Rebates earned by this account as an affiliate."

#: src/components/Glp/GlpSwap.jsx
msgid "Swap {0} on 1inch"
msgstr "Swap {0} on 1inch"

#: src/components/Glp/GlpSwap.jsx
msgid "{0} GLP bought with {1} {2}!"
msgstr "{0} GLP bought with {1} {2}!"

#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
#: src/pages/Stake/UnstakeModal.tsx
#: src/pages/Stake/UnstakeModal.tsx
msgid "Unstake"
msgstr "Unstake"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Debug Settings"
msgstr "Debug Settings"

#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "More Options"
msgstr "More Options"

#: src/components/TokenCard/TokenCard.tsx
msgid "GLV is the liquidity provider token for GMX V2 vaults. Consist of several GM tokens and accrues fees generated by them."
msgstr "GLV is the liquidity provider token for GMX V2 vaults. Consist of several GM tokens and accrues fees generated by them."

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees."
msgstr "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees."

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "<0>every</0> {hours} hours{0}"
msgstr "<0>every</0> {hours} hours{0}"

#: src/components/Referrals/TradersStats.tsx
msgid "For trades on V1, this discount will be airdropped to your account every Wednesday. On V2, discounts are applied automatically and will reduce your fees when you make a trade."
msgstr "For trades on V1, this discount will be airdropped to your account every Wednesday. On V2, discounts are applied automatically and will reduce your fees when you make a trade."

#: src/components/DebugExpressSettings/DebugSwapsSettings.tsx
#: src/components/DebugSwapsSettings/DebugSwapsSettings.tsx
msgid "Fail External Swaps"
msgstr "Fail External Swaps"

#: src/domain/synthetics/orders/utils.tsx
msgid "Swap {fromTokenText} for {toTokenText}"
msgstr "Swap {fromTokenText} for {toTokenText}"

#: src/components/Exchange/SwapBox.jsx
#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
msgid "Swap submitted."
msgstr "Swap submitted."

#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "PnL"
msgstr "PnL"

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Express Trading is not available using network's native token {0}. Consider using {1} instead."
msgstr "Express Trading is not available using network's native token {0}. Consider using {1} instead."

#: src/components/Synthetics/TradeHistory/keys.ts
#: src/domain/synthetics/orders/utils.tsx
msgid "Market Increase"
msgstr "Market Increase"

#: src/components/Synthetics/Claims/ClaimsHistory.tsx
msgid "No claims yet"
msgstr "No claims yet"

#: src/components/TVChartContainer/DynamicLine.tsx
msgid "Cancel Order"
msgstr "Cancel Order"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
#: src/components/Synthetics/PositionEditor/types.ts
#: src/components/Synthetics/TradeHistory/keys.ts
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Withdraw"
msgstr "Withdraw"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update Stop Market"
msgstr "Update Stop Market"

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "Vested Claimable GMX"
msgstr "Vested Claimable GMX"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy {nativeTokenSymbol}"
msgstr "Buy {nativeTokenSymbol}"

#: src/components/AddressDropdown/AddressDropdown.tsx
msgid "View in Explorer"
msgstr "View in Explorer"

#: src/components/AprInfo/AprInfo.tsx
msgid "Bonus APR"
msgstr "Bonus APR"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Shift request sent"
msgstr "Shift request sent"

#: src/pages/Jobs/Jobs.jsx
msgid "GMX is not actively looking for new hires at the moment. However, if you think you can contribute to the project, please email <0>jobs@gmx.io</0>."
msgstr "GMX is not actively looking for new hires at the moment. However, if you think you can contribute to the project, please email <0>jobs@gmx.io</0>."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "You have multiple existing Increase {longOrShortText} {0} limit orders"
msgstr "You have multiple existing Increase {longOrShortText} {0} limit orders"

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "After you scan, a connection prompt will appear for you to connect your wallet."
msgstr "After you scan, a connection prompt will appear for you to connect your wallet."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "You can transfer AVAX from other networks to Avalanche using any of the below options:"
msgstr "You can transfer AVAX from other networks to Avalanche using any of the below options:"

#: src/pages/Stake/Vesting.tsx
msgid "Unsupported network"
msgstr "Unsupported network"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Opening..."
msgstr "Opening..."

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Traders Referred on Avalanche"
msgstr "Traders Referred on Avalanche"

#: src/components/Exchange/PositionSeller.jsx
msgid "Trigger order disabled, pending {0} upgrade"
msgstr "Trigger order disabled, pending {0} upgrade"

#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Funding Fees"
msgstr "Funding Fees"

#: src/domain/tokens/approveTokens.tsx
msgid "Approval failed"
msgstr "Approval failed"

#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/pages/Dashboard/OverviewCard.tsx
#: src/pages/Home/Home.tsx
msgid "Open Interest"
msgstr "Open Interest"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Updating settings..."
msgstr "Updating settings..."

#: src/components/Exchange/SwapBox.jsx
msgid "The position will be opened at {0} USD with a max slippage of {1}%.<0/><1/>The slippage amount can be configured under Settings, found by clicking on your address at the top right of the page after connecting your wallet.<2/><3/><4>Read more</4>."
msgstr "The position will be opened at {0} USD with a max slippage of {1}%.<0/><1/>The slippage amount can be configured under Settings, found by clicking on your address at the top right of the page after connecting your wallet.<2/><3/><4>Read more</4>."

#: src/components/Referrals/TradersStats.tsx
msgid "Active Referral Code"
msgstr "Active Referral Code"

#: src/components/OneClickAdvancedSettings/OneClickAdvancedSettings.tsx
msgid "Save One-Click Trading settings"
msgstr "Save One-Click Trading settings"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Please switch your network to Arbitrum."
msgstr "Please switch your network to Arbitrum."

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "The position would be immediately liquidated upon order execution. Try reducing the size."
msgstr "The position would be immediately liquidated upon order execution. Try reducing the size."

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "BUYABLE"
msgstr "BUYABLE"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create TWAP"
msgstr "Create TWAP"

#: src/components/Exchange/PositionEditor.jsx
msgid "Enabling Leverage"
msgstr "Enabling Leverage"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Invalid Receiver Address"
msgstr "Invalid Receiver Address"

#: src/components/Exchange/PositionSeller.jsx
msgid "Collateral is not enough to cover pending Fees. Please uncheck \"Keep Leverage\" to pay the Fees with the realized PnL."
msgstr "Collateral is not enough to cover pending Fees. Please uncheck \"Keep Leverage\" to pay the Fees with the realized PnL."

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "You have yet to reach the minimum \"Capital Used\" of {0} to qualify for the rankings."
msgstr "You have yet to reach the minimum \"Capital Used\" of {0} to qualify for the rankings."

#: src/components/InterviewToast/InterviewToast.tsx
msgid "We value your experience as GMX Liquidity Provider and invite you to participate in an anonymous one-on-one chat."
msgstr "We value your experience as GMX Liquidity Provider and invite you to participate in an anonymous one-on-one chat."

#: src/components/Synthetics/GmList/GlvList.tsx
#: src/components/Synthetics/GmList/GmList.tsx
msgid "TVL (SUPPLY)"
msgstr "TVL (SUPPLY)"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Decrease the leverage to match the max. allowed leverage."
msgstr "Decrease the leverage to match the max. allowed leverage."

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Shorts"
msgstr "Shorts"

#: src/pages/PriceImpactRebatesStats/PriceImpactRebatesStats.tsx
msgid "Prev"
msgstr "Prev"

#: src/pages/Pools/PoolsTimeRangeFilter.tsx
msgid "Last 180d"
msgstr "Last 180d"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Unknown buy GM order"
msgstr "Unknown buy GM order"

#: src/components/Synthetics/PositionSeller/rows/AllowedSlippageRow.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AllowedSlippageRow.tsx
msgid "You can edit the default Allowed Slippage in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than -{0}, may result in failed orders if prices are volatile."
msgstr "You can edit the default Allowed Slippage in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than -{0}, may result in failed orders if prices are volatile."

#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "RPnL ($)"
msgstr "RPnL ($)"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "There is no price impact. There is a single<0/>execution price for increasing longs or<1/>decreasing shorts for this size."
msgstr "There is no price impact. There is a single<0/>execution price for increasing longs or<1/>decreasing shorts for this size."

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "After claiming, the esGMX tokens will be airdropped to your account on the selected network within 7 days."
msgstr "After claiming, the esGMX tokens will be airdropped to your account on the selected network within 7 days."

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
msgid "Buy GLV"
msgstr "Buy GLV"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed TWAP Part"
msgstr "Failed TWAP Part"

#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "Impact+Fees"
msgstr "Impact+Fees"

#: src/components/TVChartContainer/constants.ts
msgid "TP - Short Dec."
msgstr "TP - Short Dec."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Compass Labs GM Token Dashboard"
msgstr "Compass Labs GM Token Dashboard"

#: src/components/Exchange/TradeHistory.jsx
msgid "Request increase {0} {longOrShortText}, +{1} USD, Acceptable Price: {2} {3} USD"
msgstr "Request increase {0} {longOrShortText}, +{1} USD, Acceptable Price: {2} {3} USD"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/CollateralSelector/CollateralSelector.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/CollateralSelectorRow.tsx
msgid "Collateral In"
msgstr "Collateral In"

#: src/pages/Dashboard/GmCard.tsx
msgid "GM Markets"
msgstr "GM Markets"

#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Your opinions and experiences matter to us. Your feedback helps us understand what we are doing well and where we can make enhancements."
msgstr "Your opinions and experiences matter to us. Your feedback helps us understand what we are doing well and where we can make enhancements."

#: src/components/Exchange/UsefulLinks.tsx
msgid "Trading guide"
msgstr "Trading guide"

#: src/context/SyntheticsStateContext/selectors/chartSelectors/selectChartLines.tsx
msgid "Open {longOrShortText} - {marketIndexName}"
msgstr "Open {longOrShortText} - {marketIndexName}"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "TRADING Airdrop"
msgstr "TRADING Airdrop"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be short {indexSymbol} from your short position, while being long {collateralSymbol} from your {collateralSymbol} collateral. This can be useful for delta-neutral strategies to earn funding fees."
msgstr "You will be short {indexSymbol} from your short position, while being long {collateralSymbol} from your {collateralSymbol} collateral. This can be useful for delta-neutral strategies to earn funding fees."

#: src/components/Referrals/TradersStats.tsx
msgid "Rebates earned by this account as a trader."
msgstr "Rebates earned by this account as a trader."

#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/ExecutionPriceRow.tsx
#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
#: src/pages/Dashboard/WeightText.tsx
msgid "Read more"
msgstr "Read more"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "This Year"
msgstr "This Year"

#: src/components/Exchange/TradeHistory.jsx
msgid ""
"{actionDisplay} {0} {longOrShortText},\n"
"-{1} USD,\n"
"{2} Price: {3} USD"
msgstr ""
"{actionDisplay} {0} {longOrShortText},\n"
"-{1} USD,\n"
"{2} Price: {3} USD"

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Vesting Status"
msgstr "Vesting Status"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "You have an active Limit Order to Increase {longOrShortText} {sizeInToken} {0} (${1}) at price ${2}"
msgstr "You have an active Limit Order to Increase {longOrShortText} {sizeInToken} {0} (${1}) at price ${2}"

#: src/domain/synthetics/claimHistory/claimPriceImpactRebate.ts
msgid "Claiming Price Impact Rebate..."
msgstr "Claiming Price Impact Rebate..."

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Negative funding fees are automatically settled against the collateral and impact the liquidation price. Positive funding fees can be claimed under the claims tab."
msgstr "Negative funding fees are automatically settled against the collateral and impact the liquidation price. Positive funding fees can be claimed under the claims tab."

#: src/pages/Stake/Stake.tsx
msgid "Unstake esGMX"
msgstr "Unstake esGMX"

#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "The actual trigger price at which order gets filled will depend on fees and price impact at the time of execution to guarantee that you receive the minimum receive amount."
msgstr "The actual trigger price at which order gets filled will depend on fees and price impact at the time of execution to guarantee that you receive the minimum receive amount."

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "Why do I receive two different GLV tokens?"
msgstr "Why do I receive two different GLV tokens?"

#: src/components/Exchange/PositionDropdown.tsx
msgid "Set TP/SL"
msgstr "Set TP/SL"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "The Execution Price didn't meet the Acceptable Price condition. The Order will get filled when the condition is met."
msgstr "The Execution Price didn't meet the Acceptable Price condition. The Order will get filled when the condition is met."

#: src/components/Synthetics/PositionEditor/PositionEditorAdvancedRows.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
msgid "Initial Collateral (Collateral excluding Borrow and Funding Fee)."
msgstr "Initial Collateral (Collateral excluding Borrow and Funding Fee)."

#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
msgid "Net Rate / 1h"
msgstr "Net Rate / 1h"

#: src/pages/Stake/ClaimModal.tsx
msgid "Claim esGMX Rewards"
msgstr "Claim esGMX Rewards"

#: src/pages/Stake/Stake.tsx
msgid "Trading incentives program is live on {avalancheLink}."
msgstr "Trading incentives program is live on {avalancheLink}."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sending sell request"
msgstr "Sending sell request"

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "NA"
msgstr "NA"

#: src/components/Synthetics/TradeBox/TradeBoxRows/CollateralSelectorRow.tsx
msgid "You have an existing position with {0} as collateral. This action will not apply for that position. <0>Switch to {1} collateral</0>."
msgstr "You have an existing position with {0} as collateral. This action will not apply for that position. <0>Switch to {1} collateral</0>."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Trigger price for the order."
msgstr "Trigger price for the order."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ExchangeTVChart.jsx
#: src/components/Exchange/ExchangeTVChart.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/MarketWithDirectionLabel/MarketWithDirectionLabel.tsx
#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeRow.tsx
#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
#: src/context/SyntheticsStateContext/selectors/chartSelectors/selectChartLines.tsx
#: src/domain/synthetics/orders/utils.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Short"
msgstr "Short"

#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "PnL ($)"
msgstr "PnL ($)"

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "GMX Market Tokens"
msgstr "GMX Market Tokens"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
msgid "Stop Market price is above mark price"
msgstr "Stop Market price is above mark price"

#: src/context/PendingTxnsContext/PendingTxnsContext.tsx
msgid "Txn failed. <0>View</0>."
msgstr "Txn failed. <0>View</0>."

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Affiliate Vault"
msgstr "Affiliate Vault"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Enter a price"
msgstr "Enter a price"

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Updating..."
msgstr "Updating..."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Market Increase"
msgstr "Failed Market Increase"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "EIP-4844 Competition"
msgstr "EIP-4844 Competition"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Liq. Price"
msgstr "Liq. Price"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Trading Pair Price Alerts"
msgstr "Trading Pair Price Alerts"

#: src/components/Exchange/OrdersList.jsx
msgid "You will receive at least {0} {1} if this order is executed. The exact execution price may vary depending on fees at the time the order is executed."
msgstr "You will receive at least {0} {1} if this order is executed. The exact execution price may vary depending on fees at the time the order is executed."

#: src/components/Common/SEO.tsx
msgid "GMX | Decentralized Perpetual Exchange"
msgstr "GMX | Decentralized Perpetual Exchange"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "<0>Botanix</0> currently only supports"
msgstr "<0>Botanix</0> currently only supports"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "No position"
msgstr "No position"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Buy GLP"
msgstr "Buy GLP"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Cancel failed"
msgstr "Cancel failed"

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
msgid "{daysConsidered}d Earned Fees"
msgstr "{daysConsidered}d Earned Fees"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Fulfilling order request"
msgstr "Fulfilling order request"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient {0} balance to pay for gas"
msgstr "Insufficient {0} balance to pay for gas"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "You can currently vest a maximum of {0} esGMX tokens at a ratio of {1} {stakingToken} to 1 esGMX."
msgstr "You can currently vest a maximum of {0} esGMX tokens at a ratio of {1} {stakingToken} to 1 esGMX."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy AVAX directly to Avalanche or transfer it there."
msgstr "Buy AVAX directly to Avalanche or transfer it there."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Open Ocean"
msgstr "Open Ocean"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBox.tsx
msgid "Single"
msgstr "Single"

#: src/domain/synthetics/orders/prepareOrderTxn.ts
msgid "Error preparing transaction. Provider is not defined"
msgstr "Error preparing transaction. Provider is not defined"

#: src/components/Synthetics/Claims/ClaimableCardUI.tsx
msgid "Funding fees"
msgstr "Funding fees"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient liquidity in GM Pool"
msgstr "Insufficient liquidity in GM Pool"

#: src/components/Exchange/ExchangeBanner.jsx
msgid "Trade on GMX and win <0>$250.000</0> in prizes! Live until November 30th, <1>click here</1> to learn more."
msgstr "Trade on GMX and win <0>$250.000</0> in prizes! Live until November 30th, <1>click here</1> to learn more."

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "tBTC LP incentives"
msgstr "tBTC LP incentives"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "Failed to claim funds"
msgstr "Failed to claim funds"

#: src/components/ModalViews/RedirectModal.tsx
msgid "You are leaving GMX.io and will be redirected to a third party, independent website."
msgstr "You are leaving GMX.io and will be redirected to a third party, independent website."

#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Accrued Borrow Fee"
msgstr "Accrued Borrow Fee"

#: src/domain/synthetics/trade/useMaxAutoCancelOrdersState.tsx
msgid "Read more."
msgstr "Read more."

#: src/components/AddressDropdown/AddressDropdown.tsx
#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "PnL Analysis"
msgstr "PnL Analysis"

#: src/components/Synthetics/GmList/GmListItem.tsx
msgid "View Details"
msgstr "View Details"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "No swap path available. <0>Swap {0} to {swapToTokenSymbol}</0>, then to {1}."
msgstr "No swap path available. <0>Swap {0} to {swapToTokenSymbol}</0>, then to {1}."

#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
msgid "Longs"
msgstr "Longs"

#: src/components/Exchange/PositionEditor.jsx
msgid "Deposit submitted."
msgstr "Deposit submitted."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Unknown sell GM order"
msgstr "Unknown sell GM order"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "<0>Notifications are provided by Notifi and not affiliated with GMX. By subscribing, you agree that info you provide to Notifi will be governed by its </0><1>Privacy Policy</1><2> and </2><3>Terms of Use</3>."
msgstr "<0>Notifications are provided by Notifi and not affiliated with GMX. By subscribing, you agree that info you provide to Notifi will be governed by its </0><1>Privacy Policy</1><2> and </2><3>Terms of Use</3>."

#: src/components/TokenCard/TokenCard.tsx
msgid "{arbitrumLink} and {avalancheLink} GLV Pools are <0>incentivized{sparkle}.</0>"
msgstr "{arbitrumLink} and {avalancheLink} GLV Pools are <0>incentivized{sparkle}.</0>"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
#~ msgid "Claimed {0} successfully"
#~ msgstr "Claimed {0} successfully"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Long Limit: {0} a long position when the price is below the trigger price."
msgstr "{typeString} Long Limit: {0} a long position when the price is below the trigger price."

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "{0} is required for collateral.<0/><1/>There is no swap path found for {1} to {2} within GMX.<2/><3/><4>You can buy {3} on 1inch.</4>"
msgstr "{0} is required for collateral.<0/><1/>There is no swap path found for {1} to {2} within GMX.<2/><3/><4>You can buy {3} on 1inch.</4>"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "You have an existing position in the {0} market pool.<0><1>Switch to {1} market pool</1>.</0>"
msgstr "You have an existing position in the {0} market pool.<0><1>Switch to {1} market pool</1>.</0>"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Capital Used"
msgstr "Capital Used"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Max 10 symbols in name"
msgstr "Max 10 symbols in name"

#: src/pages/Dashboard/StatsCard.tsx
msgid "Users"
msgstr "Users"

#: src/components/GasPaymentTokenSelector/GasPaymentTokenSelector.tsx
#: src/components/GasPaymentTokenSelector/GasPaymentTokenSelector.tsx
msgid "Gas Payment Token"
msgstr "Gas Payment Token"

#: src/components/DepthChart/DepthChartTooltip.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
#: src/components/Synthetics/ExecutionPriceRow.tsx
#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Price Impact"
msgstr "Price Impact"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Select a token"
msgstr "Select a token"

#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "Exposure to Market Traders’ PnL"
msgstr "Exposure to Market Traders’ PnL"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Optimal"
msgstr "Optimal"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "UI Fee"
msgstr "UI Fee"

#: src/components/Errors/errorToasts.tsx
#: src/domain/synthetics/orders/simulateExecuteTxn.tsx
#: src/domain/synthetics/orders/simulateExecuteTxn.tsx
msgid "Execute order simulation failed."
msgstr "Execute order simulation failed."

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Invalid Transfer Addresses: Please check the url."
msgstr "Invalid Transfer Addresses: Please check the url."

#: src/pages/Dashboard/MarketsListV1.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "GLP Index Composition"
msgstr "GLP Index Composition"

#: src/domain/synthetics/positions/utils.ts
msgid "TP"
msgstr "TP"

#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
msgid "<0>Claimable Funding Fee.</0>"
msgstr "<0>Claimable Funding Fee.</0>"

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "Log in to your Binance app and tap [Wallets]. Go to [Web3]."
msgstr "Log in to your Binance app and tap [Wallets]. Go to [Web3]."

#: src/components/Synthetics/Claims/ClaimableCard.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Claimable"
msgstr "Claimable"

#: src/components/Exchange/OrdersToa.jsx
msgid "Additionally, trigger orders are market orders and are not guaranteed to settle at the trigger price."
msgstr "Additionally, trigger orders are market orders and are not guaranteed to settle at the trigger price."

#: src/components/Header/AppHeaderLinks.tsx
#: src/components/Header/HomeHeaderLinks.tsx
msgid "Docs"
msgstr "Docs"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Trading Stats"
msgstr "GMX Trading Stats"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Creating Order..."
msgstr "Creating Order..."

#: src/components/Exchange/PositionEditor.jsx
msgid "Deposit disabled, pending {0} upgrade"
msgstr "Deposit disabled, pending {0} upgrade"

#: src/pages/Jobs/Jobs.jsx
msgid "Jobs"
msgstr "Jobs"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Options Strategies"
msgstr "Decentralized Options Strategies"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Technical Announcements"
msgstr "GMX Technical Announcements"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Stop Market"
msgstr "Failed Stop Market"

#: src/components/AddressDropdown/AddressDropdown.tsx
msgid "Address copied to your clipboard"
msgstr "Address copied to your clipboard"

#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "Version and Network"
msgstr "Version and Network"

#: src/components/Header/AppHeaderLinks.tsx
#: src/components/NetworkDropdown/NetworkDropdown.tsx
#: src/components/NetworkDropdown/NetworkDropdown.tsx
#: src/components/SettingsModal/SettingsModal.tsx
msgid "Settings"
msgstr "Settings"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Compass Labs Trading Simulations"
msgstr "Compass Labs Trading Simulations"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Amount of traders you referred."
msgstr "Amount of traders you referred."

#: src/components/Exchange/PositionSeller.jsx
msgid "GMX V1 only supports closing positions using market orders. For advanced trading features, use GMX V2."
msgstr "GMX V1 only supports closing positions using market orders. For advanced trading features, use GMX V2."

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
#: src/domain/synthetics/positions/utils.ts
msgid "Take Profit"
msgstr "Take Profit"

#: src/components/Exchange/PositionSeller.jsx
msgid "Close submitted!"
msgstr "Close submitted!"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Hour(s)"
msgstr "Hour(s)"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient {0} liquidity"
msgstr "Insufficient {0} liquidity"

#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Creator"
msgstr "Creator"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Derivatives Portfolio Tracker"
msgstr "Derivatives Portfolio Tracker"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create Limit"
msgstr "Create Limit"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Transfer already initiated"
msgstr "Transfer already initiated"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
#: src/pages/Stake/VesterWithdrawModal.tsx
msgid "Withdraw submitted."
msgstr "Withdraw submitted."

#: src/components/Referrals/AddAffiliateCode.jsx
#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Enter a code"
msgstr "Enter a code"

#: src/components/Synthetics/GmList/GmListItem.tsx
msgid "Details"
msgstr "Details"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Umami DAO"
msgstr "Umami DAO"

#: src/components/Exchange/OrdersList.jsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Order"
msgstr "Order"

#: src/pages/Dashboard/GmxCard.tsx
msgid "Staked on Avalanche"
msgstr "Staked on Avalanche"

#: src/components/Footer/constants.ts
#: src/components/Footer/constants.ts
msgid "Media Kit"
msgstr "Media Kit"

#: src/pages/Home/Home.tsx
msgid "Reduce Liquidation Risks"
msgstr "Reduce Liquidation Risks"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "UniDex Leverage"
msgstr "UniDex Leverage"

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "collateral"
msgstr "collateral"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/GmList/GlvList.tsx
#: src/components/Synthetics/GmList/GmList.tsx
msgid "WALLET"
msgstr "WALLET"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
msgid "No open orders"
msgstr "No open orders"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Traders Referred on Avalanche Fuji"
msgstr "Traders Referred on Avalanche Fuji"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Claim V2 Rebates from your referred Traders."
msgstr "Claim V2 Rebates from your referred Traders."

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Total value of tokens in GM Pools."
msgstr "Total value of tokens in GM Pools."

#: src/components/Glp/GlpSwap.jsx
msgid "Reserved"
msgstr "Reserved"

#: src/components/TokenCard/TokenCard.tsx
#: src/components/TokenCard/TokenCard.tsx
msgid "Botanix"
msgstr "Botanix"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Price below Liq. Price"
msgstr "Price below Liq. Price"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Take Profit / Stop Loss"
msgstr "Take Profit / Stop Loss"

#: src/domain/tokens/approveTokens.tsx
msgid "There is not enough {0} in your account on {networkName} to send this transaction.<0/><1/><2>Buy or Transfer {1} to {networkName}</2>"
msgstr "There is not enough {0} in your account on {networkName} to send this transaction.<0/><1/><2>Buy or Transfer {1} to {networkName}</2>"

#: src/components/TVChartContainer/constants.ts
msgid "SL - Long Dec."
msgstr "SL - Long Dec."

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Airdrop"
msgstr "Airdrop"

#: src/pages/Stake/UnstakeModal.tsx
msgid "Unstake submitted!"
msgstr "Unstake submitted!"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "This competition is held on the {0} network. <0>Change your network</0> to participate."
msgstr "This competition is held on the {0} network. <0>Change your network</0> to participate."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create Stop Loss"
msgstr "Create Stop Loss"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Failed to generate session"
msgstr "Failed to generate session"

#: src/pages/LeaderboardPage/components/CompetitionCountdown.tsx
msgid "This competition has ended."
msgstr "This competition has ended."

#: src/components/Synthetics/MarketsList/NetFeeTooltip.tsx
#: src/components/Synthetics/MarketsList/NetFeeTooltip.tsx
msgid "Shorts Net Rate / 1h"
msgstr "Shorts Net Rate / 1h"

#: src/components/Synthetics/GmList/GlvList.tsx
msgid "GLV Vaults"
msgstr "GLV Vaults"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX (Portuguese)"
msgstr "GMX (Portuguese)"

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "<0>Stake GMX</0> and earn {gmxAvgAprText} APR"
msgstr "<0>Stake GMX</0> and earn {gmxAvgAprText} APR"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Mozaic Finance"
msgstr "Mozaic Finance"

#: src/pages/Exchange/Exchange.tsx
msgid "Withdrew {0} USD from {tokenSymbol} {longOrShortText}."
msgstr "Withdrew {0} USD from {tokenSymbol} {longOrShortText}."

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Accrued Funding Fee."
msgstr "Accrued Funding Fee."

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
#: src/pages/Stake/VesterWithdrawModal.tsx
msgid "Withdraw failed."
msgstr "Withdraw failed."

#: src/pages/Stake/ClaimModal.tsx
msgid "Pending GMX approval"
msgstr "Pending GMX approval"

#: src/components/Synthetics/MarketsList/MarketsList.tsx
msgid "No markets found."
msgstr "No markets found."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "ODOS"
msgstr "ODOS"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Substack"
msgstr "GMX Substack"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Positions Bot"
msgstr "GMX Positions Bot"

#: src/components/Referrals/TradersStats.tsx
msgid "Edit Referral Code"
msgstr "Edit Referral Code"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Take Profit"
msgstr "Execute Take Profit"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Stryke"
msgstr "Stryke"

#: src/components/Errors/errorToasts.tsx
msgid "External swap is temporarily disabled. Please try again."
msgstr "External swap is temporarily disabled. Please try again."

#: src/components/Stake/GMXAprTooltip.tsx
msgid "GMX APR"
msgstr "GMX APR"

#: src/pages/AccountDashboard/VersionNetworkSwitcherRow.tsx
msgid "Switch to:"
msgstr "Switch to:"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "{orderTypeText} {visualMultiplierPrefix}{0} {longShortText}: {sign}{1}"
msgstr "{orderTypeText} {visualMultiplierPrefix}{0} {longShortText}: {sign}{1}"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "GLV (GMX Liquidity Vaults) should be seen as GMX V2’s improved version of GLP. It is a yield-optimizing crypto-index token that"
msgstr "GLV (GMX Liquidity Vaults) should be seen as GMX V2’s improved version of GLP. It is a yield-optimizing crypto-index token that"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "You have an existing limit order in the {0} market pool.<0><1>Switch to {1} market pool</1>.</0>"
msgstr "You have an existing limit order in the {0} market pool.<0><1>Switch to {1} market pool</1>.</0>"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Decreasing"
msgstr "Decreasing"

#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
msgid "You have set a high allowed slippage. The current swap impact including fees is {0}."
msgstr "You have set a high allowed slippage. The current swap impact including fees is {0}."

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Create Referral Code"
msgstr "Create Referral Code"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Combined take profits are at maximum (100%). Decrease existing values to add more orders."
msgstr "Combined take profits are at maximum (100%). Decrease existing values to add more orders."

#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "Networks"
msgstr "Networks"

#: src/components/Exchange/TradeHistory.jsx
msgid "{0}: {1}, Price: {priceDisplay}"
msgstr "{0}: {1}, Price: {priceDisplay}"

#: src/components/Synthetics/GmList/GmList.tsx
#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "POOL"
msgstr "POOL"

#: src/components/Header/HomeHeaderLinks.tsx
msgid "Voting"
msgstr "Voting"

#: src/components/Exchange/TradeHistory.jsx
msgid "This position was liquidated as the max leverage of 100x was exceeded."
msgstr "This position was liquidated as the max leverage of 100x was exceeded."

#: src/pages/SyntheticsFallbackPage/SyntheticsFallbackPage.tsx
msgid "<0>Switch to:</0>"
msgstr "<0>Switch to:</0>"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Short Limit: {0} a short position when the price is above the trigger price."
msgstr "{typeString} Short Limit: {0} a short position when the price is above the trigger price."

#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "No trades match the selected filters"
msgstr "No trades match the selected filters"

#: src/components/Exchange/TradeHistory.jsx
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
msgid "Decreased"
msgstr "Decreased"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "Updating {orderText}."
msgstr "Updating {orderText}."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/domain/synthetics/orders/utils.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Decrease"
msgstr "Decrease"

#: src/components/Exchange/PositionSeller.jsx
msgid "Leftover collateral below 5 USD"
msgstr "Leftover collateral below 5 USD"

#: src/lib/legacy.ts
msgid "Order cannot be executed as it would reduce the position's leverage below 1"
msgstr "Order cannot be executed as it would reduce the position's leverage below 1"

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "Existing Executable Trigger Orders"
msgstr "Existing Executable Trigger Orders"

#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Weight"
msgstr "Weight"

#: src/components/Exchange/PositionShare.tsx
msgid "Link copied to clipboard."
msgstr "Link copied to clipboard."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Max slippage precision is -0.01%"
msgstr "Max slippage precision is -0.01%"

#: src/components/Exchange/ExchangeTVChart.jsx
msgid "Dec."
msgstr "Dec."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Weekly Updates"
msgstr "GMX Weekly Updates"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be long {indexSymbol} only from your long position."
msgstr "You will be long {indexSymbol} only from your long position."

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Total active: {openTotal}, executed: {executedTotal}, cancelled: {cancelledTotal}"
msgstr "Total active: {openTotal}, executed: {executedTotal}, cancelled: {cancelledTotal}"

#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
msgid "24h Low"
msgstr "24h Low"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "Chain Icon"
msgstr "Chain Icon"

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "Settle request for {0, plural, one {# position} other {# positions}} sent"
msgstr "Settle request for {0, plural, one {# position} other {# positions}} sent"

#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Price on Arbitrum"
msgstr "Price on Arbitrum"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "GM can be sold for {0} for this market up to the specified selling caps. The remaining tokens in the pool are reserved for currently open positions."
msgstr "GM can be sold for {0} for this market up to the specified selling caps. The remaining tokens in the pool are reserved for currently open positions."

#: src/components/Synthetics/AccruedPositionPriceImpactRebateModal/AccruedPositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
msgid "REBATE"
msgstr "REBATE"

#: src/components/Synthetics/TradeBox/TradeBoxRows/AvailableLiquidityRow.tsx
msgid "There may not be sufficient liquidity to execute your order when the Min. Receive are met."
msgstr "There may not be sufficient liquidity to execute your order when the Min. Receive are met."

#: src/components/Synthetics/TVChart/Chart.tsx
msgid "DEPTH"
msgstr "DEPTH"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Total Trades"
msgstr "Total Trades"

#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "Market Composition"
msgstr "Market Composition"

#: src/components/Errors/errorToasts.tsx
msgid "<0>Permit signature is invalid. Please try again.</0>"
msgstr "<0>Permit signature is invalid. Please try again.</0>"

#: src/components/NpsModal/NpsModal.tsx
msgid "Enter your answer here"
msgstr "Enter your answer here"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Firebird Finance"
msgstr "Firebird Finance"

#: src/pages/Stake/Stake.tsx
msgid "Stake GMX"
msgstr "Stake GMX"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Shifting from <0><1>GM: {fromIndexName}</1><2>{fromPoolName}</2></0> to <3><4>GM: {toIndexName}</4><5>{toPoolName}</5></3>"
msgstr "Shifting from <0><1>GM: {fromIndexName}</1><2>{fromPoolName}</2></0> to <3><4>GM: {toIndexName}</4><5>{toPoolName}</5></3>"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Long TWAP: {0} a long position in evenly distributed parts over a specified time."
msgstr "{typeString} Long TWAP: {0} a long position in evenly distributed parts over a specified time."

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Referral code updated!"
msgstr "Referral code updated!"

#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "Favorites"
msgstr "Favorites"

#: src/components/Exchange/SwapBox.jsx
msgid "Max {0} short capacity"
msgstr "Max {0} short capacity"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "The Execution Price didn't meet the Acceptable Price condition."
msgstr "The Execution Price didn't meet the Acceptable Price condition."

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Reserve Amount"
msgstr "Reserve Amount"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Fulfilling buy request"
msgstr "Fulfilling buy request"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Reason: {0}"
msgstr "Reason: {0}"

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "One-Click Approval nonce expired. Please sign a new approval."
msgstr "One-Click Approval nonce expired. Please sign a new approval."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AvailableLiquidityRow.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
msgid "Available Liquidity"
msgstr "Available Liquidity"

#: src/components/Exchange/SwapBox.jsx
msgid "A snapshot of the USD value of your {0} collateral is taken when the position is opened."
msgstr "A snapshot of the USD value of your {0} collateral is taken when the position is opened."

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
msgid "All time"
msgstr "All time"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Select your vesting option below then click \"Claim\"."
msgstr "Select your vesting option below then click \"Claim\"."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "The default number of parts for Time-Weighted Average Price (TWAP) orders."
msgstr "The default number of parts for Time-Weighted Average Price (TWAP) orders."

#: src/pages/Home/Home.tsx
msgid "Save on Costs"
msgstr "Save on Costs"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Buy order cancelled"
msgstr "Buy order cancelled"

#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
msgid "{longShortText} {0} Reserve"
msgstr "{longShortText} {0} Reserve"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Cancel newly created orders"
msgstr "Cancel newly created orders"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Delegate"
msgstr "Delegate"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Harmonix"
msgstr "Harmonix"

#: src/pages/NftWallet/NftWallet.jsx
msgid "Invalid NFT Address"
msgstr "Invalid NFT Address"

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "LIQ."
msgstr "LIQ."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GLP and GMX autocompounding vaults"
msgstr "GLP and GMX autocompounding vaults"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "esGMX OTC Market"
msgstr "esGMX OTC Market"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Leverage Trading Terminal"
msgstr "Leverage Trading Terminal"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "Execution prices for increasing shorts and<0/>decreasing longs."
msgstr "Execution prices for increasing shorts and<0/>decreasing longs."

#: src/pages/Stake/Stake.tsx
msgid "Deposit <0>GMX</0> and <1>esGMX</1> tokens to earn rewards."
msgstr "Deposit <0>GMX</0> and <1>esGMX</1> tokens to earn rewards."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "The bonus rebate is an estimate and can be up to {0}% of the open fee. It will be airdropped as {incentivesTokenTitle} tokens on a pro-rata basis. <0><1>Read more</1>.</0>"
msgstr "The bonus rebate is an estimate and can be up to {0}% of the open fee. It will be airdropped as {incentivesTokenTitle} tokens on a pro-rata basis. <0><1>Read more</1>.</0>"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "<0>The order will be executed when the oracle price is {0} {1}.</0><1/><2>Note that there may be rare cases where the order cannot be executed, for example, if the chain is down and no oracle reports are produced or if the price impact exceeds your acceptable price.</2>"
msgstr "<0>The order will be executed when the oracle price is {0} {1}.</0><1/><2>Note that there may be rare cases where the order cannot be executed, for example, if the chain is down and no oracle reports are produced or if the price impact exceeds your acceptable price.</2>"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create Stop Market"
msgstr "Create Stop Market"

#: src/components/Exchange/SwapBox.jsx
msgid "Swap submitted!"
msgstr "Swap submitted!"

#: src/components/Exchange/SwapBox.jsx
msgid "V1 trading disabled. Switch to V2"
msgstr "V1 trading disabled. Switch to V2"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V1 Avalanche"
msgstr "V1 Avalanche"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/PositionEditor/PositionEditorAdvancedRows.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
msgid "Collateral ({0})"
msgstr "Collateral ({0})"

#: src/pages/Stake/StakeModal.tsx
msgid "You will earn {0}% more rewards with this action."
msgstr "You will earn {0}% more rewards with this action."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Max Network Fee Buffer"
msgstr "Max Network Fee Buffer"

#: src/components/Exchange/OrderEditor.jsx
msgid "Order updated!"
msgstr "Order updated!"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be short {indexSymbol} from your short position, while being long {collateralSymbol} from your {collateralSymbol} collateral. The liquidation price will vary based on the price of {collateralSymbol}."
msgstr "You will be short {indexSymbol} from your short position, while being long {collateralSymbol} from your {collateralSymbol} collateral. The liquidation price will vary based on the price of {collateralSymbol}."

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "Swap Market: Swap tokens at the current market price."
msgstr "Swap Market: Swap tokens at the current market price."

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "TVL/CAP"
msgstr "TVL/CAP"

#: src/components/Synthetics/CollateralSelector/CollateralSelector.tsx
#: src/components/Synthetics/CollateralSelector/CollateralSelector.tsx
msgid "Select a pool containing {0} to use it as collateral."
msgstr "Select a pool containing {0} to use it as collateral."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Trading Simulations on GMX using DOJO"
msgstr "Trading Simulations on GMX using DOJO"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Farming"
msgstr "Yield Farming"

#: src/lib/contracts/callContract.tsx
msgid "Transaction completed!"
msgstr "Transaction completed!"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Approving..."
msgstr "Approving..."

#: src/components/Exchange/PositionSeller.jsx
msgid "Neither Collateral nor realized PnL is enough to cover pending Fees. Please close a larger position amount."
msgstr "Neither Collateral nor realized PnL is enough to cover pending Fees. Please close a larger position amount."

#: src/components/Synthetics/MarketsList/MarketsList.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "UTILIZATION"
msgstr "UTILIZATION"

#: src/components/OneClickAdvancedSettings/OneClickAdvancedSettings.tsx
msgid "One-Click Settings"
msgstr "One-Click Settings"

#: src/components/NotifyModal/NotifyModal.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Announcements"
msgstr "GMX Announcements"

#: src/components/Header/AppHeaderLinks.tsx
#: src/pages/Referrals/Referrals.tsx
#: src/pages/Referrals/Referrals.tsx
msgid "Referrals"
msgstr "Referrals"

#: src/components/Exchange/PositionSeller.jsx
msgid "Max Leverage without PnL: 100x"
msgstr "Max Leverage without PnL: 100x"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Confirm Short"
msgstr "Confirm Short"

#: src/components/Exchange/ChartTokenSelector.tsx
msgid "Short Liquidity"
msgstr "Short Liquidity"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "Order Type"
msgstr "Order Type"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sell order executed"
msgstr "Sell order executed"

#: src/domain/synthetics/orders/createStakeOrUnStakeTxn.tsx
msgid "Failed to {0}"
msgstr "Failed to {0}"

#: src/domain/synthetics/referrals/claimAffiliateRewardsTxn.ts
msgid "Affiliate Rewards Claimed"
msgstr "Affiliate Rewards Claimed"

#: src/components/Errors/errorToasts.tsx
#: src/domain/synthetics/orders/simulateExecuteTxn.tsx
msgid "Order error. Prices are currently volatile for this market, try again by <0>increasing the allowed slippage</0> under the advanced display section."
msgstr "Order error. Prices are currently volatile for this market, try again by <0>increasing the allowed slippage</0> under the advanced display section."

#: src/components/DebugExpressSettings/DebugSwapsSettings.tsx
#: src/components/DebugSwapsSettings/DebugSwapsSettings.tsx
msgid "Swap Price Impact for External Swap Threshold"
msgstr "Swap Price Impact for External Swap Threshold"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Limit / Take Profit / Stop Loss"
msgstr "Limit / Take Profit / Stop Loss"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/SwapSpreadRow.tsx
msgid "Spread"
msgstr "Spread"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "This position was liquidated as the max. leverage of {formattedMaxLeverage} was exceeded when taking into account fees."
msgstr "This position was liquidated as the max. leverage of {formattedMaxLeverage} was exceeded when taking into account fees."

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Swap {0}"
msgstr "Swap {0}"

#: src/components/Exchange/SwapBox.jsx
msgid "Swap Order submitted!"
msgstr "Swap Order submitted!"

#: src/App/MainRoutes.tsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/Claims/Claims.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftSubmitState.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Loading..."
msgstr "Loading..."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Include PnL In Leverage Display"
msgstr "Include PnL In Leverage Display"

#: src/components/Exchange/PositionsList.jsx
msgid "Share"
msgstr "Share"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Execute"
msgstr "Execute"

#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Trades"
msgstr "Trades"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "No swap path available."
msgstr "No swap path available."

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Telegram Groups"
msgstr "Telegram Groups"

#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
msgid "Search Action"
msgstr "Search Action"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Show Leverage Slider"
msgstr "Show Leverage Slider"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "Cancelling {orderText}."
msgstr "Cancelling {orderText}."

#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "CONCLUDED"
msgstr "CONCLUDED"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "Collateral Delta"
msgstr "Collateral Delta"

#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
msgid "Realized PnL after fees and price impact."
msgstr "Realized PnL after fees and price impact."

#: src/components/Exchange/ChartTokenSelector.tsx
msgid "Long Liquidity"
msgstr "Long Liquidity"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "Execution price for the order."
msgstr "Execution price for the order."

#: src/components/AprInfo/AprInfo.tsx
msgid "wstETH APR"
msgstr "wstETH APR"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram Group"
msgstr "Telegram Group"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Long TP/SL: {0} a long position when the trigger price is reached."
msgstr "{typeString} Long TP/SL: {0} a long position when the trigger price is reached."

#: src/components/Synthetics/OrderItem/TwapOrdersList/TwapOrdersList.tsx
msgid "<0>{fromTokenText} </0>{fromTokenIcon}<1> to </1>{toTokenIcon}"
msgstr "<0>{fromTokenText} </0>{fromTokenIcon}<1> to </1>{toTokenIcon}"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "Insufficient liquidity in any {0}/USD market pools for your order."
msgstr "Insufficient liquidity in any {0}/USD market pools for your order."

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "You have not traded during the selected period."
msgstr "You have not traded during the selected period."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "The trigger price for this order is based on the swap fees and price impact to guarantee that you will receive at least {toMinText} on order execution."
msgstr "The trigger price for this order is based on the swap fees and price impact to guarantee that you will receive at least {toMinText} on order execution."

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Referral code updated failed."
msgstr "Referral code updated failed."

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/MarketStats/MarketGraphs.tsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
#: src/components/Synthetics/TradeHistory/TradeHistory.tsx
#: src/pages/Dashboard/GlpCard.tsx
#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Price"
msgstr "Price"

#: src/domain/tokens/approveTokens.tsx
msgid "Permit signing was cancelled"
msgstr "Permit signing was cancelled"

#: src/components/Exchange/PositionSeller.jsx
msgid "Realized PnL insufficient for Fees"
msgstr "Realized PnL insufficient for Fees"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sending shift request"
msgstr "Sending shift request"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Yak Optimizer"
msgstr "Yield Yak Optimizer"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Incorrect Account"
msgstr "Incorrect Account"

#: src/components/Exchange/PositionEditor.jsx
msgid "Min residual collateral: 10 USD"
msgstr "Min residual collateral: 10 USD"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "GMX & Voting Power"
msgstr "GMX & Voting Power"

#: src/components/TokenCard/TokenCard.tsx
#: src/pages/Dashboard/DashboardPageTitle.tsx
#: src/pages/Dashboard/DashboardPageTitle.tsx
msgid "GMX is the utility and governance token. Accrues 30% and 27% of V1 and V2 markets generated fees, respectively."
msgstr "GMX is the utility and governance token. Accrues 30% and 27% of V1 and V2 markets generated fees, respectively."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Transferring"
msgstr "Transferring"

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "{0} GMX tokens can be claimed, use the options under the Total Rewards section to claim them."
msgstr "{0} GMX tokens can be claimed, use the options under the Total Rewards section to claim them."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GLP autocompounding vaults"
msgstr "GLP autocompounding vaults"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "TP/SL orders exceed the position"
msgstr "TP/SL orders exceed the position"

#: src/components/Glp/GlpSwap.jsx
msgid "Buy failed."
msgstr "Buy failed."

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "pay"
msgstr "pay"

#: src/pages/Dashboard/GmxCard.tsx
msgid "Total circulating supply of GMX tokens."
msgstr "Total circulating supply of GMX tokens."

#: src/pages/Dashboard/WeightText.tsx
msgid "Target Weight"
msgstr "Target Weight"

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "Winners:"
msgstr "Winners:"

#: src/components/Exchange/SwapBox.jsx
msgid "When closing the position, you can select which token you would like to receive the profits in."
msgstr "When closing the position, you can select which token you would like to receive the profits in."

#: src/domain/synthetics/trade/useMaxAutoCancelOrdersState.tsx
msgid "You can have up to {allowedAutoCancelOrdersNumber} active auto-cancelable TP/SL orders. Additional orders must be canceled manually, while existing ones will still close automatically with their related position."
msgstr "You can have up to {allowedAutoCancelOrdersNumber} active auto-cancelable TP/SL orders. Additional orders must be canceled manually, while existing ones will still close automatically with their related position."

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Top PnL (%)"
msgstr "Top PnL (%)"

#: src/components/Synthetics/TradeBox/TradeBoxRows/AvailableLiquidityRow.tsx
#: src/domain/synthetics/orders/utils.tsx
msgid "There may not be sufficient liquidity to execute your order when the price conditions are met."
msgstr "There may not be sufficient liquidity to execute your order when the price conditions are met."

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Error submitting coins"
msgstr "Error submitting coins"

#: src/components/Glp/GlpSwap.jsx
msgid "WARNING: High Fees"
msgstr "WARNING: High Fees"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Not enough Available Swap Liquidity to fill the Order. The Order will get filled when the condition is met and there is enough Available Swap Liquidity."
msgstr "Not enough Available Swap Liquidity to fill the Order. The Order will get filled when the condition is met and there is enough Available Swap Liquidity."

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Claims are not available on Avalanche Fuji"
msgstr "Claims are not available on Avalanche Fuji"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel TWAP Swap"
msgstr "Cancel TWAP Swap"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Transaction"
msgstr "Transaction"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Invalid liq. price"
msgstr "Invalid liq. price"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Annualized Buy Pressure (BB&D):"
msgstr "Annualized Buy Pressure (BB&D):"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "buy"
msgstr "buy"

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "AVAILABLE LIQ."
msgstr "AVAILABLE LIQ."

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
msgid "Start unrealized pnl"
msgstr "Start unrealized pnl"

#: src/config/events.tsx
msgid "Increasing positions (market or limit), adding collateral, and swapping on GMX V1 are now disabled. You can still close existing positions."
msgstr "Increasing positions (market or limit), adding collateral, and swapping on GMX V1 are now disabled. You can still close existing positions."

#: src/domain/tokens/approveTokens.tsx
msgid "Approval submitted! <0>View status.</0>"
msgstr "Approval submitted! <0>View status.</0>"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Order size is 0"
msgstr "Order size is 0"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "The buyable cap for the pool GM: {0} in {1} [{2}] has been reached. Please reduce the buy size, pick a different GM token, or shift the GM tokens to a different pool and try again."
msgstr "The buyable cap for the pool GM: {0} in {1} [{2}] has been reached. Please reduce the buy size, pick a different GM token, or shift the GM tokens to a different pool and try again."

#: src/components/Exchange/PositionSeller.jsx
msgid "Close {longOrShortText} {0}"
msgstr "Close {longOrShortText} {0}"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Disable validation for testing"
msgstr "Disable validation for testing"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Deposited!"
msgstr "Deposited!"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
msgid "TP/SL"
msgstr "TP/SL"

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
msgid "Max {0} in"
msgstr "Max {0} in"

#: src/domain/synthetics/orders/utils.tsx
msgid "Stop Loss Decrease"
msgstr "Stop Loss Decrease"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Diff"
msgstr "Diff"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Dashboard for GMX referral stats"
msgstr "Dashboard for GMX referral stats"

#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Action"
msgstr "Action"

#: src/pages/Dashboard/GlpCard.tsx
#: src/pages/Dashboard/GmCard.tsx
msgid "Supply"
msgstr "Supply"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
msgid "No open positions"
msgstr "No open positions"

#: src/components/DepthChart/DepthChart.tsx
msgid "Size, $"
msgstr "Size, $"

#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
msgid "Close {0} {1}{2}"
msgstr "Close {0} {1}{2}"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
msgid "Sell GLV"
msgstr "Sell GLV"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "STIP.b Retroactive Bonus"
msgstr "STIP.b Retroactive Bonus"

#: src/components/Exchange/TradeHistory.jsx
msgid "Try increasing the \"Allowed Slippage\", under the Settings menu on the top right."
msgstr "Try increasing the \"Allowed Slippage\", under the Settings menu on the top right."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "You can buy AVAX directly on <0>Avalanche</0> using these options:"
msgstr "You can buy AVAX directly on <0>Avalanche</0> using these options:"

#: src/components/Exchange/NetValueTooltip.tsx
msgid "Net Value: Initial Collateral + PnL - Borrow Fee - Close Fee"
msgstr "Net Value: Initial Collateral + PnL - Borrow Fee - Close Fee"

#: src/pages/Stake/AffiliateClaimModal.tsx
msgid "Claim Affiliate Vault Rewards"
msgstr "Claim Affiliate Vault Rewards"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Select different tokens"
msgstr "Select different tokens"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapWarningsRow.tsx
#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High Network Fees"
msgstr "High Network Fees"

#: src/domain/synthetics/fees/utils/index.ts
msgid "The network fees are very high currently, which may be due to a temporary increase in transactions on the {chainName} network."
msgstr "The network fees are very high currently, which may be due to a temporary increase in transactions on the {chainName} network."

#: src/components/Exchange/SwapBox.jsx
msgid "There are more shorts than longs, borrow fees for longing is currently zero"
msgstr "There are more shorts than longs, borrow fees for longing is currently zero"

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
#: src/pages/Pools/PoolsTimeRangeFilter.tsx
msgid "Last 90d"
msgstr "Last 90d"

#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "There is no liquidation price, as the position's collateral value will increase to cover any negative PnL."
msgstr "There is no liquidation price, as the position's collateral value will increase to cover any negative PnL."

#: src/components/TVChartContainer/DynamicLine.tsx
msgid "Edit Order"
msgstr "Edit Order"

#: src/components/MarketSelector/GmPoolsSelectorForGlvMarket.tsx
#: src/components/MarketSelector/PoolSelector.tsx
msgid "Search Pool"
msgstr "Search Pool"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Trading Chat"
msgstr "GMX Trading Chat"

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "24H%"
msgstr "24H%"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Perpie"
msgstr "Perpie"

#: src/components/Exchange/UsefulLinks.tsx
msgid "Useful Links"
msgstr "Useful Links"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Enable external swaps"
msgstr "Enable external swaps"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Trade Confirmations"
msgstr "Trade Confirmations"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Available"
msgstr "Available"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Last 7 days"
msgstr "Last 7 days"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Solv Finance"
msgstr "Solv Finance"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Begin Transfer"
msgstr "Begin Transfer"

#: src/components/RatingToast/RatingToast.tsx
msgid "How likely are you to recommend our service to a friend or colleague?"
msgstr "How likely are you to recommend our service to a friend or colleague?"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient liquidity to swap collateral"
msgstr "Insufficient liquidity to swap collateral"

#: src/components/Synthetics/TradeHistory/keys.ts
#: src/domain/synthetics/orders/utils.tsx
msgid "Market Decrease"
msgstr "Market Decrease"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Governance Alerts"
msgstr "Governance Alerts"

#: src/components/Exchange/TradeHistory.jsx
msgid "Swap {0} {1} for{2} USDG"
msgstr "Swap {0} {1} for{2} USDG"

#: src/components/Header/HomeHeaderLinks.tsx
msgid "Governance"
msgstr "Governance"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Cancel"
msgstr "Cancel"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "{orderText} updated."
msgstr "{orderText} updated."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Tradao"
msgstr "Tradao"

#: src/components/Glp/GlpSwap.jsx
msgid "Redemption time not yet reached"
msgstr "Redemption time not yet reached"

#: src/components/Glp/GlpSwap.jsx
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient liquidity"
msgstr "Insufficient liquidity"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram Bot"
msgstr "Telegram Bot"

#: src/domain/legacy.ts
msgid "Order cancelled."
msgstr "Order cancelled."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute TWAP Swap Part"
msgstr "Execute TWAP Swap Part"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "<0>every</0> {seconds} seconds"
msgstr "<0>every</0> {seconds} seconds"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy or Transfer AVAX to Avalanche"
msgstr "Buy or Transfer AVAX to Avalanche"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "TokenTerminal"
msgstr "TokenTerminal"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram bot for Open Interest on GMX"
msgstr "Telegram bot for Open Interest on GMX"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Check the \"Save on Fees\" section below to get the lowest fee percentages."
msgstr "Check the \"Save on Fees\" section below to get the lowest fee percentages."

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "The total realized and unrealized profit and loss for the period, including fees and price impact."
msgstr "The total realized and unrealized profit and loss for the period, including fees and price impact."

#: src/components/Synthetics/GmList/PerformanceLabel.tsx
msgid "Ann. Performance"
msgstr "Ann. Performance"

#: src/domain/legacy.ts
msgid "The network Fees are very high currently, which may be due to a temporary increase in transactions on the {0} network."
msgstr "The network Fees are very high currently, which may be due to a temporary increase in transactions on the {0} network."

#: src/components/Exchange/SwapBox.jsx
msgid "Current {0} long"
msgstr "Current {0} long"

#: src/domain/synthetics/orders/setAutoCancelOrdersTxn.ts
msgid "{0} orders were not updated as max order limit reached"
msgstr "{0} orders were not updated as max order limit reached"

#: src/components/Exchange/PositionSeller.jsx
msgid "Order created!"
msgstr "Order created!"

#: src/components/Synthetics/TradeHistory/filters/ActionFilter.tsx
#: src/domain/synthetics/orders/utils.tsx
msgid "Liquidation"
msgstr "Liquidation"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Risk Monitoring"
msgstr "GMX Risk Monitoring"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Receiver has not staked GLP tokens before"
msgstr "Receiver has not staked GLP tokens before"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Min collateral: {0}"
msgstr "Min collateral: {0}"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
msgid "Enter new amount or price"
msgstr "Enter new amount or price"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Wins and losses for fully closed positions."
msgstr "Wins and losses for fully closed positions."

#: src/pages/Stake/AffiliateClaimModal.tsx
msgid "<0>This will claim {formattedRewards} GMX.<1/><2/>After claiming, you can stake these GMX tokens by using the \"Stake\" button in the GMX section of this Earn page.<3/><4/></0>"
msgstr "<0>This will claim {formattedRewards} GMX.<1/><2/>After claiming, you can stake these GMX tokens by using the \"Stake\" button in the GMX section of this Earn page.<3/><4/></0>"

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "Open Binance app"
msgstr "Open Binance app"

#: src/pages/Stake/StakeModal.tsx
#: src/pages/Stake/UnstakeModal.tsx
#: src/pages/Stake/VesterDepositModal.tsx
msgid "Max amount exceeded"
msgstr "Max amount exceeded"

#: src/components/Exchange/SwapBox.jsx
msgid "Current {0} shorts"
msgstr "Current {0} shorts"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "To complete the transfer, you must switch your connected account to {receiver}."
msgstr "To complete the transfer, you must switch your connected account to {receiver}."

#: src/components/Synthetics/MarketsList/NetFeeTooltip.tsx
#: src/components/Synthetics/MarketsList/NetFeeTooltip.tsx
msgid "Longs Net Rate / 1h"
msgstr "Longs Net Rate / 1h"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "Edit"
msgstr "Edit"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "No available leverage found"
msgstr "No available leverage found"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Only addresses with over {0} in \"Capital Used\" are ranked."
msgstr "Only addresses with over {0} in \"Capital Used\" are ranked."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Shorting..."
msgstr "Shorting..."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "You have a <0>pending transfer</0> to {pendingReceiver}."
msgstr "You have a <0>pending transfer</0> to {pendingReceiver}."

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Limit size is required"
msgstr "Limit size is required"

#: src/pages/Buy/Buy.tsx
#: src/pages/Home/Home.tsx
msgid "Protocol Tokens"
msgstr "Protocol Tokens"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Collateral at Liquidation"
msgstr "Collateral at Liquidation"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "After claiming you will be able to vest a maximum of {0} esGMX at a ratio of {1} {stakingToken} to 1 esGMX."
msgstr "After claiming you will be able to vest a maximum of {0} esGMX at a ratio of {1} {stakingToken} to 1 esGMX."

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "Today"
msgstr "Today"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Receiver Address"
msgstr "Receiver Address"

#: src/pages/AccountDashboard/AccountDashboard.tsx
msgid "GMX {versionName} {networkName} information for account:"
msgstr "GMX {versionName} {networkName} information for account:"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "From"
msgstr "From"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Order Trigger Price"
msgstr "Order Trigger Price"

#: src/components/Glp/GlpSwap.jsx
msgid "Epoch ending is not acknowledged"
msgstr "Epoch ending is not acknowledged"

#: src/domain/synthetics/orders/utils.tsx
msgid "Limit Increase"
msgstr "Limit Increase"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Use the edit collateral icon to deposit or withdraw collateral."
msgstr "Use the edit collateral icon to deposit or withdraw collateral."

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "No liquidity is available for increasing longs for<0/>this size. Max long size: {0}<1/><2/>There is no price impact. There is a single<3/>execution price for decreasing shorts for<4/>this size."
msgstr "No liquidity is available for increasing longs for<0/>this size. Max long size: {0}<1/><2/>There is no price impact. There is a single<3/>execution price for decreasing shorts for<4/>this size."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX using any token from any network:"
msgstr "Buy GMX using any token from any network:"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Volume traded by your referred traders."
msgstr "Volume traded by your referred traders."

#: src/pages/Dashboard/GlpCard.tsx
msgid "Stablecoin Percentage"
msgstr "Stablecoin Percentage"

#: src/domain/synthetics/orders/utils.tsx
msgid "Parts of this order will be executed once there is sufficient liquidity."
msgstr "Parts of this order will be executed once there is sufficient liquidity."

#: src/components/Synthetics/TradeBox/TradeBoxRows/CollateralSelectorRow.tsx
msgid "You have an existing position with {0} as collateral. This Order will not be valid for that Position. <0>Switch to {1} collateral</0>."
msgstr "You have an existing position with {0} as collateral. This Order will not be valid for that Position. <0>Switch to {1} collateral</0>."

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Please only use this for full account transfers.<0/>This will transfer all your GMX, esGMX, GLP, Multiplier Points and voting power to your new account.<1/>Transfers are only supported if the receiving account has not staked GMX or GLP tokens before.<2/>Transfers are one-way, you will not be able to transfer staked tokens back to the sending account."
msgstr "Please only use this for full account transfers.<0/>This will transfer all your GMX, esGMX, GLP, Multiplier Points and voting power to your new account.<1/>Transfers are only supported if the receiving account has not staked GMX or GLP tokens before.<2/>Transfers are one-way, you will not be able to transfer staked tokens back to the sending account."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "SNTL esGMX Market"
msgstr "SNTL esGMX Market"

#: src/components/Referrals/TradersStats.tsx
msgid "Tier {0} ({currentTierDiscount}% discount)"
msgstr "Tier {0} ({currentTierDiscount}% discount)"

#: src/domain/synthetics/orders/utils.tsx
msgid "This order using {collateralSymbol} as collateral will not be valid for the existing {longText} position using {symbol} as collateral."
msgstr "This order using {collateralSymbol} as collateral will not be valid for the existing {longText} position using {symbol} as collateral."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Generative Market eXplore - AIGMX Agent"
msgstr "Generative Market eXplore - AIGMX Agent"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Dolomite"
msgstr "Dolomite"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Order request sent"
msgstr "Order request sent"

#: src/components/ExpressTradingEnabledBanner/ExpressTradingEnabledBanner.tsx
msgid "Express Trading is enabled. Enjoy smoother, more reliable trades!"
msgstr "Express Trading is enabled. Enjoy smoother, more reliable trades!"

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "Alternatively, you can select a different \"Collateral In\" token."
msgstr "Alternatively, you can select a different \"Collateral In\" token."

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Get alerts and announcements from GMX to stay on top of your trades, liquidation risk, and more."
msgstr "Get alerts and announcements from GMX to stay on top of your trades, liquidation risk, and more."

#: src/pages/PageNotFound/PageNotFound.jsx
msgid "<0>Return to </0><1>Homepage</1> <2>or </2> <3>Trade</3>"
msgstr "<0>Return to </0><1>Homepage</1> <2>or </2> <3>Trade</3>"

#: src/components/Synthetics/BridgingInfo/BridgingInfo.tsx
msgid "Bridge {tokenSymbol} to {chainName} with"
msgstr "Bridge {tokenSymbol} to {chainName} with"

#: src/domain/tokens/approveTokens.tsx
msgid "Permit signing failed"
msgstr "Permit signing failed"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Stop market price below mark price"
msgstr "Stop market price below mark price"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
msgid "Swapped {0} {1} for {2} {3}!"
msgstr "Swapped {0} {1} for {2} {3}!"

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "A size percentage is required"
msgstr "A size percentage is required"

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "Show more"
msgstr "Show more"

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Unrealized Fees"
msgstr "Unrealized Fees"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
msgid "Traders Referred"
msgstr "Traders Referred"

#: src/pages/Stake/StakeModal.tsx
msgid "Stake submitted!"
msgstr "Stake submitted!"

#: src/components/Exchange/PositionsList.jsx
msgid "Use the \"Close\" button to reduce your Position Size, or to set Take Profit / Stop Loss Orders."
msgstr "Use the \"Close\" button to reduce your Position Size, or to set Take Profit / Stop Loss Orders."

#: src/components/Exchange/PositionDropdown.tsx
msgid "Increase Size (Market)"
msgstr "Increase Size (Market)"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Couldn't find a swap path with enough liquidity"
msgstr "Couldn't find a swap path with enough liquidity"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
#: src/pages/Stake/VesterWithdrawModal.tsx
msgid "Withdrawn!"
msgstr "Withdrawn!"

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "3rd Place"
msgstr "3rd Place"

#: src/domain/synthetics/markets/claimFundingFeesTxn.ts
#: src/domain/synthetics/referrals/claimAffiliateRewardsTxn.ts
msgid "Claiming failed"
msgstr "Claiming failed"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update Stop Loss"
msgstr "Update Stop Loss"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Approve {0}"
msgstr "Approve {0}"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max {0} long exceeded"
msgstr "Max {0} long exceeded"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "N/A"
msgstr "N/A"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
msgid "Stop Market price is below mark price"
msgstr "Stop Market price is below mark price"

#: src/components/Exchange/PositionEditor.jsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Amount should be greater than zero"
msgstr "Amount should be greater than zero"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Perpetuals Aggregator"
msgstr "Perpetuals Aggregator"

#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "LIVE"
msgstr "LIVE"

#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "{formattedNetRate} / 1h"
msgstr "{formattedNetRate} / 1h"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/GmShiftBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/GmShiftBox.tsx
msgid "Balance"
msgstr "Balance"

#: src/pages/Stake/Stake.tsx
msgid "Liquidity and trading incentives programs are live on {avalancheLink}."
msgstr "Liquidity and trading incentives programs are live on {avalancheLink}."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX v2 Telegram & Discord Analytics"
msgstr "GMX v2 Telegram & Discord Analytics"

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Re-enable"
msgstr "Re-enable"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "I do not want to transfer the Affiliate esGMX tokens"
msgstr "I do not want to transfer the Affiliate esGMX tokens"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Forfeit profit and {action}"
msgstr "Forfeit profit and {action}"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Win/Loss"
msgstr "Win/Loss"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Names could be separated by commas or spaces"
msgstr "Names could be separated by commas or spaces"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX from decentralized exchanges"
msgstr "Buy GMX from decentralized exchanges"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Powered by"
msgstr "Powered by"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Buy order executed"
msgstr "Buy order executed"

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "The order's acceptable price includes the set acceptable price impact. The execution price must meet this condition for the order to be executed."
msgstr "The order's acceptable price includes the set acceptable price impact. The execution price must meet this condition for the order to be executed."

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "This TWAP order will execute {numberOfParts} {0} {type} orders of {1} each over the next {2} for the {3} market."
msgstr "This TWAP order will execute {numberOfParts} {0} {type} orders of {1} each over the next {2} for the {3} market."

#: src/pages/Stake/AffiliateClaimModal.tsx
msgid "Claim submitted."
msgstr "Claim submitted."

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "OPEN INTEREST"
msgstr "OPEN INTEREST"

#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Failed to download trade history CSV."
msgstr "Failed to download trade history CSV."

#: src/domain/synthetics/positions/utils.ts
msgid "market"
msgstr "market"

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Same as current active code"
msgstr "Same as current active code"

#: src/components/Synthetics/AllowedSwapSlippageInputRowImpl/AllowedSwapSlippageInputRowImpl.tsx
msgid "The current swap impact including fees is {0}. Consider adding a buffer of 1% to it so the order is more likely to be processed"
msgstr "The current swap impact including fees is {0}. Consider adding a buffer of 1% to it so the order is more likely to be processed"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "Win / Loss"
msgstr "Win / Loss"

#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V1 rebates are airdropped weekly. V2 rebates are automatically applied as fee discounts on each trade and do not show on this table."
msgstr "V1 rebates are airdropped weekly. V2 rebates are automatically applied as fee discounts on each trade and do not show on this table."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Min position size: {0}"
msgstr "Min position size: {0}"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Trigger price below mark price"
msgstr "Trigger price below mark price"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "and automatically compounds its yield (unlike GLP, no manual claiming is needed)"
msgstr "and automatically compounds its yield (unlike GLP, no manual claiming is needed)"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "No delegate found"
msgstr "No delegate found"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Community with NFTs, Trading and Education initiatives"
msgstr "GMX Community with NFTs, Trading and Education initiatives"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Liquidation Confirmations"
msgstr "Liquidation Confirmations"

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Expected execution price for the order, including the current price impact, once the stop market order executes."
msgstr "Expected execution price for the order, including the current price impact, once the stop market order executes."

#: src/components/Glp/GlpSwap.jsx
msgid "Acknowledge epoch is ending in {minutes} minutes"
msgstr "Acknowledge epoch is ending in {minutes} minutes"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapWarningsRow.tsx
#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High Price Impact"
msgstr "High Price Impact"

#: src/components/InterviewModal/InterviewModal.tsx
msgid "We want your insights to help improve GMX. For security reasons, we won't contact you first. Please send the message \"I have feedback\" to any of our official accounts:"
msgstr "We want your insights to help improve GMX. For security reasons, we won't contact you first. Please send the message \"I have feedback\" to any of our official accounts:"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Claim esGMX"
msgstr "Claim esGMX"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy or Transfer ETH to Arbitrum"
msgstr "Buy or Transfer ETH to Arbitrum"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "The maximum percentage difference between your specified price and execution price when placing orders."
msgstr "The maximum percentage difference between your specified price and execution price when placing orders."

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Expected execution price for the order, including the current price impact, once the limit order executes."
msgstr "Expected execution price for the order, including the current price impact, once the limit order executes."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "of open fee"
msgstr "of open fee"

#: src/pages/Dashboard/MarketsListV1.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Pool Amount"
msgstr "Pool Amount"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Approve GMX"
msgstr "Approve GMX"

#: src/components/Glp/SwapErrorModal.tsx
msgid "{0} Capacity Reached"
msgstr "{0} Capacity Reached"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/swap.ts
msgid "{fromText} to {toExecutionText}"
msgstr "{fromText} to {toExecutionText}"

#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Create {0} Order"
msgstr "Create {0} Order"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Limit Swap"
msgstr "Execute Limit Swap"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "To purchase GMX on the {0} blockchain, please <0>change your network</0>."
msgstr "To purchase GMX on the {0} blockchain, please <0>change your network</0>."

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
#: src/components/NpsModal/NpsModal.tsx
#: src/components/Referrals/JoinReferralCode.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Submit"
msgstr "Submit"

#: src/domain/tokens/approveTokens.tsx
msgid "Permit signed!"
msgstr "Permit signed!"

#: src/components/Exchange/TradeHistory.jsx
msgid "Request withdrawal from {0} {longOrShortText}"
msgstr "Request withdrawal from {0} {longOrShortText}"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Select an option"
msgstr "Select an option"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "less than a minute"
msgstr "less than a minute"

#: src/components/Header/AppHeaderLinks.tsx
msgid "Ecosystem"
msgstr "Ecosystem"

#: src/pages/PriceImpactRebatesStats/PriceImpactRebatesStats.tsx
msgid "Next"
msgstr "Next"

#: src/components/Exchange/TradeHistory.jsx
#: src/components/Referrals/AddAffiliateCode.jsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Create"
msgstr "Create"

#: src/components/Exchange/SwapBox.jsx
msgid "Limit order submitted!"
msgstr "Limit order submitted!"

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "Last 7d"
msgstr "Last 7d"

#: src/components/Synthetics/StatusNotification/StakeNotification.tsx
msgid "Swap {fromAmount} for {toAmount}"
msgstr "Swap {fromAmount} for {toAmount}"

#: src/components/Exchange/PositionShare.tsx
msgid "Copy"
msgstr "Copy"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Amount"
msgstr "Amount"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Create {0} order"
msgstr "Create {0} order"

#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
msgid "Edit {0} {1}{2}"
msgstr "Edit {0} {1}{2}"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "No rebates distribution history yet."
msgstr "No rebates distribution history yet."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Governance"
msgstr "GMX Governance"

#: src/domain/synthetics/orders/utils.tsx
msgid "trigger price"
msgstr "trigger price"

#: src/components/Referrals/ClaimAffiliatesModal/ClaimAffiliatesModal.tsx
#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
#: src/components/Synthetics/Claims/ClaimableCard.tsx
#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/AffiliateClaimModal.tsx
#: src/pages/Stake/ClaimModal.tsx
#: src/pages/Stake/TotalRewardsCard.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Claim"
msgstr "Claim"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/PriceImpactFeesRow.tsx
msgid "Price Impact / Fees"
msgstr "Price Impact / Fees"

#: src/pages/AccountDashboard/AccountDashboard.tsx
#: src/pages/AccountDashboard/AccountDashboard.tsx
msgid "GMX {versionName} Account"
msgstr "GMX {versionName} Account"

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Order execution price takes into account price impact."
msgstr "Order execution price takes into account price impact."

#: src/pages/Buy/Buy.tsx
msgid "Buy GLP or GMX"
msgstr "Buy GLP or GMX"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "GLV earns from trading fees (open, close, borrow, liquidations, swaps) and trader losses across GM pools, with auto-compounding for seamless growth (20-30% historical average annualized performance). View real-time earnings, performance, and portfolio value on the <0>Pools page</0>."
msgstr "GLV earns from trading fees (open, close, borrow, liquidations, swaps) and trader losses across GM pools, with auto-compounding for seamless growth (20-30% historical average annualized performance). View real-time earnings, performance, and portfolio value on the <0>Pools page</0>."

#: src/components/Exchange/ChartTokenSelector.tsx
msgid "Max Out"
msgstr "Max Out"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/StakeModal.tsx
#: src/pages/Stake/UnstakeModal.tsx
#: src/pages/Stake/VesterDepositModal.tsx
msgid "Enter an amount"
msgstr "Enter an amount"

#: src/components/Header/AppHeaderUser.tsx
msgid "Connect"
msgstr "Connect"

#: src/components/InterviewToast/InterviewToast.tsx
msgid "Click here to give us your feedback on GMX."
msgstr "Click here to give us your feedback on GMX."

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "V1 Avalanche Fuji"
msgstr "V1 Avalanche Fuji"

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "1st Place"
msgstr "1st Place"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "D2.Finance"
msgstr "D2.Finance"

#: src/pages/Dashboard/OverviewCard.tsx
msgid "Annualized:"
msgstr "Annualized:"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Failed to sign approval"
msgstr "Failed to sign approval"

#: src/pages/LeaderboardPage/components/CompetitionCountdown.tsx
msgid "Starts in"
msgstr "Starts in"

#: src/domain/synthetics/fees/utils/index.ts
msgid "The network fees are high currently, which may be due to a temporary increase in transactions on the {chainName} network."
msgstr "The network fees are high currently, which may be due to a temporary increase in transactions on the {chainName} network."

#: src/lib/wallets/connecters/binanceW3W/binanceWallet.ts
msgid "Scan the QR code"
msgstr "Scan the QR code"

#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Claims ({totalClaimables})"
msgstr "Claims ({totalClaimables})"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Unknown shift GM order"
msgstr "Unknown shift GM order"

#: src/components/Exchange/TradeHistory.jsx
msgid "Max leverage of 100x was exceeded, the remaining collateral after deducting losses and fees have been sent back to your account:"
msgstr "Max leverage of 100x was exceeded, the remaining collateral after deducting losses and fees have been sent back to your account:"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
msgid "Shifting {symbol}..."
msgstr "Shifting {symbol}..."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Not enough Available Liquidity to fill the Order."
msgstr "Not enough Available Liquidity to fill the Order."

#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/orders/getPositionOrderError.tsx
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Trigger price above mark price"
msgstr "Trigger price above mark price"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Order size exceeds position"
msgstr "Order size exceeds position"

#: src/components/Exchange/OrderEditor.jsx
msgid "Order update submitted!"
msgstr "Order update submitted!"

#: src/components/Exchange/PositionEditor.jsx
msgid "Enable withdraw failed."
msgstr "Enable withdraw failed."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Explore, analyze, and copy on-chain traders"
msgstr "Explore, analyze, and copy on-chain traders"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Forfeit profit"
msgstr "Forfeit profit"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "Sell Fee"
msgstr "Sell Fee"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/InfoRows.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/GmShiftBox.tsx
#: src/components/Synthetics/PositionEditor/PositionEditorAdvancedRows.tsx
#: src/components/Synthetics/PositionSeller/PositionSellerAdvancedDisplayRows.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AdvancedDisplayRows.tsx
msgid "Execution Details"
msgstr "Execution Details"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "GM Airdrop"
msgstr "GM Airdrop"

#: src/components/Glp/GlpSwap.jsx
msgid "Save on Fees"
msgstr "Save on Fees"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update Take Profit"
msgstr "Update Take Profit"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Active Orders"
msgstr "Active Orders"

#: src/components/Synthetics/AcceptablePriceImpactInputRow/AcceptablePriceImpactInputRow.tsx
msgid "You have set a high acceptable price impact. The current price impact is {0}."
msgstr "You have set a high acceptable price impact. The current price impact is {0}."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Lending and Borrowing"
msgstr "Lending and Borrowing"

#: src/components/Exchange/SwapBox.jsx
msgid "Switch to {0} collateral."
msgstr "Switch to {0} collateral."

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "GMX Vault"
msgstr "GMX Vault"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Jones DAO"
msgstr "Jones DAO"

#: src/components/Exchange/TradeHistory.jsx
msgid "Partially Liquidated"
msgstr "Partially Liquidated"

#: src/components/Glp/GlpSwap.jsx
msgid "Insufficient GLP balance"
msgstr "Insufficient GLP balance"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Minute(s)"
msgstr "Minute(s)"

#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Start Unrealized Fees"
msgstr "Start Unrealized Fees"

#: src/components/Synthetics/BotanixBanner/BotanixBanner.tsx
msgid "V2 trading"
msgstr "V2 trading"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "view"
msgstr "view"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "{orderText} cancel failed."
msgstr "{orderText} cancel failed."

#: src/components/Exchange/OrdersToa.jsx
msgid "Accept terms to enable orders"
msgstr "Accept terms to enable orders"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Protocol analytics"
msgstr "Protocol analytics"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Transfer submitted!"
msgstr "Transfer submitted!"

#: src/components/Exchange/TradeHistory.jsx
msgid ""
"Liquidated {0} {longOrShortText},\n"
"-{1} USD,\n"
"{2} Price: {3} USD"
msgstr ""
"Liquidated {0} {longOrShortText},\n"
"-{1} USD,\n"
"{2} Price: {3} USD"

#: src/components/Exchange/ExchangeTVChart.jsx
msgid "Inc."
msgstr "Inc."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Fees exceed amount"
msgstr "Fees exceed amount"

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
msgid "Search Type"
msgstr "Search Type"

#: src/pages/Dashboard/WeightText.tsx
msgid "{0} is below its target weight.<0/><1/>Get lower fees to <2>buy GLP</2> with {1}, and to <3>swap</3> {2} for other tokens."
msgstr "{0} is below its target weight.<0/><1/>Get lower fees to <2>buy GLP</2> with {1}, and to <3>swap</3> {2} for other tokens."

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Win Rate"
msgstr "Win Rate"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "Save {0} in price impact and fees by <0><1>switching to the {1} pool</1>.</0>"
msgstr "Save {0} in price impact and fees by <0><1>switching to the {1} pool</1>.</0>"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "You have esGMX tokens in the Affiliate Vault, you need to withdraw these tokens if you want to transfer them to the new account"
msgstr "You have esGMX tokens in the Affiliate Vault, you need to withdraw these tokens if you want to transfer them to the new account"

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Open {0} in Explorer"
msgstr "Open {0} in Explorer"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "{0} and {1} can be used to buy GM for this market up to the specified buying caps."
msgstr "{0} and {1} can be used to buy GM for this market up to the specified buying caps."

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "GLV tokens are similar in composition to GLP, and enable seamless integration into GMX V2's liquidity ecosystem. Users can either sell or hold the tokens to earn yield. To encourage long-term participation, a $500,000 GLV incentive pool will be distributed proportionally to those who hold their allocated GLV for at least 3 months."
msgstr "GLV tokens are similar in composition to GLP, and enable seamless integration into GMX V2's liquidity ecosystem. Users can either sell or hold the tokens to earn yield. To encourage long-term participation, a $500,000 GLV incentive pool will be distributed proportionally to those who hold their allocated GLV for at least 3 months."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/StatusNotification/StakeNotification.tsx
#: src/context/PendingTxnsContext/PendingTxnsContext.tsx
#: src/lib/contracts/notifications.tsx
#: src/lib/contracts/notifications.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
msgid "View"
msgstr "View"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Execute Stop Market"
msgstr "Execute Stop Market"

#: src/components/Referrals/TradersStats.tsx
msgid "Volume traded by this account with an active referral code."
msgstr "Volume traded by this account with an active referral code."

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
msgid "Start unrealized fees"
msgstr "Start unrealized fees"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Referral Codes"
msgstr "Referral Codes"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Vested GMX not withdrawn"
msgstr "Vested GMX not withdrawn"

#: src/components/Glp/GlpSwap.jsx
msgid "FEES"
msgstr "FEES"

#: src/components/Exchange/FeesTooltip.tsx
#: src/components/Exchange/NetValueTooltip.tsx
#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Open Fee"
msgstr "Open Fee"

#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Looks like you don't have a referral code to share. <0/> Create one now and start earning rebates!"
msgstr "Looks like you don't have a referral code to share. <0/> Create one now and start earning rebates!"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
#: src/context/SubaccountContext/SubaccountContextProvider.tsx
#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Update 1CT (One-Click Trading) settings"
msgstr "Update 1CT (One-Click Trading) settings"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Kudai AI Agent"
msgstr "Kudai AI Agent"

#: src/components/Synthetics/MarketStats/MarketGraphs.tsx
msgid "Current Price"
msgstr "Current Price"

#: src/pages/NftWallet/NftWallet.jsx
msgid "Enter NFT ID"
msgstr "Enter NFT ID"

#: src/components/Exchange/PositionEditor.jsx
msgid "Withdrawal failed."
msgstr "Withdrawal failed."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Limit Price"
msgstr "Limit Price"

#: src/components/AddressView/AddressView.tsx
msgid "You"
msgstr "You"

#: src/components/Synthetics/GmList/GmList.tsx
msgid "Pools providing liquidity to specific GMX markets, supporting single-asset and native asset options."
msgstr "Pools providing liquidity to specific GMX markets, supporting single-asset and native asset options."

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Deactivate 1CT (One-Click Trading)"
msgstr "Deactivate 1CT (One-Click Trading)"

#: src/components/Exchange/TradeHistory.jsx
msgid "Could not execute deposit into {0} {longOrShortText}"
msgstr "Could not execute deposit into {0} {longOrShortText}"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Synthetics/PositionEditor/types.ts
#: src/components/Synthetics/TradeHistory/keys.ts
#: src/pages/Stake/VesterDepositModal.tsx
#: src/pages/Stake/VesterDepositModal.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "Deposit"
msgstr "Deposit"

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
msgid "365d Est. Fees"
msgstr "365d Est. Fees"

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price below highest limit price"
msgstr "Trigger price below highest limit price"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Acceptable Price"
msgstr "Acceptable Price"

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sell request sent"
msgstr "Sell request sent"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DeFi Margin Protocol"
msgstr "DeFi Margin Protocol"

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "Claimable Balance"
msgstr "Claimable Balance"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Enabling Leverage..."
msgstr "Enabling Leverage..."

#: src/domain/synthetics/orders/utils.tsx
msgid "There may not be sufficient liquidity to execute the swap to the receive token when the price conditions are met."
msgstr "There may not be sufficient liquidity to execute the swap to the receive token when the price conditions are met."

#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "Withdrawn {balanceFormatted} to Main Account"
msgstr "Withdrawn {balanceFormatted} to Main Account"

#: src/components/NotifyModal/NotifyModal.tsx
msgid "Trade Errors"
msgstr "Trade Errors"

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Consider selecting only positions where the accrued funding fee exceeds the {0} gas cost to settle each position."
msgstr "Consider selecting only positions where the accrued funding fee exceeds the {0} gas cost to settle each position."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "The buyable cap for the pool GM: {0} using the pay token selected is reached. Please choose a different pool, reduce the buy size, or pick a different composition of tokens."
msgstr "The buyable cap for the pool GM: {0} using the pay token selected is reached. Please choose a different pool, reduce the buy size, or pick a different composition of tokens."

#: src/components/Glp/GlpSwap.jsx
msgid "Fees may vary depending on which asset you use to buy GLP. <0/>Enter the amount of GLP you want to purchase in the order form, then check here to compare fees."
msgstr "Fees may vary depending on which asset you use to buy GLP. <0/>Enter the amount of GLP you want to purchase in the order form, then check here to compare fees."

#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
msgid "Claim <0>{0}</0>"
msgstr "Claim <0>{0}</0>"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/GmDepositWithdrawalBox.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/GmShiftBox.tsx
#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Receive"
msgstr "Receive"

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "time to liq"
msgstr "time to liq"

#: src/pages/AccountDashboard/dailyAndCumulativePnLDebug.tsx
#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Realized Fees"
msgstr "Realized Fees"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Top Positions"
msgstr "Top Positions"

#: src/components/Header/AppHeaderLinks.tsx
msgid "Pools"
msgstr "Pools"

#: src/components/Exchange/TradeHistory.jsx
msgid "Could not execute withdrawal from {0} {longOrShortText}"
msgstr "Could not execute withdrawal from {0} {longOrShortText}"

#: src/components/Synthetics/GmList/GlvList.tsx
msgid "VAULT"
msgstr "VAULT"

#: src/components/Glp/GlpSwap.jsx
msgid "Fees (Rebated)"
msgstr "Fees (Rebated)"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Your transfer has been completed."
msgstr "Your transfer has been completed."

#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "We Value Your Feedback"
msgstr "We Value Your Feedback"

#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
#: src/domain/synthetics/positions/utils.ts
msgid "Stop Loss"
msgstr "Stop Loss"

#: src/pages/Stake/Stake.tsx
msgid "Liquidity incentives program is live on {avalancheLink}."
msgstr "Liquidity incentives program is live on {avalancheLink}."

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "GLP Distribution (test)"
msgstr "GLP Distribution (test)"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "This position could still be liquidated, excluding any price movement, due to funding and borrowing fee rates reducing the position's collateral over time."
msgstr "This position could still be liquidated, excluding any price movement, due to funding and borrowing fee rates reducing the position's collateral over time."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Transfer {nativeTokenSymbol}"
msgstr "Transfer {nativeTokenSymbol}"

#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "Meme"
msgstr "Meme"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useDepositWithdrawalTransactions.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useDepositWithdrawalTransactions.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmShiftBox/useShiftTransactions.tsx
#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeboxTransactions.tsx
msgid "Error submitting order"
msgstr "Error submitting order"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "V1 Rebates and V1/V2 esGMX are airdropped weekly. V2 Rebates are claimed manually."
msgstr "V1 Rebates and V1/V2 esGMX are airdropped weekly. V2 Rebates are claimed manually."

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Duration"
msgstr "Duration"

#: src/components/Common/SEO.tsx
msgid "Trade spot or perpetual BTC, ETH, AVAX and other top cryptocurrencies with up to 100x leverage directly from your wallet on Arbitrum and Avalanche."
msgstr "Trade spot or perpetual BTC, ETH, AVAX and other top cryptocurrencies with up to 100x leverage directly from your wallet on Arbitrum and Avalanche."

#: src/components/Exchange/ChartTokenSelector.tsx
msgid "Max In"
msgstr "Max In"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Myself"
msgstr "Myself"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Search Address"
msgstr "Search Address"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max GM buyable amount reached"
msgstr "Max GM buyable amount reached"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Session generated"
msgstr "Session generated"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Buy GMX"
msgstr "Buy GMX"

#: src/pages/Dashboard/MarketsListV1.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Max {0} Capacity"
msgstr "Max {0} Capacity"

#: src/components/ToastifyDebug/ToastifyDebug.tsx
msgid "Copy error"
msgstr "Copy error"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Projects developed by the GMX community. <0/>Please exercise caution when interacting with any app, apps are fully maintained by community developers."
msgstr "Projects developed by the GMX community. <0/>Please exercise caution when interacting with any app, apps are fully maintained by community developers."

#: src/domain/synthetics/userFeedback/utils.ts
msgid "What areas can we improve to make your experience better?"
msgstr "What areas can we improve to make your experience better?"

#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "{typeString} Long Market: {0} a long position at the current price."
msgstr "{typeString} Long Market: {0} a long position at the current price."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Select a collateral"
msgstr "Select a collateral"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Size per part"
msgstr "Size per part"

#: src/components/Glp/GlpSwap.jsx
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Insufficient {0} balance"
msgstr "Insufficient {0} balance"

#: src/domain/synthetics/orders/utils.tsx
msgid "limit price"
msgstr "limit price"

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Price impact rebates for closing trades are claimable under the claims tab. <0>Read more</0>."
msgstr "Price impact rebates for closing trades are claimable under the claims tab. <0>Read more</0>."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Sending order request"
msgstr "Sending order request"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Can't execute because of an error"
msgstr "Can't execute because of an error"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Yield Products"
msgstr "Decentralized Yield Products"

#: src/components/Exchange/PositionSeller.jsx
msgid "Keep Leverage is not possible"
msgstr "Keep Leverage is not possible"

#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
msgid "Max Network Fee includes fees for additional orders. It will be sent back in full to your account if they don't trigger and are cancelled. <0>Read more</0>."
msgstr "Max Network Fee includes fees for additional orders. It will be sent back in full to your account if they don't trigger and are cancelled. <0>Read more</0>."

#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
msgid "{positionName} Failed to settle"
msgstr "{positionName} Failed to settle"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
msgid "Rebates"
msgstr "Rebates"

#: src/components/Glp/GlpSwap.jsx
#~ msgid "GLP is not sellable"
#~ msgstr "GLP is not sellable"

#: src/pages/BuyGlp/BuyGlp.jsx
msgid "GMX V1 markets are disabled and only allow for position closing. GLP is being phased out and no longer supports GMX V1 markets."
msgstr "GMX V1 markets are disabled and only allow for position closing. GLP is being phased out and no longer supports GMX V1 markets."

#: src/components/Glp/GlpSwap.jsx
msgid "Sell failed."
msgstr "Sell failed."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update Limit"
msgstr "Update Limit"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "Edit order"
msgstr "Edit order"

#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Claims"
msgstr "Claims"

#: src/components/Referrals/AffiliatesStats.tsx
#: src/components/Referrals/TradersStats.tsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "Date"
msgstr "Date"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy GMX using FIAT gateways:"
msgstr "Buy GMX using FIAT gateways:"

#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Referral code created!"
msgstr "Referral code created!"

#: src/components/Exchange/OrderEditor.jsx
msgid "Price above Mark Price"
msgstr "Price above Mark Price"

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Trigger Price"
msgstr "Trigger Price"

#: src/pages/PoolsDetails/PoolsDetailsAbout.tsx
msgid "Sellable"
msgstr "Sellable"

#: src/components/Exchange/PositionSeller.jsx
msgid "Initial Collateral (Collateral excluding Borrow Fee)."
msgstr "Initial Collateral (Collateral excluding Borrow Fee)."

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "COMPETITION Airdrop"
msgstr "COMPETITION Airdrop"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Enter Receiver Address"
msgstr "Enter Receiver Address"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Additional reserve required"
msgstr "Additional reserve required"

#: src/components/Footer/constants.ts
#: src/pages/TermsAndConditions/TermsAndConditions.jsx
msgid "Terms and Conditions"
msgstr "Terms and Conditions"

#: src/pages/Stake/ClaimModal.tsx
msgid "Convert {wrappedTokenSymbol} to {nativeTokenSymbol}"
msgstr "Convert {wrappedTokenSymbol} to {nativeTokenSymbol}"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Available amount to deposit into GLP."
msgstr "Available amount to deposit into GLP."

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "What is GLV exactly?"
msgstr "What is GLV exactly?"

#: src/components/Exchange/PositionShare.tsx
msgid "Download"
msgstr "Download"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Swap {0} for {1}"
msgstr "Swap {0} for {1}"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Vault Capacity"
msgstr "Vault Capacity"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Decrease active: {0}, executed: {1}, cancelled: {2}"
msgstr "Decrease active: {0}, executed: {1}, cancelled: {2}"

#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "Layer 1"
msgstr "Layer 1"

#: src/components/Exchange/TradeHistory.jsx
msgid "{0}  {1} {longOrShortText}, -{2} USD, {3} Price: ${4} USD"
msgstr "{0}  {1} {longOrShortText}, -{2} USD, {3} Price: ${4} USD"

#: src/components/Exchange/PositionSeller.jsx
msgid "Keep leverage at {0}x"
msgstr "Keep leverage at {0}x"

#: src/pages/Stake/StakeModal.tsx
msgid "Staking..."
msgstr "Staking..."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Buy request sent"
msgstr "Buy request sent"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max {0} amount exceeded"
msgstr "Max {0} amount exceeded"

#: src/components/Exchange/PositionSeller.jsx
msgid "Position close disabled, pending {0} upgrade"
msgstr "Position close disabled, pending {0} upgrade"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Swapping..."
msgstr "Swapping..."

#: src/pages/AccountDashboard/generalPerformanceDetailsDebug.tsx
msgid "Realized Base PnL"
msgstr "Realized Base PnL"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
#: src/domain/synthetics/orders/createWrapOrUnwrapTxn.ts
msgid "Swap failed."
msgstr "Swap failed."

#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "Failed to withdraw {balanceFormatted} to Main Account"
msgstr "Failed to withdraw {balanceFormatted} to Main Account"

#: src/components/Synthetics/MarketStats/components/MarketDescription.tsx
msgid "This token automatically accrues fees from swaps for the {0}/{1} market. It is also exposed to {2} and {3} as per the composition displayed."
msgstr "This token automatically accrues fees from swaps for the {0}/{1} market. It is also exposed to {2} and {3} as per the composition displayed."

#: src/components/Exchange/PositionSeller.jsx
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Page outdated, please refresh"
msgstr "Page outdated, please refresh"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Proposals"
msgstr "GMX Proposals"

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "BUY…"
msgstr "BUY…"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "Vest with GLP on Arbitrum"
msgstr "Vest with GLP on Arbitrum"

#: src/components/InterviewModal/InterviewModal.tsx
#: src/components/InterviewModal/InterviewModal.tsx
msgid "Telegram account"
msgstr "Telegram account"

#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "SOON"
msgstr "SOON"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmDepositWithdrawalBox/useGmSwapSubmitState.tsx
msgid "Sell {operationTokenSymbol}"
msgstr "Sell {operationTokenSymbol}"

#: src/components/Exchange/PositionEditor.jsx
msgid "Liquidation price would cross mark price."
msgstr "Liquidation price would cross mark price."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Perfectswap"
msgstr "Perfectswap"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Leaderboard for traders on GMX V2."
msgstr "Leaderboard for traders on GMX V2."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Withdraw"
msgstr "Failed Withdraw"

#: src/pages/Referrals/Referrals.tsx
msgid "Get fee discounts and earn rebates through the GMX referral program.<0/>For more information, please read the <1>referral program details</1>."
msgstr "Get fee discounts and earn rebates through the GMX referral program.<0/>For more information, please read the <1>referral program details</1>."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/shared.ts
msgid "Freeze"
msgstr "Freeze"

#: src/components/Synthetics/PositionEditor/usePositionEditorButtonState.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Express params loading..."
msgstr "Express params loading..."

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "As there is not enough liquidity in GLP to swap {0} to {swapTokenSymbol}, you can use the option below to do so:"
msgstr "As there is not enough liquidity in GLP to swap {0} to {swapTokenSymbol}, you can use the option below to do so:"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
#: src/pages/Stake/AffiliateClaimModal.tsx
#: src/pages/Stake/ClaimModal.tsx
msgid "Claim completed!"
msgstr "Claim completed!"

#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/domain/synthetics/positions/utils.ts
msgid "Stop Market"
msgstr "Stop Market"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Min number of parts: {MIN_TWAP_NUMBER_OF_PARTS}"
msgstr "Min number of parts: {MIN_TWAP_NUMBER_OF_PARTS}"

#: src/components/Exchange/PositionSeller.jsx
msgid "You can change this in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than {0}, may result in failed orders if prices are volatile."
msgstr "You can change this in the settings menu on the top right of the page.<0/><1/>Note that a low allowed slippage, e.g. less than {0}, may result in failed orders if prices are volatile."

#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Request Settlement of Funding Fees"
msgstr "Request Settlement of Funding Fees"

#: src/pages/Dashboard/WeightText.tsx
msgid "Current Weight"
msgstr "Current Weight"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Partnerships and Integrations"
msgstr "Partnerships and Integrations"

#: src/components/Exchange/PositionEditor.jsx
msgid "Leftover Collateral not enough to cover fees"
msgstr "Leftover Collateral not enough to cover fees"

#: src/components/InterviewToast/InterviewToast.tsx
#: src/components/InterviewToast/InterviewToast.tsx
msgid "As a token of our appreciation, you'll receive a reward of <0>100 <1/></0>."
msgstr "As a token of our appreciation, you'll receive a reward of <0>100 <1/></0>."

#: src/domain/synthetics/sidecarOrders/utils.ts
#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price above limit price"
msgstr "Trigger price above limit price"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Select a Pay token"
msgstr "Select a Pay token"

#: src/components/Exchange/SwapBox.jsx
msgid "Swap {0} submitted!"
msgstr "Swap {0} submitted!"

#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
msgid "The available liquidity will be the lesser of the difference between the maximum value and the current value for both the reserve and open interest."
msgstr "The available liquidity will be the lesser of the difference between the maximum value and the current value for both the reserve and open interest."

#: src/components/Referrals/JoinReferralCode.tsx
msgid "Referral Code does not exist"
msgstr "Referral Code does not exist"

#: src/components/Synthetics/GmSwap/GmFees/GmFees.tsx
msgid "shift"
msgstr "shift"

#: src/components/Synthetics/UserIncentiveDistributionList/UserIncentiveDistributionList.tsx
msgid "GLP Distribution"
msgstr "GLP Distribution"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "Why is the claim in GLV tokens?"
msgstr "Why is the claim in GLV tokens?"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "GLP to GM Airdrop"
msgstr "GLP to GM Airdrop"

#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Yield Vaults"
msgstr "Yield Vaults"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram Group (Portuguese)"
msgstr "Telegram Group (Portuguese)"

#: src/pages/Actions/SyntheticsActions.tsx
msgid "GMX V2 Actions"
msgstr "GMX V2 Actions"

#: src/components/Referrals/ReferralCodeWarnings.tsx
msgid "This code has been taken by someone else on {takenNetworkNames}, you will not receive rebates from traders using this code on {takenNetworkNames}."
msgstr "This code has been taken by someone else on {takenNetworkNames}, you will not receive rebates from traders using this code on {takenNetworkNames}."

#: src/components/Referrals/ClaimAffiliatesModal/ClaimAffiliatesModal.tsx
#: src/components/Synthetics/ClaimablePositionPriceImpactRebateModal/ClaimablePositionPriceImpactRebateModal.tsx
#: src/components/Synthetics/ClaimModal/ClaimModal.tsx
msgid "Confirm Claim"
msgstr "Confirm Claim"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX community discussion"
msgstr "GMX community discussion"

#: src/components/TokenCard/TokenCard.tsx
msgid "{arbitrumLink} GLV Pools are <0>incentivized{sparkle}.</0>"
msgstr "{arbitrumLink} GLV Pools are <0>incentivized{sparkle}.</0>"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxHeader.tsx
msgid "Sell GM"
msgstr "Sell GM"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "<0>Delegate your undelegated {0} GMX DAO</0> voting power."
msgstr "<0>Delegate your undelegated {0} GMX DAO</0> voting power."

#: src/domain/synthetics/markets/createShiftTxn.ts
msgid "Shift error."
msgstr "Shift error."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ExchangeTVChart.jsx
#: src/components/Exchange/ExchangeTVChart.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/MarketWithDirectionLabel/MarketWithDirectionLabel.tsx
#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/ClaimsHistory.tsx
#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeRow.tsx
#: src/components/Synthetics/StatusNotification/FeesSettlementStatusNotification.tsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/TableMarketFilter/MarketFilterLongShort.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
#: src/context/SyntheticsEvents/SyntheticsEventsProvider.tsx
#: src/context/SyntheticsStateContext/selectors/chartSelectors/selectChartLines.tsx
#: src/domain/synthetics/orders/utils.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/Exchange/Exchange.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Long"
msgstr "Long"

#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxPoolRow.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxPoolRow.tsx
#: src/components/Synthetics/GmSwap/GmSwapBox/GmSwapBoxPoolRow.tsx
#: src/components/Synthetics/MarketsList/NetFeeTooltip.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/TradeBox/MarketPoolSelectorRow.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Pool"
msgstr "Pool"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Venus"
msgstr "Venus"

#: src/pages/Referrals/Referrals.tsx
msgid "Referral code creation failed."
msgstr "Referral code creation failed."

#: src/components/Glp/SwapErrorModal.tsx
msgid "<0>The pool's capacity has been reached for {0}. Please use another token to buy GLP.</0><1>Check the \"Save on Fees\" section for tokens with the lowest fees.</1>"
msgstr "<0>The pool's capacity has been reached for {0}. Please use another token to buy GLP.</0><1>Check the \"Save on Fees\" section for tokens with the lowest fees.</1>"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "GMX dashboards and analytics."
msgstr "GMX dashboards and analytics."

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "External Swap {0} to {1}"
msgstr "External Swap {0} to {1}"

#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Position"
msgstr "Position"

#: src/components/Synthetics/TradeFeesRow/TradeFeesRow.tsx
msgid "Bonus Rebate"
msgstr "Bonus Rebate"

#: src/components/Synthetics/TradeboxPoolWarnings/TradeboxPoolWarnings.tsx
msgid "You have an existing position in the {0} market pool, but it lacks liquidity for this order."
msgstr "You have an existing position in the {0} market pool, but it lacks liquidity for this order."

#: src/components/Exchange/PositionEditor.jsx
msgid "Enable Leverage"
msgstr "Enable Leverage"

#: src/components/Exchange/PositionSeller.jsx
msgid "Close without profit"
msgstr "Close without profit"

#: src/components/StatsTooltip/ChainsStatsTooltipRow.tsx
msgid "{title}"
msgstr "{title}"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Increasing"
msgstr "Increasing"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Fastest"
msgstr "Fastest"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "Avg. Lev."
msgstr "Avg. Lev."

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "No liquidity is available for increasing shorts for<0/>this size. Max short size: {0}<1/><2/>There is no price impact. There is a single<3/>execution price for decreasing longs for<4/>this size."
msgstr "No liquidity is available for increasing shorts for<0/>this size. Max short size: {0}<1/><2/>There is no price impact. There is a single<3/>execution price for decreasing longs for<4/>this size."

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "Avalanche LP incentives"
msgstr "Avalanche LP incentives"

#: src/components/Stake/GMXAprTooltip.tsx
msgid "{nativeTokenSymbol} APR"
msgstr "{nativeTokenSymbol} APR"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Telegram Group (Chinese)"
msgstr "Telegram Group (Chinese)"

#: src/components/Exchange/TradeHistory.jsx
msgid "Swap {0} {1} for {2} {3}"
msgstr "Swap {0} {1} for {2} {3}"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
msgid "<0>This will withdraw all esGMX tokens as well as pause vesting.<1/><2/>esGMX tokens that have been converted to GMX will be claimed and remain as GMX tokens.<3/><4/>To claim GMX tokens without withdrawing, use the \"Claim\" button.<5/><6/></0>"
msgstr "<0>This will withdraw all esGMX tokens as well as pause vesting.<1/><2/>esGMX tokens that have been converted to GMX will be claimed and remain as GMX tokens.<3/><4/>To claim GMX tokens without withdrawing, use the \"Claim\" button.<5/><6/></0>"

#: src/context/TokensFavoritesContext/TokensFavoritesContextProvider.tsx
msgid "DeFi"
msgstr "DeFi"

#: src/components/Synthetics/GmList/GlvList.tsx
#: src/components/Synthetics/GmList/GmList.tsx
msgid "SNAPSHOT"
msgstr "SNAPSHOT"

#: src/components/Synthetics/PositionEditor/PositionEditor.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
msgid "Liquidation Price"
msgstr "Liquidation Price"

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Voting Power"
msgstr "Voting Power"

#: src/components/Synthetics/TVChart/components/AvailableLiquidityTooltip.tsx
msgid "The long reserve accounts for the PnL of open positions, while the open interest does not."
msgstr "The long reserve accounts for the PnL of open positions, while the open interest does not."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel Take Profit"
msgstr "Cancel Take Profit"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Top PnL ($)"
msgstr "Top PnL ($)"

#: src/pages/AccountDashboard/AccountDashboard.tsx
msgid "Invalid address. Please make sure you have entered a valid Ethereum address"
msgstr "Invalid address. Please make sure you have entered a valid Ethereum address"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Sender has withdrawn all tokens from GMX Vesting Vault"
msgstr "Sender has withdrawn all tokens from GMX Vesting Vault"

#: src/components/Synthetics/Claims/ClaimHistoryRow/ClaimFundingFeesHistoryRow.tsx
#: src/components/Synthetics/Claims/filters/ActionFilter.tsx
msgid "Failed Settlement of Funding Fees"
msgstr "Failed Settlement of Funding Fees"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Pay Amount"
msgstr "Pay Amount"

#: src/pages/Dashboard/DashboardPageTitle.tsx
msgid "GLP is the liquidity provider token for GMX V1 markets. Accrues 70% of the V1 markets generated fees."
msgstr "GLP is the liquidity provider token for GMX V1 markets. Accrues 70% of the V1 markets generated fees."

#: src/domain/synthetics/orders/utils.tsx
msgid "{increaseOrDecreaseText} {tokenText} by {sizeText}"
msgstr "{increaseOrDecreaseText} {tokenText} by {sizeText}"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
#~ msgid "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees. Note: Selling will forfeit the $500,000 holding incentive."
#~ msgstr "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees. Note: Selling will forfeit the $500,000 holding incentive."

#: src/pages/Stake/UnstakeModal.tsx
msgid "{0}<0>You will earn {1}% less rewards with this action.</0>"
msgstr "{0}<0>You will earn {1}% less rewards with this action.</0>"

#: src/pages/Stake/AffiliateVesterWithdrawModal.tsx
msgid "Confirming..."
msgstr "Confirming..."

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Exchange/TradeHistory.jsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
#: src/domain/synthetics/orders/utils.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Increase"
msgstr "Increase"

#: src/pages/Stake/ClaimModal.tsx
msgid "Claim {wrappedTokenSymbol} Rewards"
msgstr "Claim {wrappedTokenSymbol} Rewards"

#: src/components/Glp/GlpSwap.jsx
#: src/pages/Dashboard/GmxCard.tsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Total Supply"
msgstr "Total Supply"

#: src/components/Exchange/NoLiquidityErrorModal.tsx
msgid "{0} Pool Capacity Reached"
msgstr "{0} Pool Capacity Reached"

#: src/components/Glp/GlpSwap.jsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Staked"
msgstr "Staked"

#: src/components/Footer/Footer.tsx
msgid "Leave feedback"
msgstr "Leave feedback"

#: src/pages/Referrals/Referrals.tsx
msgid "Traders"
msgstr "Traders"

#: src/domain/synthetics/orders/cancelOrdersTxn.ts
msgid "{ordersText} cancelled"
msgstr "{ordersText} cancelled"

#: src/domain/synthetics/positions/utils.ts
msgid "take profit"
msgstr "take profit"

#: src/components/DebugExpressSettings/DebugSwapsSettings.tsx
#: src/components/DebugSwapsSettings/DebugSwapsSettings.tsx
msgid "Force External Swaps"
msgstr "Force External Swaps"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Fees are high to swap from {0} to {1}. <0/>{2} is needed for collateral."
msgstr "Fees are high to swap from {0} to {1}. <0/>{2} is needed for collateral."

#: src/pages/PositionsOverview/PositionsOverview.jsx
msgid "size"
msgstr "size"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Create Limit Swap"
msgstr "Create Limit Swap"

#: src/components/Errors/errorToasts.tsx
msgid "<0>Your wallet is not connected to {0}.</0><1/><2>Switch to {1}</2>"
msgstr "<0>Your wallet is not connected to {0}.</0><1/><2>Switch to {1}</2>"

#: src/components/Errors/errorToasts.tsx
#: src/components/Errors/errorToasts.tsx
msgid "Transaction was cancelled."
msgstr "Transaction was cancelled."

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Accept confirmation of trigger orders"
msgstr "Accept confirmation of trigger orders"

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Choose to buy from decentralized or centralized exchanges."
msgstr "Choose to buy from decentralized or centralized exchanges."

#: src/components/Exchange/TradeHistory.jsx
msgid "Min required collateral"
msgstr "Min required collateral"

#: src/components/Exchange/TradeHistory.jsx
msgid "Try increasing the \"Allowed Slippage\", under the Settings menu on the top right"
msgstr "Try increasing the \"Allowed Slippage\", under the Settings menu on the top right"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "GMX ecosystem pages."
msgstr "GMX ecosystem pages."

#: src/components/TokenCard/TokenCard.tsx
msgid "{avalancheLink} GM Pools are <0>incentivized{sparkle}.</0>"
msgstr "{avalancheLink} GM Pools are <0>incentivized{sparkle}.</0>"

#: src/components/Exchange/PositionsList.jsx
#: src/lib/legacy.ts
msgid "Order size is bigger than position, will only be executable if position increases"
msgstr "Order size is bigger than position, will only be executable if position increases"

#: src/components/Header/AppHeaderLinks.tsx
msgid "Buy"
msgstr "Buy"

#: src/config/events.tsx
msgid "Incentives are live for <0>Arbitrum</0> and <1>Avalanche</1> GM pools and V2 trading."
msgstr "Incentives are live for <0>Arbitrum</0> and <1>Avalanche</1> GM pools and V2 trading."

#: src/pages/Stake/TotalRewardsCard.tsx
msgid "Total Rewards"
msgstr "Total Rewards"

#: src/pages/NftWallet/NftWallet.jsx
msgid "NFT ID"
msgstr "NFT ID"

#: src/domain/synthetics/markets/claimFundingFeesTxn.ts
#: src/domain/synthetics/referrals/claimAffiliateRewardsTxn.ts
msgid "Success claimings"
msgstr "Success claimings"

#: src/lib/legacy.ts
msgid "Decentralized Perpetual Exchange | GMX"
msgstr "Decentralized Perpetual Exchange | GMX"

#: src/components/Exchange/PositionEditor.jsx
msgid "The pending borrow fee will be charged on this transaction."
msgstr "The pending borrow fee will be charged on this transaction."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Fees will be shown once you have entered an amount in the order form."
msgstr "Fees will be shown once you have entered an amount in the order form."

#: src/pages/Stake/Vesting.tsx
#: src/pages/Stake/Vesting.tsx
msgid "GLP Vault"
msgstr "GLP Vault"

#: src/components/Footer/constants.ts
#: src/pages/ReferralTerms/ReferralTerms.jsx
msgid "Referral Terms"
msgstr "Referral Terms"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Enter unique coins"
msgstr "Enter unique coins"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
#~ msgid "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees. Selling will reduce your incentive eligibility proportionally."
#~ msgstr "Yes, GLV is fully liquid and permissionless. You can sell via the GMX interface to redeem for underlying assets, with low fees. Selling will reduce your incentive eligibility proportionally."

#: src/components/Synthetics/GmList/FeeApyLabel.tsx
msgid "Fee APY"
msgstr "Fee APY"

#: src/components/MarketSelector/MarketSelector.tsx
#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "No markets matched."
msgstr "No markets matched."

#: src/pages/Stake/Stake.tsx
msgid "Stake esGMX"
msgstr "Stake esGMX"

#: src/pages/Dashboard/MarketsListV1.tsx
#: src/pages/Dashboard/MarketsListV1.tsx
msgid "Target Min Amount"
msgstr "Target Min Amount"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Fees exceed Pay amount"
msgstr "Fees exceed Pay amount"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Market Swap"
msgstr "Failed Market Swap"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "HoudiniSwap"
msgstr "HoudiniSwap"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "dynamically allocates its liquidity to the highest-utilised markets, maximising capital efficiency and annualized performance"
msgstr "dynamically allocates its liquidity to the highest-utilised markets, maximising capital efficiency and annualized performance"

#: src/components/NpsModal/NpsModal.tsx
#: src/components/UserFeedbackModal/UserFeedbackModal.tsx
msgid "Error occurred. Please try again"
msgstr "Error occurred. Please try again"

#: src/components/Referrals/referralsHelper.js
msgid "Only letters, numbers and underscores are allowed."
msgstr "Only letters, numbers and underscores are allowed."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Fulfilling shift request"
msgstr "Fulfilling shift request"

#: src/pages/Referrals/Referrals.tsx
msgid "Referral code submitted!"
msgstr "Referral code submitted!"

#: src/context/PendingTxnsContext/PendingTxnsContext.tsx
#~ msgid "Transaction failed due to execution fee validation. <0>View</0>.<1/><2/>Please <3>enable Express trading</3> under settings, which should offer a better experience.<4/><5/>Otherwise, try increasing the max network fee buffer to {0} in <6>settings</6>."
#~ msgstr "Transaction failed due to execution fee validation. <0>View</0>.<1/><2/>Please <3>enable Express trading</3> under settings, which should offer a better experience.<4/><5/>Otherwise, try increasing the max network fee buffer to {0} in <6>settings</6>."

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "APY"
msgstr "APY"

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
msgid "Last month"
msgstr "Last month"

#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
msgid "Leave at least {0} {1} for gas"
msgstr "Leave at least {0} {1} for gas"

#: src/pages/Dashboard/GmxCard.tsx
msgid "staked"
msgstr "staked"

#: src/components/Errors/errorToasts.tsx
#: src/components/Errors/errorToasts.tsx
msgid "There is not enough {0} in your account on {1} to send this transaction.<0/><1/><2>Buy or Transfer {2} to {3}</2>"
msgstr "There is not enough {0} in your account on {1} to send this transaction.<0/><1/><2>Buy or Transfer {2} to {3}</2>"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Total Volume"
msgstr "Total Volume"

#: src/components/Exchange/OrderEditor.jsx
#: src/components/Exchange/OrderEditor.jsx
msgid "Enter new Price"
msgstr "Enter new Price"

#: src/pages/Stake/Vesting.tsx
msgid "Withdraw from GLP Vault"
msgstr "Withdraw from GLP Vault"

#: src/components/Exchange/PositionShare.tsx
msgid "Image generation error, please refresh and try again."
msgstr "Image generation error, please refresh and try again."

#: src/components/Synthetics/Claims/ClaimableCardUI.tsx
#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Price Impact Rebates"
msgstr "Price Impact Rebates"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Take Profit and Stop Loss orders will be automatically cancelled when the associated position is completely closed. This will only affect newly created TP/SL orders."
msgstr "Take Profit and Stop Loss orders will be automatically cancelled when the associated position is completely closed. This will only affect newly created TP/SL orders."

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed TWAP Swap Part"
msgstr "Failed TWAP Swap Part"

#: src/components/Exchange/ExchangeTVChart.jsx
msgid "Open {0} {longOrShortText}"
msgstr "Open {0} {longOrShortText}"

#: src/components/InterviewToast/InterviewToast.tsx
msgid "Give us your feedback on GMX."
msgstr "Give us your feedback on GMX."

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Current Borrow Fee / Day"
msgstr "Current Borrow Fee / Day"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Rebates on V1"
msgstr "Rebates on V1"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Invalid token indexToken: \"{0}\" collateralToken: \"{1}\""
msgstr "Invalid token indexToken: \"{0}\" collateralToken: \"{1}\""

#: src/components/AddressDropdown/AddressDropdown.tsx
#: src/components/Header/AppHeaderLinks.tsx
msgid "Alerts"
msgstr "Alerts"

#: src/components/Exchange/OrdersList.jsx
msgid "<0>The price that orders can be executed at may differ slightly from the chart price, as market orders update oracle prices, while limit/trigger orders do not.</0><1>This can also cause limit/triggers to not be executed if the price is not reached for long enough. <2>Read more</2>.</1>"
msgstr "<0>The price that orders can be executed at may differ slightly from the chart price, as market orders update oracle prices, while limit/trigger orders do not.</0><1>This can also cause limit/triggers to not be executed if the price is not reached for long enough. <2>Read more</2>.</1>"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DeFi Portfolio Tracker"
msgstr "DeFi Portfolio Tracker"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Current Funding Fee / Day"
msgstr "Current Funding Fee / Day"

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
msgid "365d estimate based on past {daysConsidered}d APY."
msgstr "365d estimate based on past {daysConsidered}d APY."

#: src/components/TokenCard/TokenCard.tsx
msgid "Arbitrum APR:"
msgstr "Arbitrum APR:"

#: src/pages/Jobs/Jobs.jsx
msgid "Job Openings"
msgstr "Job Openings"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Projects integrated with GMX."
msgstr "Projects integrated with GMX."

#: src/components/Stake/GMXAprTooltip.tsx
msgid "Escrowed GMX APR"
msgstr "Escrowed GMX APR"

#: src/components/Exchange/TradeHistory.jsx
msgid "Initial collateral"
msgstr "Initial collateral"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Activate 1CT (One-Click Trading)"
msgstr "Activate 1CT (One-Click Trading)"

#: src/components/AprInfo/AprInfo.tsx
msgid "The Bonus APR will be airdropped as {airdropTokenTitle} tokens. <0>Read more</0>."
msgstr "The Bonus APR will be airdropped as {airdropTokenTitle} tokens. <0>Read more</0>."

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
#: src/components/Synthetics/GmList/GmListItem.tsx
#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
#: src/pages/PoolsDetails/PoolsDetailsHeader.tsx
#: src/pages/Stake/EscrowedGmxCard.tsx
#: src/pages/Stake/GlpCard.tsx
#: src/pages/Stake/GmxAndVotingPowerCard.tsx
#: src/pages/Stake/VesterDepositModal.tsx
msgid "Wallet"
msgstr "Wallet"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "You have a pending transfer from {sender}."
msgstr "You have a pending transfer from {sender}."

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Once the mark price hits the stop price, the order will attempt to execute."
msgstr "Once the mark price hits the stop price, the order will attempt to execute."

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Enter a trigger price"
msgstr "Enter a trigger price"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Vested GLP not withdrawn"
msgstr "Vested GLP not withdrawn"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "<0>every</0> {minutes} minutes{0}"
msgstr "<0>every</0> {minutes} minutes{0}"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/EntryPriceRow.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Entry Price"
msgstr "Entry Price"

#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "Price change to Liq."
msgstr "Price change to Liq."

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "STIP.b LP incentives"
msgstr "STIP.b LP incentives"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Cancel Stop Loss"
msgstr "Cancel Stop Loss"

#: src/components/Exchange/PositionsList.jsx
msgid "Click on the Position to select its market, then use the trade box to increase your Position Size if needed."
msgstr "Click on the Position to select its market, then use the trade box to increase your Position Size if needed."

#: src/domain/synthetics/orders/utils.tsx
msgid "Limit Decrease"
msgstr "Limit Decrease"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Stabilize Protocol"
msgstr "Stabilize Protocol"

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Enter a valid coin names"
msgstr "Enter a valid coin names"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "Cumulative PnL: <0>{0}</0>"
msgstr "Cumulative PnL: <0>{0}</0>"

#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "Long Liq."
msgstr "Long Liq."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GBC Kudai AI Agent"
msgstr "GBC Kudai AI Agent"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "You have {0} esGMX (IOU) tokens."
msgstr "You have {0} esGMX (IOU) tokens."

#: src/domain/synthetics/orders/utils.tsx
msgid "There is currently a high swap price impact for the order swap path."
msgstr "There is currently a high swap price impact for the order swap path."

#: src/components/Exchange/PositionDropdown.tsx
msgid "Increase Size (Stop Market)"
msgstr "Increase Size (Stop Market)"

#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
msgid "Stop Loss PnL"
msgstr "Stop Loss PnL"

#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "Withdrawing {balanceFormatted}  to Main Account"
msgstr "Withdrawing {balanceFormatted}  to Main Account"

#: src/components/Synthetics/SettleAccruedFundingFeeModal/SettleAccruedFundingFeeModal.tsx
msgid "Settling..."
msgstr "Settling..."

#: src/components/Exchange/UsefulLinks.tsx
#: src/components/Header/AppHeaderLinks.tsx
msgid "Leaderboard"
msgstr "Leaderboard"

#: src/domain/synthetics/orders/utils.tsx
msgid "There may not be enough liquidity to execute parts of this order when the time conditions are met."
msgstr "There may not be enough liquidity to execute parts of this order when the time conditions are met."

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
msgid "The PnL ($) compared to the capital used.<0/><1/>The capital used is calculated as the highest value of [<2>sum of collateral of open positions - realized PnL + period start pending PnL</2>]."
msgstr "The PnL ($) compared to the capital used.<0/><1/>The capital used is calculated as the highest value of [<2>sum of collateral of open positions - realized PnL + period start pending PnL</2>]."

#: src/components/Synthetics/Claims/SettleAccruedCard.tsx
msgid "Accrued"
msgstr "Accrued"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Liquidation price is influenced by fees and collateral value."
msgstr "Liquidation price is influenced by fees and collateral value."

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "No data available"
msgstr "No data available"

#: src/pages/LeaderboardPage/components/CompetitionCountdown.tsx
msgid "{prefix} <0>{text}</0>"
msgstr "{prefix} <0>{text}</0>"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Failed to update settings"
msgstr "Failed to update settings"

#: src/components/Synthetics/TradeBox/TradeBoxRows/PriceImpactFeesRow.tsx
msgid "Positive Price Impact / Fees"
msgstr "Positive Price Impact / Fees"

#: src/components/Exchange/PositionShare.tsx
msgid "Tweet"
msgstr "Tweet"

#: src/components/Synthetics/MarketTokenSelector/MarketTokenSelector.tsx
msgid "SELL…"
msgstr "SELL…"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Confirm Swap"
msgstr "Confirm Swap"

#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
msgid "Keep leverage is not available as Position exceeds max. allowed leverage. <0>Read more</0>."
msgstr "Keep leverage is not available as Position exceeds max. allowed leverage. <0>Read more</0>."

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Add {0} to Metamask"
msgstr "Add {0} to Metamask"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Failed Stop Loss"
msgstr "Failed Stop Loss"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "Daily Profit"
msgstr "Daily Profit"

#: src/pages/ClaimEsGmx/ClaimEsGmx.jsx
msgid "The esGMX tokens can be staked or vested at any time."
msgstr "The esGMX tokens can be staked or vested at any time."

#: src/pages/BuyGMX/BuyGMX.tsx
msgid "Buy ETH directly on Arbitrum or transfer it there."
msgstr "Buy ETH directly on Arbitrum or transfer it there."

#: src/components/MissedCoinsModal/MissedCoinsModal.tsx
msgid "Max 110 symbols exceeded"
msgstr "Max 110 symbols exceeded"

#: src/components/Errors/errorToasts.tsx
#: src/components/Errors/errorToasts.tsx
msgid "Transaction failed"
msgstr "Transaction failed"

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "COLLATERAL"
msgstr "COLLATERAL"

#: src/components/Synthetics/Claims/SettleAccruedCard.tsx
msgid "Accrued price impact rebates. They will become claimable after approximately ten days.<0/><1/><2>Read more</2>."
msgstr "Accrued price impact rebates. They will become claimable after approximately ten days.<0/><1/><2>Read more</2>."

#: src/components/Exchange/PositionEditor.jsx
#: src/pages/Stake/VesterDepositModal.tsx
msgid "Depositing..."
msgstr "Depositing..."

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
#: src/components/Synthetics/PoolSelector2/PoolSelector2.tsx
msgid "Net Rate"
msgstr "Net Rate"

#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
#: src/pages/LeaderboardPage/components/CompetitionPrizes.tsx
msgid "2nd Place"
msgstr "2nd Place"

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "LAST PRICE"
msgstr "LAST PRICE"

#: src/components/Synthetics/TradeBox/ExpressTradingWarningCard.tsx
msgid "Re-sign"
msgstr "Re-sign"

#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/AccountDashboard/HistoricalLists.tsx
#: src/pages/SyntheticsPage/SyntheticsPage.tsx
msgid "Orders ({ordersCount})"
msgstr "Orders ({ordersCount})"

#: src/components/TVChartContainer/constants.ts
msgid "Limit - Long Inc."
msgstr "Limit - Long Inc."

#: src/pages/Stake/ClaimModal.tsx
msgid "<0>Delegate your undelegated {0} GMX DAO</0>voting power before claiming."
msgstr "<0>Delegate your undelegated {0} GMX DAO</0>voting power before claiming."

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "Claim funds"
msgstr "Claim funds"

#: src/components/Synthetics/TradeBox/hooks/useCollateralInTooltipContent.tsx
msgid "You will be long {indexSymbol} from your long position, as well as from your {collateralSymbol} collateral. The liquidation price is higher compared to using a stablecoin as collateral since the worth of the collateral will change with its price."
msgstr "You will be long {indexSymbol} from your long position, as well as from your {collateralSymbol} collateral. The liquidation price is higher compared to using a stablecoin as collateral since the worth of the collateral will change with its price."

#: src/components/Synthetics/StatusNotification/GmStatusNotification.tsx
msgid "Sell order cancelled"
msgstr "Sell order cancelled"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Last 30 days"
msgstr "Last 30 days"

#: src/components/DepthChart/DepthChartTooltip.tsx
#: src/components/Synthetics/ExecutionPriceRow.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
msgid "Execution Price"
msgstr "Execution Price"

#: src/components/Exchange/OrdersList.jsx
msgid "The price that the order can be executed at may differ slightly from the chart price as market orders can change the price while limit / trigger orders cannot."
msgstr "The price that the order can be executed at may differ slightly from the chart price as market orders can change the price while limit / trigger orders cannot."

#: src/components/Synthetics/Claims/ClaimsHistory.tsx
msgid "Claims History"
msgstr "Claims History"

#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "About"
msgstr "About"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "This may take a few minutes."
msgstr "This may take a few minutes."

#: src/components/Synthetics/Claims/SettleAccruedCard.tsx
msgid "Accrued positive funding fees in positions not yet claimable.<0/><1/>They become available after modifying the position by increasing or decreasing it, depositing or withdrawing collateral, or settling the fees using the \"Settle\" button."
msgstr "Accrued positive funding fees in positions not yet claimable.<0/><1/>They become available after modifying the position by increasing or decreasing it, depositing or withdrawing collateral, or settling the fees using the \"Settle\" button."

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
msgid "Fee values do not include incentives."
msgstr "Fee values do not include incentives."

#: src/components/Referrals/AddAffiliateCode.jsx
msgid "Generate Referral Code"
msgstr "Generate Referral Code"

#: src/components/Synthetics/HighPriceImpactOrFeesWarningCard/HighPriceImpactOrFeesWarningCard.tsx
msgid "High Swap Price Impact"
msgstr "High Swap Price Impact"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/components/Synthetics/SwapCard/SwapCard.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Swap"
msgstr "Swap"

#: src/domain/synthetics/orders/utils.tsx
msgid "long"
msgstr "long"

#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/components/Synthetics/TVChart/ChartHeader.tsx
msgid "24h High"
msgstr "24h High"

#: src/components/Referrals/ReferralCodeWarnings.tsx
msgid "This code is not yet registered on {nonTakenNetworkNames}, you will not receive rebates there.<0/><1/>Switch your network to create this code on {nonTakenNetworkNames}."
msgstr "This code is not yet registered on {nonTakenNetworkNames}, you will not receive rebates there.<0/><1/>Switch your network to create this code on {nonTakenNetworkNames}."

#: src/components/Exchange/TradeHistory.jsx
msgid "Deposit {0} USD into {1} {longOrShortText}"
msgstr "Deposit {0} USD into {1} {longOrShortText}"

#: src/pages/Dashboard/GmxCard.tsx
msgid "Distribution"
msgstr "Distribution"

#: src/components/NetworkDropdown/NetworkDropdown.tsx
msgid "Language"
msgstr "Language"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Complete Transfer"
msgstr "Complete Transfer"

#: src/pages/Home/Home.tsx
msgid "Total Users"
msgstr "Total Users"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "Net Value: Initial Collateral + PnL - Borrow Fee - Negative Funding Fee - Close Fee"
msgstr "Net Value: Initial Collateral + PnL - Borrow Fee - Negative Funding Fee - Close Fee"

#: src/domain/synthetics/sidecarOrders/utils.ts
msgid "Trigger price below lowest limit price"
msgstr "Trigger price below lowest limit price"

#: src/components/Exchange/PositionDropdown.tsx
#: src/components/Exchange/PositionShare.tsx
msgid "Share Position"
msgstr "Share Position"

#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
msgid "Min leverage: 1.1x"
msgstr "Min leverage: 1.1x"

#: src/components/Exchange/FeesTooltip.tsx
msgid "Deposit Fee"
msgstr "Deposit Fee"

#: src/domain/synthetics/orders/getPositionOrderError.tsx
msgid "Enter a new size or price"
msgstr "Enter a new size or price"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max pool amount exceeded"
msgstr "Max pool amount exceeded"

#: src/components/Exchange/SwapBox.jsx
msgid "The borrow fee is calculated as (assets borrowed) / (total assets in pool) * 0.01% per hour."
msgstr "The borrow fee is calculated as (assets borrowed) / (total assets in pool) * 0.01% per hour."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Unknown order"
msgstr "Unknown order"

#: src/pages/Jobs/Jobs.jsx
msgid "No open positions at GMX currently"
msgstr "No open positions at GMX currently"

#: src/domain/synthetics/orders/useOrderTxnCallbacks.tsx
msgid "Max Action Count Reached. <0>Click here</0> to update."
msgstr "Max Action Count Reached. <0>Click here</0> to update."

#: src/components/Exchange/TradeHistory.jsx
msgid "Execute Order: {orderTypeText} {0} {longShortDisplay} {sizeDeltaDisplay} USD, Price: {executionPriceDisplay} USD"
msgstr "Execute Order: {orderTypeText} {0} {longShortDisplay} {sizeDeltaDisplay} USD, Price: {executionPriceDisplay} USD"

#: src/components/Synthetics/MarketStats/components/CompositionTable.tsx
msgid "{column}"
msgstr "{column}"

#: src/pages/LeaderboardPage/components/LeaderboardAccountsTable.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
msgid "You do not have any eligible trade during the competition window."
msgstr "You do not have any eligible trade during the competition window."

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "Execution prices for increasing longs and<0/>decreasing shorts."
msgstr "Execution prices for increasing longs and<0/>decreasing shorts."

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "Processing your claim…"
msgstr "Processing your claim…"

#: src/components/Synthetics/DateRangeSelect/DateRangeSelect.tsx
#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
#: src/pages/Pools/PoolsTimeRangeFilter.tsx
msgid "Last 30d"
msgstr "Last 30d"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Dashboards"
msgstr "Dashboards"

#: src/components/Synthetics/TradeBox/hooks/useTradeButtonState.tsx
msgid "Create TWAP {0} order"
msgstr "Create TWAP {0} order"

#: src/domain/synthetics/trade/utils/validation.ts
msgid "Leftover collateral below {0} USD"
msgstr "Leftover collateral below {0} USD"

#: src/domain/synthetics/positions/utils.ts
msgid "trigger"
msgstr "trigger"

#: src/components/Glp/GlpSwap.jsx
#~ msgid "Please <0>read here</0> for more information."
#~ msgstr "Please <0>read here</0> for more information."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Rage Trade"
msgstr "Rage Trade"

#: src/pages/Home/Home.tsx
msgid "Trade BTC, ETH, AVAX and other top cryptocurrencies with up to 100x leverage directly from your wallet"
msgstr "Trade BTC, ETH, AVAX and other top cryptocurrencies with up to 100x leverage directly from your wallet"

#: src/pages/Stake/ClaimModal.tsx
msgid "Claim GMX Rewards"
msgstr "Claim GMX Rewards"

#: src/components/Referrals/JoinReferralCode.tsx
#: src/components/Referrals/JoinReferralCode.tsx
msgid "Enter Referral Code"
msgstr "Enter Referral Code"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
#: src/pages/LeaderboardPage/components/LeaderboardNavigation.tsx
msgid "EIP-4844, 20-27 Mar"
msgstr "EIP-4844, 20-27 Mar"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
#: src/pages/NftWallet/NftWallet.jsx
msgid "Transfer failed."
msgstr "Transfer failed."

#: src/components/Exchange/PositionEditor.jsx
msgid "Deposit amount is insufficient to bring leverage below the max allowed leverage of 100x"
msgstr "Deposit amount is insufficient to bring leverage below the max allowed leverage of 100x"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/PositionEditor.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/OrderItem/OrderItem.tsx
#: src/components/Synthetics/OrderList/OrderList.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionList/PositionList.tsx
#: src/components/Synthetics/TradeHistory/useDownloadAsCsv.tsx
#: src/pages/LeaderboardPage/components/LeaderboardPositionsTable.tsx
#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Mark Price"
msgstr "Mark Price"

#: src/components/Synthetics/GmAssetDropdown/GmAssetDropdown.tsx
msgid "Open {marketName} in Explorer"
msgstr "Open {marketName} in Explorer"

#: src/components/Exchange/TradeHistory.jsx
msgid "Partial Liquidation"
msgstr "Partial Liquidation"

#: src/components/Synthetics/TVChart/ChartHeader.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "24h Volume"
msgstr "24h Volume"

#: src/pages/Dashboard/DashboardV2.tsx
msgid "Total Stats"
msgstr "Total Stats"

#: src/domain/synthetics/claims/useClaimFundsTransactionCallback.tsx
msgid "Claimed {0} successfully."
msgstr "Claimed {0} successfully."

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Frequency"
msgstr "Frequency"

#: src/components/Exchange/PositionEditor.jsx
msgid "Enable deposit sent."
msgstr "Enable deposit sent."

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Withdrawing {0} from {positionText}"
msgstr "Withdrawing {0} from {positionText}"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Community Projects"
msgstr "Community Projects"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
#: src/domain/synthetics/orders/utils.tsx
msgid "Limit Swap"
msgstr "Limit Swap"

#: src/components/DepthChart/DepthChartTooltip.tsx
msgid "No liquidity is available for increasing longs for<0/>this size. Max long size: {0}<1/><2/>Execution prices for decreasing shorts."
msgstr "No liquidity is available for increasing longs for<0/>this size. Max long size: {0}<1/><2/>Execution prices for decreasing shorts."

#: src/components/Synthetics/ChartTokenSelector/ChartTokenSelector.tsx
msgid "24H VOL."
msgstr "24H VOL."

#: src/components/Synthetics/UserIncentiveDistributionList/ClaimableAmounts.tsx
msgid "Accept Claim Terms"
msgstr "Accept Claim Terms"

#: src/components/Glp/GlpSwap.jsx
#: src/components/Glp/GlpSwap.jsx
msgid "Sell for {0}"
msgstr "Sell for {0}"

#: src/components/Exchange/PositionSeller.jsx
msgid "Fees are higher than Collateral"
msgstr "Fees are higher than Collateral"

#: src/components/Referrals/TradersStats.tsx
msgid "You will receive a {currentTierDiscount}% discount on opening and closing fees."
msgstr "You will receive a {currentTierDiscount}% discount on opening and closing fees."

#: src/components/InterviewModal/InterviewModal.tsx
msgid "Anonymous chat with GMX team"
msgstr "Anonymous chat with GMX team"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "GMX Market Token Price Chart"
msgstr "GMX Market Token Price Chart"

#: src/pages/LeaderboardPage/components/LeaderboardContainer.tsx
msgid "Top Addresses"
msgstr "Top Addresses"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Continue"
msgstr "Continue"

#: src/pages/AccountDashboard/DailyAndCumulativePnL.tsx
msgid "Daily and Cumulative PnL"
msgstr "Daily and Cumulative PnL"

#: src/components/Exchange/PositionEditor.jsx
msgid "Edit {longOrShortText} {0}"
msgstr "Edit {longOrShortText} {0}"

#: src/domain/synthetics/orders/utils.tsx
msgid "short"
msgstr "short"

#: src/components/RatingToast/RatingToast.tsx
msgid "Very likely"
msgstr "Very likely"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "I am aware of the trigger orders"
msgstr "I am aware of the trigger orders"

#: src/domain/synthetics/orders/cancelOrdersTxn.ts
msgid "{count, plural, one {Order} other {# Orders}}"
msgstr "{count, plural, one {Order} other {# Orders}}"

#: src/components/Referrals/AffiliatesStats.tsx
msgid "Volume on V1"
msgstr "Volume on V1"

#: src/domain/synthetics/common/incentivesAirdropMessages.ts
msgid "Avalanche trading incentives"
msgstr "Avalanche trading incentives"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Request Market Decrease"
msgstr "Request Market Decrease"

#: src/domain/synthetics/trade/utils/validation.ts
#: src/domain/synthetics/trade/utils/validation.ts
msgid "Max. Leverage exceeded"
msgstr "Max. Leverage exceeded"

#: src/components/Exchange/OrderEditor.jsx
msgid "Price is above Mark Price"
msgstr "Price is above Mark Price"

#: src/components/Synthetics/PositionItem/PositionItem.tsx
msgid "This position could be liquidated, excluding any price movement, due to funding and borrowing fee rates reducing the position's collateral over time."
msgstr "This position could be liquidated, excluding any price movement, due to funding and borrowing fee rates reducing the position's collateral over time."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Gemini Wallet is not supported for Express or One-Click trading."
msgstr "Gemini Wallet is not supported for Express or One-Click trading."

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Your wallet, your keys. You sign each transaction off-chain. Trades use GMX-sponsored premium RPCs for reliability, even during network congestion. Gas payments in USDC or WETH."
msgstr "Your wallet, your keys. You sign each transaction off-chain. Trades use GMX-sponsored premium RPCs for reliability, even during network congestion. Gas payments in USDC or WETH."

#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
#: src/components/Synthetics/TradeHistory/TradeHistoryRow/utils/position.ts
msgid "Order Execution Price"
msgstr "Order Execution Price"

#: src/components/Exchange/ConfirmationBox.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Synthetics/PositionSeller/rows/AllowedSlippageRow.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/AllowedSlippageRow.tsx
msgid "Slippage is too high"
msgstr "Slippage is too high"

#: src/components/Synthetics/MarketsList/NetFeeHeaderTooltipContent.tsx
msgid "Net rate combines funding and borrowing fees but excludes open, swap or impact fees.<0/><1/>Funding fees help to balance longs and shorts and are exchanged between both sides. <2>Read more</2>.<3/><4/>Borrowing fees help ensure available liquidity. <5>Read more</5>."
msgstr "Net rate combines funding and borrowing fees but excludes open, swap or impact fees.<0/><1/>Funding fees help to balance longs and shorts and are exchanged between both sides. <2>Read more</2>.<3/><4/>Borrowing fees help ensure available liquidity. <5>Read more</5>."

#: src/components/Synthetics/AccruedPositionPriceImpactRebateModal/AccruedPositionPriceImpactRebateModal.tsx
msgid "Accrued Price Impact Rebates"
msgstr "Accrued Price Impact Rebates"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "Yesterday"
msgstr "Yesterday"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Request Deposit"
msgstr "Request Deposit"

#: src/components/Exchange/PositionEditor.jsx
msgid "Deposit not enough to cover fees"
msgstr "Deposit not enough to cover fees"

#: src/components/Synthetics/TwapRows/TwapRows.tsx
msgid "Number of Parts"
msgstr "Number of Parts"

#: src/domain/synthetics/orders/cancelOrdersTxn.ts
msgid "Cancelling {ordersText}"
msgstr "Cancelling {ordersText}"

#: src/context/SubaccountContext/SubaccountContextProvider.tsx
msgid "Deactivated"
msgstr "Deactivated"

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Ecosystem Projects"
msgstr "Ecosystem Projects"

#: src/domain/synthetics/orders/useDisabledCancelMarketOrderMessage.ts
msgid "Market order will be cancellable in ..."
msgstr "Market order will be cancellable in ..."

#: src/domain/synthetics/claimHistory/claimPriceImpactRebate.ts
msgid "Price Impact Rebate Claimed"
msgstr "Price Impact Rebate Claimed"

#: src/components/InterviewModal/InterviewModal.tsx
msgid "Anonymous chat with GMX"
msgstr "Anonymous chat with GMX"

#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/OrdersList.jsx
#: src/components/Exchange/SwapBox.jsx
#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/OrderList/filters/OrderTypeFilter.tsx
#: src/components/Synthetics/TradeBox/tradeboxConstants.tsx
#: src/components/Synthetics/TradeBox/TradeBoxRows/LimitAndTPSLRows.tsx
#: src/components/Synthetics/TradeHistory/keys.ts
#: src/domain/synthetics/positions/utils.ts
msgid "Limit"
msgstr "Limit"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "You will receive at least {toAmountText} if this order is executed. This price is being updated in real time based on swap fees and price impact."
msgstr "You will receive at least {toAmountText} if this order is executed. This price is being updated in real time based on swap fees and price impact."

#: src/components/Synthetics/ExecutionPriceRow.tsx
msgid "Acceptable price does not apply to stop loss orders, as they will be executed regardless of any price impact."
msgstr "Acceptable price does not apply to stop loss orders, as they will be executed regardless of any price impact."

#: src/components/InterviewModal/InterviewModal.tsx
msgid "We'll then schedule a chat or interview with you. As a thank you, you'll receive <0>100 <1/></0> for providing your feedback."
msgstr "We'll then schedule a chat or interview with you. As a thank you, you'll receive <0>100 <1/></0> for providing your feedback."

#: src/domain/synthetics/positions/utils.ts
msgid "limit"
msgstr "limit"

#: src/components/SettingsModal/SettingsModal.tsx
msgid "Trading Settings"
msgstr "Trading Settings"

#: src/components/Exchange/OrdersToa.jsx
msgid "<0>Insufficient liquidity to execute the order</0><1>The mark price which is an aggregate of exchange prices did not reach the specified price</1><2>The specified price was reached but not long enough for it to be executed</2><3>No keeper picked up the order for execution</3>"
msgstr "<0>Insufficient liquidity to execute the order</0><1>The mark price which is an aggregate of exchange prices did not reach the specified price</1><2>The specified price was reached but not long enough for it to be executed</2><3>No keeper picked up the order for execution</3>"

#: src/components/Exchange/ConfirmationBox.jsx
msgid "Your position's collateral after deducting fees:"
msgstr "Your position's collateral after deducting fees:"

#: src/components/Glp/GlpSwap.jsx
msgid "Selling..."
msgstr "Selling..."

#: src/domain/synthetics/orders/utils.tsx
msgid "The order may not execute as the max. allowed leverage is exceeded. Consider decreasing the order's leverage by editing and decreasing its size. <0>Read more</0>."
msgstr "The order may not execute as the max. allowed leverage is exceeded. Consider decreasing the order's leverage by editing and decreasing its size. <0>Read more</0>."

#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionSeller.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Exchange/PositionsList.jsx
#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionItem/PositionItem.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/PositionSeller/PositionSeller.tsx
#: src/components/Synthetics/TradeBox/TradeBox.tsx
#: src/components/Synthetics/TradeInfoIcon/TradeInfoIcon.tsx
msgid "Close"
msgstr "Close"

#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
#: src/pages/Ecosystem/Ecosystem.tsx
msgid "Link"
msgstr "Link"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
#: src/pages/Dashboard/OverviewCard.tsx
msgid "Long Positions"
msgstr "Long Positions"

#: src/components/Synthetics/StatusNotification/OrderStatusNotification.tsx
msgid "Depositing {0} to {positionText}"
msgstr "Depositing {0} to {positionText}"

#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
msgid "Max Network Fee"
msgstr "Max Network Fee"

#: src/domain/tokens/approveTokens.tsx
msgid "Approval was cancelled"
msgstr "Approval was cancelled"

#: src/components/Synthetics/MarketNetFee/MarketNetFee.tsx
msgid "{longOrShort} positions do not pay a funding fee and pay a borrow fee of {borrowRate} per hour."
msgstr "{longOrShort} positions do not pay a funding fee and pay a borrow fee of {borrowRate} per hour."

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Increase active: {0}, executed: {1}, cancelled: {2}"
msgstr "Increase active: {0}, executed: {1}, cancelled: {2}"

#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
#: src/components/Synthetics/NetworkFeeRow/NetworkFeeRow.tsx
msgid "Maximum network fee paid to the network. This fee is a blockchain cost not specific to GMX, and it does not impact your collateral."
msgstr "Maximum network fee paid to the network. This fee is a blockchain cost not specific to GMX, and it does not impact your collateral."

#: src/pages/Ecosystem/Ecosystem.tsx
msgid "GMX Pages"
msgstr "GMX Pages"

#: src/components/Exchange/SwapBox.jsx
msgid "{0} is required for collateral."
msgstr "{0} is required for collateral."

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "Decentralized Options Protocol"
msgstr "Decentralized Options Protocol"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update TWAP Swap Part"
msgstr "Update TWAP Swap Part"

#: src/components/Synthetics/TradeHistory/keys.ts
msgid "Update TWAP Part"
msgstr "Update TWAP Part"

#: src/components/Synthetics/UserIncentiveDistributionList/AboutGlpIncident.tsx
msgid "How does GLV earn yield, and where do I see my earnings?"
msgstr "How does GLV earn yield, and where do I see my earnings?"

#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
#: src/pages/CompleteAccountTransfer/CompleteAccountTransfer.jsx
msgid "Complete Account Transfer"
msgstr "Complete Account Transfer"

#: src/pages/Stake/ClaimModal.tsx
msgid "Claim Rewards"
msgstr "Claim Rewards"

#: src/components/AddressDropdown/AddressDropdown.tsx
msgid "Copy Address"
msgstr "Copy Address"

#: src/pages/BeginAccountTransfer/BeginAccountTransfer.tsx
msgid "Pending Transfer Approval"
msgstr "Pending Transfer Approval"

#: src/components/Synthetics/OrderItem/OrderItem.tsx
msgid "<0>{fromTokenText} </0>{fromTokenIcon}<1> to </1>{0}{toTokenIcon}{1}"
msgstr "<0>{fromTokenText} </0>{fromTokenIcon}<1> to </1>{0}{toTokenIcon}{1}"

#: src/components/DepthChart/DepthChart.tsx
msgid "ORACLE PRICE"
msgstr "ORACLE PRICE"

#: src/pages/Dashboard/DashboardV2.tsx
msgid "For detailed stats:"
msgstr "For detailed stats:"

#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
#: src/components/Synthetics/GmList/GmTokensTotalBalanceInfo.tsx
#: src/pages/PoolsDetails/PoolsDetailsHeader.tsx
msgid "Total Earned Fees"
msgstr "Total Earned Fees"

#: src/components/Synthetics/OrderEditor/OrderEditor.tsx
msgid "Enter a ratio"
msgstr "Enter a ratio"

#: src/pages/Dashboard/AssetDropdown.tsx
msgid "Proof of Reserves"
msgstr "Proof of Reserves"

#: src/pages/AccountDashboard/GeneralPerformanceDetails.tsx
msgid "General Performance Details"
msgstr "General Performance Details"

#: src/pages/Stake/VesterWithdrawModal.tsx
msgid "<0>This will withdraw and unreserve all tokens as well as pause vesting.<1/><2/>esGMX tokens that have been converted to GMX will be claimed and remain as GMX tokens.<3/><4/>To claim GMX tokens without withdrawing, use the \"Claim\" button under the Total Rewards section.<5/><6/></0>"
msgstr "<0>This will withdraw and unreserve all tokens as well as pause vesting.<1/><2/>esGMX tokens that have been converted to GMX will be claimed and remain as GMX tokens.<3/><4/>To claim GMX tokens without withdrawing, use the \"Claim\" button under the Total Rewards section.<5/><6/></0>"

#: src/pages/OrdersOverview/OrdersOverview.jsx
msgid "Price conditions are met"
msgstr "Price conditions are met"

#: src/pages/PoolsDetails/PoolsDetails.tsx
msgid "Backing Composition"
msgstr "Backing Composition"

#: src/pages/Ecosystem/ecosystemConstants.tsx
msgid "DeBank"
msgstr "DeBank"

#: src/components/OldSubaccountWithdraw/OldSubaccountWithdraw.tsx
msgid "You have {balanceFormatted} remaining in your old version 1CT subaccount."
msgstr "You have {balanceFormatted} remaining in your old version 1CT subaccount."

#: src/pages/Stake/GmxAndVotingPowerCard.tsx
msgid "Unstake GMX"
msgstr "Unstake GMX"

#: src/pages/Stake/VesterDepositModal.tsx
msgid "Deposit failed!"
msgstr "Deposit failed!"
